export const HSK = [
    [
      "一贯",
      "一貫",
      "yíguàn",
      "consistent; constant; from start to finish; then as now"
    ],
    ["多少", "多少", "duōshao", "how much; how many"],
    ["工厂", "工厂", "gōngchǎng", "factory"],
    ["有名", "有名", "yǒumíng", "famous; well-known"],
    ["太太", "太太", "tàitai", "wife; title for married woman; Mrs.; Madame"],
    ["大小", "大小", "dàxiǎo", "size; dimension"],
    ["光明", "光明", "guāngmíng", "bright (future); promising; illuminate"],
    ["孙子", "孫子", "sūnzi", "grandson; Sun Zi (Chinese philosopher)"],
    ["好奇", "好奇", "hàoqí", "curious"],
    ["少女", "少女", "shàonv3", "maiden; young girl"],
    ["孙女", "孫女", "sūnnv3", "granddaughter"],
    ["大哥", "大哥", "dàgē", "eldest brother"],
    ["目光", "目光", "mùguāng", "sight; vision; view"],
    ["月光", "月光", "yuèguāng", "moonlight"],
    ["尖子", "尖子", "jiānzi", "best of its kind; cream of the crop"],
    ["大大", "大大", "dàdà", "great; significantly; enormously"],
    [
      "子孙",
      "子孫",
      "zǐsūn",
      "children and grandchildren; offspring; progeny; posterity; descendants"
    ],
    [
      "大多",
      "大多",
      "dàduō",
      "for the most part; many; most; mostly; the greater part"
    ],
    ["奇妙", "奇妙", "qímiào", "wonderful; fantastic"],
    ["日光", "日光", "rìguāng", "sunlight"],
    ["小子", "小子", "xiǎozi", "boy; young fellow; (derogatory) chap"],
    ["好多", "好多", "hǎoduō", "many; quite a lot"],
    ["一点儿", "一點兒", "yìdiǎnr5", "a bit; a few; a little"],
    ["小时", "小時", "xiǎoshí", "hour"],
    ["活儿", "活兒", "huór5", "(colloquial) work; lots of things to do"],
    ["肚子", "肚子", "dùzi", "belly; abdomen; stomach"],
    ["原则", "原則", "yuánzé", "principle; doctrine"],
    ["消灭", "消滅", "xiāomiè", "eliminate; perish; wipe out"],
    ["有时", "有時", "yǒushí", "sometimes; now and then; at times"],
    [
      "一时",
      "一時",
      "yìshí",
      "short period of time; temporary; for the moment"
    ],
    ["有点儿", "有點兒", "yǒudiǎnr5", "a little; some; rather; a bit"],
    [
      "有一点儿",
      "有一點兒",
      "yǒuyìdiǎnr5",
      "a little; some; rather; a little"
    ],
    ["沙子", "沙子", "shāzi", "sand; grit"],
    ["时时", "時時", "shíshí", "often; constantly; all the time"],
    ["原子", "原子", "yuánzǐ", "atom; atomic"],
    ["尘土", "塵土", "chéntǔ", "dust"],
    [
      "均匀",
      "均勻",
      "jūnyún",
      "even; well-distributed; homogeneous; well-proportioned (body)"
    ],
    ["灯火", "燈火", "dēnghuǒ", "lights"],
    ["灰尘", "灰塵", "huīchén", "dust; dirt"],
    ["中原", "中原", "zhōngyuán", "the central plains of China"],
    ["早点", "早點", "zǎodiǎn", "light breakfast; earlier"],
    [
      "淡水",
      "淡水",
      "dànshuǐ",
      "fresh water; potable water (water with low salt content)"
    ],
    ["沙土", "沙土", "shātǔ", "sandy soil"],
    ["石灰", "石灰", "shíhuī", "lime (calcium oxide)"],
    ["照明", "照明", "zhàomíng", "lighting; illumination supplied by lights"],
    ["点明", "點明", "diǎnmíng", "point out; make clear"],
    [
      "水土",
      "水土",
      "shuǐtǔ",
      "water and soil; surface water; natural environment; climate"
    ],
    ["点子", "點子", "diǎnzi", "idea; spot; dot; speck; drop (of a liquid)"],
    [
      "水源",
      "水源",
      "shuǐyuán",
      "water source; water supply; headwaters; headspring"
    ],
    ["顶点", "頂點", "dǐngdiǎn", "summit; peak"],
    ["告状", "告狀", "gào zhuàng", "sue; lodge a complaint (to a superior)"],
    ["默默", "默默", "mòmò", "in silence; not speaking"],
    [
      "查获",
      "查獲",
      "cháhuò",
      "investigate and capture (a criminal); ferret out"
    ],
    ["原告", "原告", "yuángào", "plaintiff; complainant; accuser"],
    ["器具", "器具", "qìjù", "implement; ware"],
    ["世界", "世界", "shìjiè", "world"],
    ["完全", "完全", "wánquán", "complete; whole; totally"],
    ["点钟", "點鐘", "diǎnzhōng", "o'clock"],
    ["玩儿", "玩兒", "wánr5", "to play; have fun"],
    ["月球", "月球", "yuèqiú", "the moon"],
    ["哈哈", "哈哈", "hāhā", "(an onomatopoeia for laughing)"],
    ["安全", "安全", "ānquán", "safe; safety; secure; security"],
    ["合理", "合理", "hélǐ", "rational; reasonable; equitable"],
    ["个子", "個子", "gèzi", "height; stature; build"],
    ["合同", "合同", "hétong5", "contract"],
    ["真理", "真理", "zhēnlǐ", "truth"],
    ["好玩儿", "好玩兒", "hǎowánr5", "amusing; fun; interesting; delightful"],
    ["茶叶", "茶葉", "cháyè", "tea leaves"],
    ["合唱", "合唱", "héchàng", "sing in chorus; a chorus"],
    ["金鱼", "金魚", "jīnyú", "goldfish"],
    ["个儿", "個兒", "gèr5", "stature; size; height"],
    ["钉子", "釘子", "dīngzi", "nail; snag"],
    ["自主", "自主", "zìzhǔ", "independent; to act for oneself; autonomous"],
    ["宝石", "寶石", "bǎoshí", "precious stone; gem"],
    ["原理", "原理", "yuánlǐ", "principle; theory"],
    ["镇压", "鎮壓", "zhènyā", "suppress; suppression; crack down"],
    ["合金", "合金", "héjīn", "alloy"],
    ["外界", "外界", "wàijiè", "the external world; outside"],
    ["现金", "現金", "xiànjīn", "cash"],
    ["玩具", "玩具", "wánjù", "plaything; toy"],
    ["现状", "現狀", "xiànzhuàng", "current situation; status quo"],
    ["大理石", "大理石", "dàlǐshí", "marble"],
    ["钟点", "鐘點", "zhōngdiǎn", "hour; specified time"],
    ["注目", "注目", "zhùmù", "focus; pay attention; stare at; gaze at"],
    ["宝贝", "寶貝", "bǎobèi", "baby; darling; treasured thing"],
    ["呈现", "呈現", "chéngxiàn", "appear; emerge; present"],
    ["目前", "目前", "mùqián", "at present; now; for the moment"],
    ["道理", "道理", "dàoli", "reason; sense; argument"],
    ["好处", "好處", "hǎochu", "benefit; advantage"],
    ["火车", "火車", "huǒchē", "train"],
    ["永远", "永遠", "yǒngyuǎn", "forever; eternal; always"],
    ["卡车", "卡車", "kǎchē", "truck"],
    [
      "合适",
      "合適",
      "héshì",
      "suitable; proper; appropriate; to fit (clothes)"
    ],
    [
      "处理",
      "處理",
      "chǔlǐ",
      "deal with; to handle; dispose of; to process; sell at a discount; punish"
    ],
    ["适合", "適合", "shìhé", "to suit; to fit"],
    ["味道", "味道", "wèidao", "flavor; taste; interest; odour; smell"],
    ["具备", "具備", "jùbèi", "possess; be equipped with"],
    ["造句", "造句", "zào jù", "make a sentence"],
    ["一道", "一道", "yídào", "together; alongside"],
    ["客厅", "客廳", "kètīng", "living room; parlor"],
    ["或多或少", "或多或少", "huò duō huò shǎo", "more or less"],
    ["工钱", "工錢", "gōngqián", "salary; wages"],
    ["合成", "合成", "héchéng", "compound; synthesis; mixture; to photoshop"],
    ["战略", "戰略", "zhànlvè", "strategy; strategic"],
    ["口试", "口試", "kǒushì", "oral exam; oral test"],
    ["城镇", "城鎮", "chéngzhèn", "cities and towns; city; town"],
    ["模式", "模式", "móshì", "model; pattern; method; mode"],
    ["金钱", "金錢", "jīnqián", "money; currency"],
    ["格式", "格式", "géshì", "form; specification; format"],
    ["本钱", "本錢", "běnqián", "capital (financial)"],
    ["成品", "成品", "chéngpǐn", "finished product; end product"],
    ["现钱", "現錢", "xiànqián", "cash"],
    [
      "落成",
      "落成",
      "luòchéng",
      "(of a building, construction project, etc.) to be completed"
    ],
    ["高烧", "高燒", "gāoshāo", "burning heat; temperature"],
    ["真诚", "真誠", "zhēnchéng", "sincere; true; genuine"],
    [
      "一定",
      "一定",
      "yídìng",
      "must be; surely; certainly; necessarily; definite"
    ],
    ["可是", "可是", "kěshì", "but; however"],
    ["真正", "真正", "zhēnzhèng", "genuine; real; true"],
    ["就是", "就是", "jiùshì", "exactly so; be exactly"],
    ["肯定", "肯定", "kěndìng", "sure; definite; affirm; approve"],
    [
      "正好",
      "正好",
      "zhènghǎo",
      "just (in time); just right; just enough; happen to; by chance"
    ],
    ["正式", "正式", "zhèngshì", "formal; official"],
    ["超过", "超過", "chāoguò", "surpass; exceed; outstrip"],
    [
      "证明",
      "證明",
      "zhèngmíng",
      "prove; testify; confirm the truth of; identification; certificate"
    ],
    ["只是", "只是", "zhǐshì", "only; merely; but"],
    ["题目", "題目", "tímù", "subject; title; topic"],
    ["封建", "封建", "fēngjiàn", "feudal; feudalism"],
    ["有的是", "有的是", "yǒudeshì", "have plenty of; there's no lack of"],
    ["武器", "武器", "wǔqì", "weapon; arms"],
    ["走道", "走道", "zǒudào", "sidewalk; pavement; path; aisle"],
    ["是的", "是的", "shìde", "yes; that's it; right"],
    [
      "安定",
      "安定",
      "āndìng",
      "stable; quiet; settled; stabilize; calm and orderly"
    ],
    ["凡是", "凡是", "fánshì", "every; any; all; without exception"],
    ["建造", "建造", "jiànzào", "construct; to build; make"],
    ["超额", "超額", "chāo'é", "over quota"],
    ["真是", "真是", "zhēn shi", "it is truly; really; what a shame"],
    ["主题", "主題", "zhǔtí", "theme; subject; topic"],
    ["话题", "話題", "huàtí", "subject (of a talk or conversation)"],
    ["让步", "讓步", "ràngbù", "give in; concede; yield"],
    ["正月", "正月", "zhēngyuè", "the first month of the lunar calendar"],
    [
      "定点",
      "定點",
      "dìng diǎn",
      "fixed point or location; point of reference"
    ],
    [
      "定量",
      "定量",
      "dìngliàng",
      "fixed amount/quantity; ration; to determine the amounts of the components in a substance"
    ],
    ["步子", "步子", "bùzi", "to step; pace"],
    ["定理", "定理", "dìnglǐ", "an established theory; (math) theorem"],
    [
      "定向",
      "定向",
      "dìngxiàng",
      "determine the direction; a prior decision as to the direction of one's work"
    ],
    ["镇定", "鎮定", "zhèndìng", "calm; unperturbed"],
    ["超越", "超越", "chāoyuè", "surpass; exceed; transcend"],
    ["同步", "同步", "tóngbù", "synchronous; simultaneous"],
    ["定额", "定額", "dìng'é", "fixed amount; quota; ration"],
    ["逃走", "逃走", "táozǒu", "escape; to flee"],
    ["一一", "一一", "yīyī", "one by one; one after another"],
    ["明明", "明明", "míngmíng", "obviously; plainly; undoubtedly"],
    [
      "一旦",
      "一旦",
      "yídàn",
      "in case (something happens); once (sth. has happened ... then); in one day"
    ],
    ["早日", "早日", "zǎorì", "early; soon; shortly; on a day quite soon"],
    ["早上", "早上", "zǎoshang5", "(early) morning"],
    ["明白", "明白", "míngbai", "clear; obvious; understand; explicit"],
    ["上升", "上升", "shàngshēng", "to rise; go up; ascend"],
    ["白白", "白白", "báibái", "in vain; for nothing"],
    ["上下", "上下", "shàngxià", "up and down; top and bottom; old and young"],
    ["自古", "自古", "zì gǔ", "(since) ancient times; (from) time immemorial"],
    ["一下儿", "一下兒", "yíxiàr5", "a little bit/while; one time; once"],
    ["千万", "千萬", "qiānwàn", "ten million; be sure to; must"],
    ["目的", "目的", "mùdì", "purpose; aim; goal"],
    ["日元", "日元", "Rìyuán", "Japanese yen"],
    ["万一", "萬一", "wànyī", "just in case; if by any chance"],
    ["元旦", "元旦", "yuándàn", "New Year's Day (Western calendar)"],
    ["万万", "萬萬", "wànwàn", "absolutely; wholly; hundred million"],
    ["中旬", "中旬", "zhōngxún", "middle third of a month"],
    ["下旬", "下旬", "xiàxún", "last third of the month"],
    ["上旬", "上旬", "shàngxún", "first third of a month"],
    ["元首", "元首", "yuánshǒu", "head of state"],
    [
      "一直",
      "一直",
      "yìzhí",
      "always; all along; straight (in a straight line); from the beginning"
    ],
    ["一切", "一切", "yíqiè", "all; every; everything"],
    ["哥哥", "哥哥", "gēge", "older brother"],
    ["有的", "有的", "yǒude", "some (exist); (there are) some (who/that are)"],
    ["左右", "左右", "zuǒyòu", "about; approximate; around; left and right"],
    ["只有", "只有", "zhǐyǒu", "only; only if; can only"],
    ["项目", "項目", "xiàngmù", "item; project; (sports) event"],
    ["工具", "工具", "gōngjù", "tool; instrument; means"],
    ["具有", "具有", "jùyǒu", "have; possess (a quality or ability)"],
    ["可见", "可見", "kějiàn", "it can clearly be seen that; clear"],
    ["占有", "占有", "zhànyǒu", "have; own; possess; hold; capture; occupy"],
    [
      "刀刃",
      "刀刃",
      "dāorèn",
      "the edge of a knife; where a thing can be put to best use; the crucial point"
    ],
    ["可口", "可口", "kěkǒu", "tasty; taste good"],
    ["儿子", "兒子", "érzi", "son"],
    ["日子", "日子", "rìzi", "days; date; time; life; days of one's life"],
    ["女儿", "女兒", "nv3'ér", "daughter"],
    ["只好", "只好", "zhǐhǎo", "have to; be forced to; have no choice but to"],
    ["句子", "句子", "jùzi", "sentence"],
    [
      "一下子",
      "一下子",
      "yíxiàzi",
      "(indicates doing sth. a short duration or just once); once; one time; a short while; all at once"
    ],
    ["叶子", "葉子", "yèzi", "leaves"],
    [
      "好好儿",
      "好好兒",
      "hǎohāor5",
      "in a proper way; to one's heart's content; well"
    ],
    ["刀子", "刀子", "dāozi", "knife"],
    ["胡子", "胡子", "húzi", "beard; mustache; facial hair"],
    ["胡乱", "胡亂", "húluàn", "carelessly; recklessly; casually; at random"],
    ["勺子", "勺子", "sháozi", "spoon; scoop; ladle"],
    ["女子", "女子", "nv3zǐ", "woman; a female"],
    ["儿女", "兒女", "érnv3", "children; sons and daughters"],
    ["千克", "千克", "qiānkè", "1000 grams"],
    ["如下", "如下", "rú xià", "as follows"],
    ["选定", "選定", "xuǎndìng", "designate; select; choose"],
    ["涉外", "涉外", "shèwài", "concerning foreigners or foreign affairs"],
    [
      "卓越",
      "卓越",
      "zhuóyuè",
      "outstanding; brilliant; remarkable; distinguished"
    ],
    ["高超", "高超", "gāochāo", "excellent; superb"],
    ["越过", "越過", "yuèguò", "get across; rise above; overcome; exceed"],
    ["特定", "特定", "tèdìng", "special; specific; designated"],
    [
      "真是的",
      "真是的",
      "zhēn shì de",
      "(idiom) It really is? (expressing dissatisfaction)"
    ],
    ["走向", "走向", "zǒuxiàng", "trend; trending towards; headed for"],
    ["测定", "測定", "cèdìng", "survey; measure; evaluate; measurement"],
    ["或是", "或是", "huòshì", "or; either one or the other"],
    [
      "走狗",
      "走狗",
      "zǒugǒu",
      "(literally) running dog; a lackey; a person who helps someone harm people"
    ],
    ["一些", "一些", "yìxiē", "some; a few; a little; a number of; certain"],
    ["城市", "城市", "chéngshì", "city or town"],
    ["明天", "明天", "míngtiān", "tomorrow"],
    ["讨论", "討論", "tǎolùn", "discuss; talk over"],
    ["农村", "農村", "nóngcūn", "rural area; village; countryside"],
    ["复杂", "復雜", "fùzá", "complicated; complex"],
    ["夏天", "夏天", "xiàtiān", "summer"],
    ["冬天", "冬天", "dōngtiān", "winter"],
    ["有些", "有些", "yǒuxiē", "some; somewhat; rather"],
    ["帽子", "帽子", "màozi", "hat; cap"],
    ["车站", "車站", "chēzhàn", "(bus, train, etc.) stop; station"],
    ["好吃", "好吃", "hǎochī", "tasty; tastes good"],
    ["有一些", "有一些", "yǒuyìxiē", "some; somewhat; rather; have a little"],
    ["比如", "比如", "bǐrú", "for example; for instance; such as"],
    ["儿童", "兒童", "értóng", "child; children"],
    ["建立", "建立", "jiànlì", "establish; to construct; to set up"],
    ["减少", "減少", "jiǎnshǎo", "reduce; to decrease"],
    ["白天", "白天", "báitiān", "daytime; during the day; day"],
    ["商品", "商品", "shāngpǐn", "goods; commodity; merchandise"],
    ["成立", "成立", "chénglì", "establish; to found; to set up"],
    ["资源", "資源", "zīyuán", "natural resource; resource"],
    ["工资", "工資", "gōngzī", "wages; pay; earnings; salary"],
    ["前天", "前天", "qiántiān", "the day before yesterday"],
    ["商量", "商量", "shāngliang5", "consult; talk over; discuss"],
    ["宣布", "宣布", "xuānbù", "announce; declare; proclaim"],
    ["制造", "制造", "zhìzào", "manufacture; make"],
    ["状况", "狀況", "zhuàngkuàng", "condition; state; situation"],
    ["理论", "理論", "lǐlùn", "theory"],
    ["此外", "此外", "cǐwài", "besides; in addition; moreover"],
    ["皇帝", "皇帝", "huángdì", "emperor"],
    ["洗衣机", "洗衣機", "xǐyījī", "washing machine; washer"],
    ["大衣", "大衣", "dàyī", "overcoat; cloak"],
    ["天真", "天真", "tiānzhēn", "naïve; innocent; artless"],
    ["上衣", "上衣", "shàngyī", "upper garment; jacket; coat"],
    ["狮子", "獅子", "shīzi", "lion"],
    ["雨衣", "雨衣", "yǔyī", "raincoat"],
    ["衬衣", "襯衣", "chènyī", "shirt"],
    [
      "特此",
      "特此",
      "tècǐ",
      "{adverb} (used in a document or formal letter) hereby"
    ],
    ["初步", "初步", "chūbù", "initial; preliminary; tentative"],
    ["四周", "四周", "sìzhōu", "all around; all sides"],
    ["高尚", "高尚", "gāoshàng", "noble; lofty"],
    ["享有", "享有", "xiǎngyǒu", "enjoy (rights, privileges, etc.)"],
    ["高明", "高明", "gāomíng", "brilliant; smart; better qualified"],
    ["远景", "遠景", "yuǎnjǐng", "prospect; long-range view; future"],
    ["光亮", "光亮", "guāngliàng", "bright; shiny"],
    ["前景", "前景", "qiánjǐng", "outlook; future (prospects); foreground"],
    ["亮光", "亮光", "liàngguāng", "light; beam of light"],
    ["大学", "大學", "dàxué", "university; college"],
    ["同学", "同學", "tóngxué", "fellow student; schoolmate"],
    ["上学", "上學", "shàng xué", "go to school"],
    ["中学", "中學", "zhōngxué", "middle/high school"],
    ["外语", "外語", "wàiyǔ", "foreign language"],
    ["语言", "語言", "yǔyán", "language"],
    ["口语", "口語", "kǒuyǔ", "spoken language; colloquial speech"],
    ["日语", "日語", "Rìyǔ", "Japanese (language)"],
    ["小学", "小學", "xiǎoxué", "primary school; elementary school"],
    [
      "调查",
      "調查",
      "diàochá",
      "investigation; inquiry; to investigate; to survey; survey"
    ],
    ["讨厌", "討厭", "tǎoyàn", "to hate; loathe; disgusting; troublesome"],
    ["谈话", "談話", "tán huà", "to talk; to chat; conversation"],
    ["自觉", "自覺", "zìjué", "be conscious; be aware of; self-motivated"],
    ["的话", "的話", "dehuà", "if (following conditional clause)"],
    ["语调", "語調", "yǔdiào", "intonation; tone"],
    ["自学", "自學", "zìxué", "self-study; study independently"],
    ["警告", "警告", "jǐnggào", "warn; admonish"],
    ["自言自语", "自言自語", "zì yán zì yǔ", "talk to oneself; soliloquize"],
    ["学时", "學時", "xuéshí", "class hour; period"],
    ["攻克", "攻克", "gōngkè", "to capture; to take; overcome"],
    ["宣言", "宣言", "xuānyán", "declaration; manifesto; declare; proclaim"],
    [
      "学员",
      "學員",
      "xuéyuán",
      "student (usu. of a college or training course); member of an institution of learning; trainee; officer cadet"
    ],
    ["升学", "升學", "shēng xué", "enter the next higher school; graduate"],
    [
      "见识",
      "見識",
      "jiànshi",
      "widen one's knowledge; enrich one's experience; knowledge and experience; sensibleness"
    ],
    ["宽敞", "寬敞", "kuānchang5", "spacious; commodious"],
    ["活计", "活計", "huójì", "handicrafts; needlework; work"],
    ["言语", "言語", "yányǔ", "words; speech; (spoken) language"],
    ["救灾", "救災", "jiù zāi", "provide disaster relief"],
    ["相识", "相識", "xiāngshí", "acquaintance; be acquainted with each other"],
    ["计划", "計划", "jìhuà", "plan; project"],
    ["完成", "完成", "wánchéng", "to complete; accomplish; fulfill"],
    ["成就", "成就", "chéngjiù", "accomplishment; achievement; success"],
    ["成熟", "成熟", "chéngshú", "mature; ripe"],
    ["战士", "戰士", "zhànshì", "soldier; fighter; warrior"],
    ["达成", "達成", "dá chéng", "to reach (an agreement); achieve"],
    ["成员", "成員", "chéngyuán", "member"],
    ["成本", "成本", "chéngběn", "cost (manufacturing, production, etc.)"],
    [
      "成千上万",
      "成千上萬",
      "chéng qiān shàng wàn",
      "thousands upon thousands; untold numbers of"
    ],
    ["测试", "測試", "cèshì", "test; trial; examine; beta (software)"],
    ["现成", "現成", "xiànchéng", "ready-made; off-the-shelf"],
    ["成语", "成語", "chéngyǔ", "idiom; proverb"],
    ["照旧", "照舊", "zhàojiù", "as before; as usual; as of old"],
    ["时光", "時光", "shíguāng", "time; era; period of time"],
    ["源泉", "源泉", "yuánquán", "headspring; fountainhead; water source"],
    [
      "点火",
      "點火",
      "diǎn huǒ",
      "ignite; light a fire; agitate; stir up trouble"
    ],
    ["同时", "同時", "tóngshí", "at the same time; simultaneously"],
    ["名字", "名字", "míngzi", "a name"],
    ["大量", "大量", "dàliàng", "great amount; large quantity"],
    ["墨水", "墨水", "mòshuǐ", "ink"],
    ["一同", "一同", "yītóng", "together; along; at the same time and place"],
    [
      "一向",
      "一向",
      "yíxiàng",
      "all along; the whole time; constantly; always"
    ],
    [
      "胡同",
      "胡同",
      "hútòng",
      "lane; alley (also with a neutral tone on the second syllable)"
    ],
    ["如同", "如同", "rútóng", "like; similar to"],
    [
      "元宵",
      "元宵",
      "yuánxiāo",
      "Lantern Festival; sweet, sticky rice dumplings made for Lantern Festival"
    ],
    ["富有", "富有", "fùyǒu", "rich; affluent; be rich in; be full of"],
    ["测量", "測量", "cèliáng", "to survey; to measure"],
    ["字母", "字母", "zìmǔ", "letter (of the alphabet)"],
    ["火灾", "火災", "huǒzāi", "fire (disaster)"],
    ["黑白", "黑白", "hēibái", "black and white; right and wrong"],
    ["同一", "同一", "tóngyī", "identical; the same"],
    ["少量", "少量", "shǎoliàng", "a little bit; very few"],
    [
      "安置",
      "安置",
      "ānzhì",
      "find a place for; help settle down; arrange for"
    ],
    ["水灾", "水災", "shuǐzāi", "flood"],
    ["飞机", "飛機", "fēijī", "airplane"],
    ["妹妹", "妹妹", "mèimei", "younger sister"],
    ["照相", "照相", "zhào xiàng", "to take a photograph"],
    ["桌子", "桌子", "zhuōzi", "tables; desks"],
    ["本子", "本子", "běnzi", "book; notebook; edition"],
    ["草原", "草原", "cǎoyuán", "grassland; prairie"],
    ["沙漠", "沙漠", "shāmò", "desert"],
    ["森林", "森林", "sēnlín", "forest"],
    ["相同", "相同", "xiāngtóng", "identical; same; alike"],
    ["工艺品", "工藝品", "gōngyìpǐn", "handicraft; handiwork"],
    ["照相机", "照相機", "zhàoxiàngjī", "camera"],
    ["村子", "村子", "cūnzi", "village; hamlet"],
    ["时机", "時機", "shíjī", "opportune time; opportunity"],
    ["有机", "有機", "yǒujī", "organic"],
    ["草案", "草案", "cǎo'àn", "draft (legislation, proposal, etc.)"],
    [
      "真相",
      "真相",
      "zhēnxiàng",
      "the real (or true) situation; the actual facts; truth"
    ],
    ["宽大", "寬大", "kuāndà", "spacious; wide; lenient"],
    ["首相", "首相", "shǒuxiàng", "prime minister"],
    ["杂乱", "雜亂", "záluàn", "a mess; disorderly"],
    [
      "查明",
      "查明",
      "chámíng",
      "investigate and bring out into the open; ascertain"
    ],
    ["机器", "機器", "jīqì", "machine; machinery; apparatus"],
    [
      "自然",
      "自然",
      "zìrán",
      "natural world; natural sciences; natural; normal; ordinary; of course; naturally"
    ],
    ["首先", "首先", "shǒuxiān", "first (of all); in the first place; firstly"],
    ["特点", "特點", "tèdiǎn", "a characteristic; trait; feature"],
    ["大自然", "大自然", "dàzìrán", "nature (as in Mother Nature)"],
    ["宣告", "宣告", "xuāngào", "to declare; to proclaim; to pronounce"],
    ["原先", "原先", "yuánxiān", "former; original"],
    ["奇特", "奇特", "qítè", "peculiar; queer; strange"],
    ["完备", "完備", "wánbèi", "complete; perfect"],
    ["处处", "處處", "chùchù", "everywhere; in all respects"],
    [
      "四处",
      "四處",
      "sìchù",
      "all around; all over the place; everywhere and all directions"
    ],
    ["直达", "直達", "zhídá", "nonstop; direct"],
    ["格外", "格外", "géwài", "especially; additionally"],
    ["一连", "一連", "yìlián", "in a row; in succession; running"],
    ["合格", "合格", "hégé", "qualified; up to standard"],
    ["大道", "大道", "dàdào", "main street; thoroughfare"],
    ["各自", "各自", "gèzì", "each; respective; apiece"],
    ["条子", "條子", "tiáozi", "a short note; a slip of paper"],
    ["各界", "各界", "gèjiè", "all walks of life; all social circles"],
    ["条理", "條理", "tiáolǐ", "consecutive; arrangement; orderliness"],
    ["额外", "額外", "éwài", "extra; added; additional"],
    ["省略", "省略", "shěnglvè", "omit; leave out; abbreviate"],
    ["剪刀", "剪刀", "jiǎndāo", "scissors"],
    ["连同", "連同", "liántóng", "together with; along with"],
    ["客车", "客車", "kèchē", "coach; passenger car"],
    ["名额", "名額", "míng'é", "particular number of people; quota"],
    ["先前", "先前", "xiānqián", "before; previously"],
    ["下落", "下落", "xiàluò", "whereabouts"],
    ["查处", "查處", "cháchǔ", "investigate and take care of"],
    ["莲子", "蓮子", "liánzǐ", "lotus seed"],
    ["河道", "河道", "hédào", "the course of a river; watercourse"],
    ["连连", "連連", "liánlián", "repeatedly; again and again"],
    ["金额", "金額", "jīn'é", "monetary sum; monetary value"],
    ["落选", "落選", "luò xuǎn", "lose an election"],
    [
      "处置",
      "處置",
      "chǔzhì",
      "to handle; deal with; take care of;  manage; punish; dispose of"
    ],
    ["好客", "好客", "hàokè", "hospitable; enjoy having guests"],
    ["远大", "遠大", "yuǎndà", "forward looking and ambitious"],
    ["下达", "下達", "xiàdá", "transmit to lower level people"],
    ["机车", "機車", "jīchē", "locomotive; train engine car; motorcycle"],
    ["月亮", "月亮", "yuèliang5", "the moon"],
    ["冠军", "冠軍", "guànjūn", "champion"],
    ["女士", "女士", "nv3shì", "lady; madam"],
    ["高原", "高原", "gāoyuán", "plateau; highland"],
    ["沉默", "沉默", "chénmò", "silent; uncommunicative"],
    ["光辉", "光輝", "guānghuī", "radiance; brilliance; glory"],
    ["明亮", "明亮", "míngliàng", "well-lit; bright; shining; become clear"],
    ["高大", "高大", "gāodà", "tall; big; lofty"],
    ["周末", "周末", "zhōumò", "weekend"],
    ["高中", "高中", "gāozhōng", "high school; senior high school"],
    ["将军", "將軍", "jiāngjūn", "a general (military officer)"],
    ["壮丽", "壯麗", "zhuànglì", "magnificence; splendid; majestic"],
    ["亭子", "亭子", "tíngzi", "pavilion; kiosk"],
    ["壮大", "壯大", "zhuàngdà", "expand; grow in strength"],
    ["辉煌", "輝煌", "huīhuáng", "splendid; glorious"],
    ["响亮", "響亮", "xiǎngliàng", "loud and clear; resounding"],
    ["高压", "高壓", "gāoyā", "high pressure; high-handed"],
    ["军备", "軍備", "jūnbèi", "armaments; (military) arms"],
    [
      "高潮",
      "高潮",
      "gāocháo",
      "high tide; upsurge; climax; chorus (of a song); orgasm"
    ],
    ["棉衣", "棉衣", "miányī", "cotton-padded clothes"],
    ["布置", "布置", "bùzhì", "arrange; lay out; decorate; assign"],
    ["好些", "好些", "hǎoxiē", "a good deal of; quite a lot"],
    ["运输", "運輸", "yùnshū", "transport; transportation"],
    [
      "制定",
      "制定",
      "zhìdìng",
      "(of a policy or standard) formulate; enact; adopt; set out or forth"
    ],
    ["初中", "初中", "chūzhōng", "junior high school; middle school"],
    ["如此", "如此", "rúcǐ", "in this way; so; such; like that"],
    ["背景", "背景", "bèijǐng", "background"],
    [
      "天下",
      "天下",
      "tiānxià",
      "land under heaven; the whole world; domination"
    ],
    ["混乱", "混亂", "hùnluàn", "confusion; disorder; chaotic"],
    ["农田", "農田", "nóngtián", "farmland"],
    ["制止", "制止", "zhìzhǐ", "to curb; to put a stop to"],
    ["吃苦", "吃苦", "chī kǔ", "bear hardships; suffer"],
    ["复制", "復制", "fùzhì", "duplicate; reproduce; copy"],
    ["带儿", "帶兒", "dàir5", "belt; strap; ribbon"],
    ["谈论", "談論", "tánlùn", "discuss; talk about"],
    ["农具", "農具", "nóngjù", "farm implements; farm tools"],
    ["布告", "布告", "bùgào", "notice; bulletin"],
    ["资金", "資金", "zījīn", "funds; funding"],
    ["歌唱", "歌唱", "gēchàng", "sing; praise through singing"],
    ["天上", "天上", "tiānshàng", "the sky; the heavens"],
    [
      "上帝",
      "上帝",
      "Shàngdì",
      "the Lord on High (ancient China); God (Western)"
    ],
    ["外衣", "外衣", "wàiyī", "outerwear; semblance; appearance"],
    ["成天", "成天", "chéngtiān", "all day long; all the time"],
    ["轮子", "輪子", "lúnzi", "wheel"],
    ["好比", "好比", "hǎobǐ", "be just like; can be compared to"],
    ["装备", "裝備", "zhuāngbèi", "equipment; to equip; to outfit"],
    ["资格", "資格", "zīgé", "qualifications; seniority"],
    ["压制", "壓制", "yāzhì", "suppress; inhibit; stifle"],
    [
      "一带",
      "一帶",
      "yídài",
      "region; district; the area around a particular place; area; surroundings"
    ],
    ["凉水", "涼水", "liángshuǐ", "cold water; unboiled water"],
    [
      "装置",
      "裝置",
      "zhuāngzhì",
      "to install; installation; equipment; system; unit; device"
    ],
    ["海军", "海軍", "hǎijūn", "navy"],
    ["武装", "武裝", "wǔzhuāng", "arms; equipment; to arm"],
    ["天然", "天然", "tiānrán", "natural; naturally-formed"],
    ["资本", "資本", "zīběn", "(economics) capital; asset"],
    ["混合", "混合", "hùnhé", "to mix; to blend"],
    ["学制", "學制", "xuézhì", "educational system; length of schooling"],
    ["安装", "安裝", "ānzhuāng", "install; erect; to fix; to mount"],
    [
      "合资",
      "合資",
      "hézī",
      "to pool capital; enter into a partnership or joint venture"
    ],
    ["外资", "外資", "wàizī", "foreign capital/investment"],
    ["海外", "海外", "hǎiwài", "overseas; abroad"],
    ["制裁", "制裁", "zhìcái", "punish; (economic) sanctions"],
    ["相比", "相比", "xiāngbǐ", "compare; by comparison; in comparison with"],
    ["言论", "言論", "yánlùn", "expression of (political) opinion; speech"],
    [
      "竞选",
      "競選",
      "jìngxuǎn",
      "run for (electoral) office; take part in an election"
    ],
    ["诗歌", "詩歌", "shīgē", "poems and songs"],
    ["吹牛", "吹牛", "chuī niú", "to brag; (regional) to chat"],
    [
      "时装",
      "時裝",
      "shízhuāng",
      "the latest fashion in clothes; fashionable; contemporary costume"
    ],
    ["军装", "軍裝", "jūnzhuāng", "army uniform"],
    ["消息", "消息", "xiāoxi", "news; information; message"],
    ["总是", "總是", "zǒngshì", "always; eventually"],
    ["思想", "思想", "sīxiǎng", "thought; thinking; idea; ideology"],
    [
      "习惯",
      "習慣",
      "xíguàn",
      "habit; usual practice; it's my habit to...; make it a habit..."
    ],
    ["同志", "同志", "tóngzhì", "comrade; gay person (slang)"],
    ["商店", "商店", "shāngdiàn", "shop; store"],
    ["感冒", "感冒", "gǎnmào", "catch cold; (common) cold"],
    ["主意", "主意", "zhǔyi", "plan; idea; decision"],
    ["点心", "點心", "diǎnxin5", "dim sum; light refreshments; snacks"],
    ["起床", "起床", "qǐ chuáng", "get up; get out of bed"],
    ["有意思", "有意思", "yǒuyìsi", "interesting; meaningful; enjoyable; fun"],
    ["中心", "中心", "zhōngxīn", "centre; heart; core"],
    ["广告", "广告", "guǎnggào", "advertisement; a commercial"],
    ["放心", "放心", "fàngxīn", "relax; feel relieved; rest assured"],
    ["原因", "原因", "yuányīn", "cause; reason"],
    ["恐怕", "恐怕", "kǒngpà", "be afraid; to fear; I'm afraid that..."],
    [
      "因此",
      "因此",
      "yīncǐ",
      "therefore; thus; consequently; that is why; because of this"
    ],
    ["小心", "小心", "xiǎoxīn", "be careful"],
    ["总理", "總理", "zǒnglǐ", "premier"],
    ["prime minister", "", "", ""],
    [
      "理想",
      "理想",
      "lǐxiǎng",
      "a dream; an ideal; perfection; ideal; perfect; desirable"
    ],
    ["感觉", "感覺", "gǎnjué", "to feel; become aware of; feeling"],
    ["裤子", "褲子", "kùzi", "pants; trousers"],
    ["地图", "地圖", "dìtú", "map"],
    ["忘记", "忘記", "wàngjì", "forget"],
    ["状态", "狀態", "zhuàngtài", "state of affairs; condition; state"],
    ["国王", "國王", "guówáng", "king"],
    ["愿望", "願望", "yuànwàng", "desire; wish; aspiration"],
    ["必然", "必然", "bìrán", "inevitable; certain; necessary"],
    ["广大", "广大", "guǎngdà", "vast; extensive"],
    ["广场", "广場", "guǎngchǎng", "public square; plaza"],
    ["吃惊", "吃驚", "chī jīng", "be startled; be shocked; be amazed"],
    ["企图", "企圖", "qǐtú", "(to) attempt; try"],
    ["意外", "意外", "yìwài", "unexpected; accident; mishap"],
    ["安心", "安心", "ānxīn", "at ease; relieved"],
    ["可怕", "可怕", "kěpà", "terrible; awful; frightful; scary"],
    ["故意", "故意", "gùyì", "deliberately; intentional; on purpose"],
    ["感想", "感想", "gǎnxiǎng", "impressions; reflections; thoughts"],
    ["连忙", "連忙", "liánmáng", "promptly; at once; hastily"],
    ["机床", "機床", "jīchuáng", "machine tools"],
    ["意志", "意志", "yìzhì", "will; willpower; determination"],
    ["感激", "感激", "gǎnjī", "be grateful; appreciate; thankful"],
    ["杂志", "雜志", "zázhì", "magazine"],
    ["固定", "固定", "gùdìng", "fixed; regular; stable"],
    ["意识", "意識", "yìshi", "realize; consciousness; awareness; sense"],
    ["园林", "園林", "yuánlín", "gardens; park; landscape"],
    ["有意", "有意", "yǒuyì", "intend; intentionally; be interested in"],
    [
      "自愿",
      "自願",
      "zìyuàn",
      "voluntary; of one's own accord; of one's own free will"
    ],
    ["梦想", "夢想", "mèngxiǎng", "to dream of; wishful thinking; dream"],
    ["固然", "固然", "gùrán", "admittedly; it is true that; indeed"],
    ["心理", "心理", "xīnlǐ", "mental; psychological"],
    ["千方百计", "千方百計", "qiān fāng bǎi jì", "by every possible means"],
    ["前方", "前方", "qiánfāng", "the front; ahead; forward"],
    ["就是说", "就是說", "jiùshìshuō", "in other words; that is; namely"],
    ["一旁", "一旁", "yìpáng", "aside; to the side of"],
    [
      "灭亡",
      "滅亡",
      "mièwáng",
      "be destroyed; perish; exterminate; become extinct"
    ],
    ["音响", "音響", "yīnxiǎng", "speakers (electronic); acoustics; audio"],
    ["培训", "培訓", "péixùn", "cultivate; to train; training"],
    ["四方", "四方", "sìfāng", "four-way; four sided; all directions"],
    ["远方", "遠方", "yuǎnfāng", "far away; a distant location"],
    ["兑现", "兌現", "duìxiàn", "cash a check; honor a commitment"],
    ["处方", "處方", "chǔfāng", "(medical) prescription"],
    [
      "好说",
      "好說",
      "hǎo shuō",
      "you're too kind (humble); with pleasure! (indicating agreement); easy to handle"
    ],
    ["脱落", "脫落", "tuōluò", "drop off; shed; missing; to omit"],
    ["暗淡", "暗淡", "àndàn", "dim; faint; dismal; gloomy"],
    ["激光", "激光", "jīguāng", "laser"],
    [
      "暗中",
      "暗中",
      "ànzhōng",
      "in the dark; in secret; surreptitiously; on the sly"
    ],
    ["望远镜", "望遠鏡", "wàngyuǎnjìng", "binoculars; telescope"],
    ["境界", "境界", "jìngjiè", "boundary; state; realm; level"],
    ["狂妄", "狂妄", "kuángwàng", "egotistical; arrogant; brassy"],
    ["压韵", "壓韻", "yāyùn", "to rhyme (usually written 押-)"],
    ["威望", "威望", "wēiwàng", "prestige"],
    [
      "下放",
      "下放",
      "xiàfàng",
      "get transferred to a lower job position; demoted"
    ],
    ["处境", "處境", "chǔjìng", "plight; unfavorable situation"],
    ["自己", "自己", "zìjǐ", "oneself; self"],
    ["地方", "地方", "dìfang5", "place; space; room; part"],
    ["一样", "一樣", "yíyàng", "the same; alike; equal to"],
    ["准备", "准備", "zhǔnbèi", "prepare; get ready"],
    ["下午", "下午", "xiàwǔ", "afternoon"],
    ["学习", "學習", "xuéxí", "to learn; to study"],
    ["上午", "上午", "shàngwǔ", "morning (before noon)"],
    ["机场", "機場", "jīchǎng", "airport; airfield"],
    ["许多", "許多", "xǔduō", "many; a lot; much"],
    ["虽然", "雖然", "suīrán", "although; even though"],
    ["样子", "樣子", "yàngzi", "manner; air; style; appearance; looks"],
    ["大家", "大家", "dàjiā", "everyone; everybody"],
    ["一起", "一起", "yìqǐ", "together; in the same place"],
    ["中午", "中午", "zhōngwǔ", "noon; midday"],
    ["也许", "也許", "yěxǔ", "perhaps; probably; maybe"],
    ["照顾", "照顧", "zhàogu", "take care of; look after; give consideration"],
    ["复习", "復習", "fùxí", "revise; to review"],
    ["集合", "集合", "jíhé", "gather; assemble; to muster"],
    ["市场", "市場", "shìchǎng", "market"],
    ["美元", "美元", "měiyuán", "U.S. dollar"],
    ["独立", "獨立", "dúlì", "independent; independence; to stand alone"],
    ["土地", "土地", "tǔdì", "land; territory; soil"],
    ["集中", "集中", "jízhōng", "concentrate; to focus; collect"],
    ["球场", "球場", "qiúchǎng", "ball field/court; stadium"],
    ["家具", "家具", "jiājù", "furniture"],
    ["逐步", "逐步", "zhúbù", "step by step; gradually"],
    ["商场", "商場", "shāngchǎng", "market; bazaar; shopping mall"],
    ["正比", "正比", "zhèngbǐ", "in direct proportion; directly related"],
    ["哀求", "哀求", "āiqiú", "entreat; implore"],
    ["雷达", "雷達", "léidá", "radar"],
    [
      "厂商",
      "厂商",
      "chǎngshāng",
      "manufacturer; (commercial or industrial) firm"
    ],
    [
      "浓厚",
      "濃厚",
      "nónghòu",
      "dense; thick (fog, clouds, etc.); strong; pronounced; to have a strong interest in; deep; fully saturated (color)"
    ],
    ["乔装", "喬裝", "qiáozhuāng", "pretend; feign; disguise oneself"],
    ["雨水", "雨水", "yǔshuǐ", "rainwater; Rainwater (one of 24 solar terms)"],
    ["补救", "補救", "bǔjiù", "remedy; repair"],
    ["论点", "論點", "lùndiǎn", "argument; line of reasoning; thesis"],
    ["复合", "復合", "fùhé", "complex; compound; reunited"],
    ["谈天", "談天", "tán tiān", "to chat"],
    ["削减", "削減", "xuējiǎn", "cut down; reduce; lower"],
    ["连带", "連帶", "liándài", "and while; and; as well as; associated with"],
    ["次品", "次品", "cìpǐn", "defective or substandard products"],
    ["补贴", "補貼", "bǔtiē", "subsidy; allowance"],
    ["乞求", "乞求", "qǐqiú", "beg for; supplicate; implore"],
    ["复活", "復活", "fùhuó", "resurrection"],
    ["论证", "論證", "lùnzhèng", "prove a point; expound on; argumentation"],
    ["填补", "填補", "tiánbǔ", "fill a gap; fill a gap or omission"],
    ["中立", "中立", "zhōnglì", "neutral; neutrality"],
    ["制品", "制品", "zhìpǐn", "products; goods"],
    ["可歌可泣", "可歌可泣", "kě gē kě qì", "emotionally moving"],
    ["名次", "名次", "míngcì", "position in a ranking of names"],
    ["商讨", "商討", "shāngtǎo", "discuss; deliberate over"],
    ["此时", "此時", "cǐshí", "now; this moment"],
    ["越冬", "越冬", "yuè dōng", "go through the winter; hibernate"],
    ["试制", "試制", "shìzhì", "trial manufacture; try out a new product"],
    ["雷雨", "雷雨", "léiyǔ", "thunderstorm"],
    ["裁军", "裁軍", "cái jūn", "disarmament"],
    ["说明", "說明", "shuōmíng", "explain; explanation; illustrate; to show"],
    ["方向", "方向", "fāngxiàng", "direction; orientation"],
    ["方式", "方式", "fāngshì", "way; style; fashion; manner"],
    ["小说", "小說", "xiǎoshuō", "novel; fiction"],
    ["北方", "北方", "běifāng", "north; the northern part of the country"],
    ["镜子", "鏡子", "jìngzi", "mirror; (colloquial) eyeglasses"],
    ["黑暗", "黑暗", "hēi'àn", "dark; darkly; darkness"],
    ["方针", "方針", "fāngzhēn", "policy; guidelines"],
    ["立方", "立方", "lìfāng", "cube; (mw cubic units of measure)"],
    ["放大", "放大", "fàngdà", "enlarge; amplify"],
    ["方案", "方案", "fāng'àn", "plan; program (for action, etc.); proposal"],
    ["语音", "語音", "yǔyīn", "pronunciation; voice"],
    ["比方", "比方", "bǐfang5", "instance; analogy; example"],
    [
      "竟然",
      "竟然",
      "jìngrán",
      "unexpectedly; to one's surprise; go so far as to"
    ],
    [
      "刺激",
      "刺激",
      "cìjī",
      "to excite; exciting; to stimulate; to invigorate"
    ],
    ["大方", "大方", "dàfang5", "generous; easy-mannered; in good taste"],
    ["放学", "放學", "fàngxué", "dismiss from school; after school"],
    ["胡说", "胡說", "húshuō", "talk nonsense; drivel"],
    ["暗暗", "暗暗", "àn'àn", "secretly; inwardly"],
    ["学说", "學說", "xuéshuō", "theory; doctrine"],
    ["盲目", "盲目", "mángmù", "blind; blindness; aimless"],
    ["起初", "起初", "qǐchū", "at first; originally; in the beginning"],
    ["昆虫", "昆虫", "kūnchóng", "insect"],
    ["召集", "召集", "zhàojí", "convene; gather"],
    ["现场", "現場", "xiànchǎng", "scene (of event or incident); site; live"],
    ["包装", "包裝", "bāozhuāng", "to pack; package; packaging"],
    ["准则", "准則", "zhǔnzé", "principle; standard or norm; criterion"],
    ["特地", "特地", "tèdì", "specially; for a special purpose"],
    ["式样", "式樣", "shìyàng", "style; type; model"],
    ["养活", "養活", "yǎnghuo", "to support; provide for; raise animals"],
    ["十全十美", "十全十美", "shí quán shí měi", "complete and beautiful"],
    ["习题", "習題", "xítí", "school work exercises"],
    ["只顾", "只顧", "zhǐgù", "be focused on; engrossed in; single-mindedly"],
    ["沉着", "沉着", "chénzhuó", "calm and collected; not nervous"],
    ["选集", "選集", "xuǎnjí", "anthology; select works anthology"],
    [
      "独立自主",
      "獨立自主",
      "dúlì zìzhǔ",
      "(idiom) self-determination; maintain independence"
    ],
    [
      "全集",
      "全集",
      "quánjí",
      "collected edition; complete works of an artist"
    ],
    [
      "本着",
      "本着",
      "běnzhe",
      "based on; in conformance with; in the spirit of; in line with"
    ],
    [
      "美妙",
      "美妙",
      "měimiào",
      "beautiful (describing sth. abstract); wonderful; splendid"
    ],
    [
      "好样的",
      "好樣的",
      "hǎoyàngde",
      "a good person (used to praise sb.'s moral integrity or courage)"
    ],
    [
      "起草",
      "起草",
      "qǐ cǎo",
      "draft (a document); draw up (plans); compose; map out; sketch"
    ],
    ["飞翔", "飛翔", "fēixiáng", "fly; hover"],
    ["相差", "相差", "xiāngchà", "differ; difference"],
    ["改建", "改建", "gǎijiàn", "rebuild; renovation; transform (a building)"],
    ["准许", "准許", "zhǔnxǔ", "allow; grant; to permit"],
    ["独裁", "獨裁", "dúcái", "dictatorship"],
    ["天地", "天地", "tiāndì", "heaven and earth; world"],
    ["厂家", "厂家", "chǎngjiā", "factory; factory owners"],
    ["境地", "境地", "jìngdì", "circumstances"],
    ["许可", "許可", "xǔkě", "allow; permit; permission"],
    ["主导", "主導", "zhǔdǎo", "leading; dominant; guiding"],
    ["完蛋", "完蛋", "wán dàn", "fallen from power; to be done for"],
    ["或许", "或許", "huòxǔ", "perhaps; maybe"],
    ["集资", "集資", "jí zī", "raise money; accumulate funds"],
    ["灯泡", "燈泡", "dēngpào", "light bulb"],
    ["林场", "林場", "línchǎng", "forestry station; forest management"],
    [
      "集市",
      "集市",
      "jíshì",
      "country fair; market; bazaar; open-air market; marketplace"
    ],
    ["就地", "就地", "jiùdì", "on the spot; locally; nearby"],
    ["样品", "樣品", "yàngpǐn", "product sample; specimen; prototype"],
    ["起点", "起點", "qǐdiǎn", "starting point"],
    ["泡沫", "泡沫", "pàomò", "foam; bubble (economic and soap)"],
    [
      "落地",
      "落地",
      "luòdì",
      "fall to the ground; be born (of a baby); touching the ground"
    ],
    ["误差", "誤差", "wùchā", "difference; error; inaccuracy"],
    ["国家", "國家", "guójiā", "country; state; nation"],
    ["意思", "意思", "yìsi", "meaning; idea; opinion"],
    ["愿意", "願意", "yuànyì", "willing; want to; ready"],
    ["注意", "注意", "zhùyì", "pay attention to; take notice of; be careful"],
    ["外国", "外國", "wàiguó", "foreign country"],
    ["同意", "同意", "tóngyì", "agree; consent; approve"],
    ["意见", "意見", "yìjiàn", "opinion; view; suggestion; complaint"],
    ["麻烦", "麻煩", "máfan5", "trouble (someone); troubling; bothersome"],
    ["顾客", "顧客", "gùkè", "customer; client"],
    ["美丽", "美麗", "měilì", "beautiful"],
    ["同样", "同樣", "tóngyàng", "same; similar; equal; equivalent"],
    ["草地", "草地", "cǎodì", "lawn; meadow"],
    ["地球", "地球", "dìqiú", "the Earth (planet)"],
    ["美好", "美好", "měihǎo", "happy; fine; glorious"],
    ["日记", "日記", "rìjì", "diary"],
    ["外地", "外地", "wàidì", "other places; foreign lands"],
    ["立场", "立場", "lìchǎng", "position; stand; stance"],
    ["地下", "地下", "dìxià", "underground; subterranean; covert"],
    ["地点", "地點", "dìdiǎn", "place; site; location"],
    [
      "补习",
      "補習",
      "bǔxí",
      "take lessons after school; extra tutoring; cram (for exams)"
    ],
    ["准时", "准時", "zhǔnshí", "punctually; on time; on schedule"],
    [
      "改正",
      "改正",
      "gǎizhèng",
      "to correct; to amend; to put right; correction"
    ],
    ["包子", "包子", "bāozi", "steamed stuffed bun"],
    ["模样", "模樣", "múyàng", "appearance; form; approximation"],
    ["改造", "改造", "gǎizào", "to change; alter; to transform"],
    ["海洋", "海洋", "hǎiyáng", "ocean"],
    ["差一点儿", "差一點兒", "chàyìdiǎnr5", "almost; nearly; barely"],
    ["差点儿", "差點兒", "chàdiǎnr5", "almost; nearly; barely"],
    ["地带", "地帶", "dìdài", "region; district; zone"],
    ["虫子", "虫子", "chóngzi", "worm; insect"],
    [
      "培养",
      "培養",
      "péiyǎng",
      "to train; cultivate; bring up; culture (micro-organisms); foster (a talent in sb.); groom (for a position)"
    ],
    ["地理", "地理", "dìlǐ", "geography"],
    ["起飞", "起飛", "qǐfēi", "take off (in an airplane); liftoff"],
    ["独特", "獨特", "dútè", "unique; distinctive"],
    ["场合", "場合", "chǎnghé", "occasion; situation"],
    ["记载", "記載", "jìzǎi", "write down; to record; written record"],
    ["战场", "戰場", "zhànchǎng", "battlefield"],
    ["早已", "早已", "zǎoyǐ", "long ago; for a long time; already"],
    ["场地", "場地", "chǎngdì", "space; site; place"],
    ["照样", "照樣", "zhàoyàng", "as before; (same) as usual"],
    ["工地", "工地", "gōngdì", "construction site"],
    ["养成", "養成", "yǎngchéng", "cultivate; acquire; to form (a habit)"],
    ["地步", "地步", "dìbù", "condition; plight; extent"],
    ["虽说", "雖說", "suīshuō", "although it is said; though"],
    ["地道", "地道", "dìdao", "authentic; genuine"],
    [
      "向导",
      "向導",
      "xiàngdǎo",
      "to show sb. the way; to lead sb. somewhere; to act as a guide; a guide; an escort"
    ],
    ["地主", "地主", "dìzhǔ", "landlord; landowner"],
    ["着凉", "着涼", "zháo liáng", "catch a cold"],
    [
      "背包",
      "背包",
      "bēibāo",
      "backpack (also with fourth tone on first syllable)"
    ],
    ["导师", "導師", "dǎoshī", "tutor; teacher; academic advisor"],
    ["独自", "獨自", "dúzì", "alone"],
    ["鲜明", "鮮明", "xiānmíng", "bright (color); clear-cut; distinct"],
    ["起源", "起源", "qǐyuán", "origin; originate; come from"],
    ["农场", "農場", "nóngchǎng", "farm"],
    ["资本家", "資本家", "zīběnjiā", "capitalist"],
    [
      "各式各样",
      "各式各樣",
      "gèshìgèyàng",
      "of all styles and types; various"
    ],
    ["田地", "田地", "tiándì", "field; farmland"],
    ["大地", "大地", "dàdì", "earth; mother earth"],
    ["沉思", "沉思", "chénsī", "ponder; contemplate; meditation"],
    ["意味着", "意味着", "yìwèizhe", "signify; to mean; imply"],
    ["一心", "一心", "yìxīn", "wholeheartedly; of one mind"],
    ["大意", "大意", "dàyì", "main idea; general idea; gist; careless"],
    ["水库", "水庫", "shuǐkù", "reservoir; M:座"],
    ["回想", "回想", "huíxiǎng", "recall; recollect; think back"],
    ["心思", "心思", "xīnsi", "mind; thoughts; inclination; mood"],
    ["村庄", "村莊", "cūnzhuāng", "village; hamlet"],
    ["心意", "心意", "xīnyì", "regard; kind feelings; intentions"],
    ["惊奇", "驚奇", "jīngqí", "to wonder; be amazed; be surprised"],
    ["顽固", "頑固", "wángù", "stubborn; obstinate"],
    ["姿态", "姿態", "zītài", "attitude; posture; stance"],
    ["未必", "未必", "wèibì", "not necessarily; need not"],
    ["灰心", "灰心", "huī xīn", "lose heart; be discouraged"],
    ["志愿", "志願", "zhìyuàn", "aspiration; wish; ideal; to volunteer"],
    ["背心", "背心", "bèixīn", "sleeveless garment; vest"],
    ["玩意儿", "玩意兒", "wányìr5", "thing; toy; gadget"],
    ["必定", "必定", "bìdìng", "be bound to; be sure to; undoubtedly"],
    ["心里", "心里", "xīnli", "at heart; in one's heart and mind"],
    ["感染", "感染", "gǎnrǎn", "infection; infect; influence"],
    ["王国", "王國", "wángguó", "kingdom; realm"],
    ["宝库", "寶庫", "bǎokù", "treasure-house; treasury; treasure trove"],
    ["烟草", "煙草", "yāncǎo", "tobacco"],
    ["思潮", "思潮", "sīcháo", "trends of thought; way of thinking"],
    ["心愿", "心願", "xīnyuàn", "wish; cherished desire; aspiration; dream"],
    ["好感", "好感", "hǎogǎn", "good opinion; favorable impression"],
    [
      "着想",
      "着想",
      "zhuóxiǎng",
      "give consideration to; consider others' needs"
    ],
    ["总计", "總計", "zǒngjì", "(grand) total"],
    ["心中", "心中", "xīnzhōng", "in one's thoughts; in one's heart"],
    ["国有", "國有", "guó yǒu", "nationalized; public; government owned"],
    ["总额", "總額", "zǒng'é", "total (amount or value)"],
    ["特意", "特意", "tèyì", "specially for; special meaning"],
    [
      "壮志",
      "壯志",
      "zhuàngzhì",
      "lofty goal; great aspiration; strong spirit"
    ],
    ["图案", "圖案", "tú'àn", "design; pattern"],
    ["妄想", "妄想", "wàngxiǎng", "hope in vain; wishful thinking; delusion"],
    ["宽广", "寬广", "kuānguǎng", "wide; broad; extensive"],
    ["真心", "真心", "zhēnxīn", "sincere; heartfelt"],
    ["成心", "成心", "chéngxīn", "intentional; deliberate; with prior intent"],
    ["诚意", "誠意", "chéngyì", "sincerity; good faith"],
    ["麻木", "麻木", "mámù", "numb"],
    [
      "妄图",
      "妄圖",
      "wàngtú",
      "try in vain; futile attempt; absurd; outlandish"
    ],
    [
      "诚心诚意",
      "誠心誠意",
      "chéng xīn chéng yì",
      "eager and sincere; with all sincerity"
    ],
    ["帝国", "帝國", "dìguó", "empire"],
    [
      "如意",
      "如意",
      "rúyì",
      "according to one's wishes; jade ornament symbolizing good luck"
    ],
    ["车床", "車床", "chēchuáng", "lathe"],
    ["国土", "國土", "guótǔ", "country's territory; national soil"],
    [
      "全心全意",
      "全心全意",
      "quán xīn quán yì",
      "heart and soul; wholeheartedly"
    ],
    ["安全感", "安全感", "ānquángǎn", "feeling of security/safety"],
    ["必将", "必將", "bìjiāng", "inevitably; surely"],
    ["困苦", "困苦", "kùnkǔ", "hardship; deep poverty"],
    ["店员", "店員", "diànyuán", "store clerk; shop assistant; salesperson"],
    ["意向", "意向", "yìxiàng", "will; intent; disposition"],
    ["心目", "心目", "xīnmù", "mental attitude; viewpoint"],
    ["意图", "意圖", "yìtú", "intent; intention; intend"],
    ["固有", "固有", "gùyǒu", "intrinsic/inherent to something; native"],
    ["回顾", "回顧", "huígù", "look back; to review"],
    ["没有", "沒有", "méiyǒu", "not have; there is not; haven't; hasn't"],
    ["现在", "現在", "xiànzài", "now"],
    ["开始", "開始", "kāishǐ", "begin; to start; beginning"],
    ["然后", "然后", "ránhòu", "then; afterwards"],
    ["朋友", "朋友", "péngyou", "friend"],
    ["提高", "提高", "tígāo", "elevate; heighten; improve"],
    [
      "正在",
      "正在",
      "zhèngzài",
      "in the process of (doing something); while (doing)"
    ],
    ["回去", "回去", "huí qù", "return; go back"],
    ["建设", "建設", "jiànshè", "build; construct; construction"],
    ["机会", "機會", "jīhuì", "opportunity; chance; occasion"],
    ["过去", "過去", "guòqù", "in the past; formerly; go over"],
    ["友好", "友好", "yǒuhǎo", "friendly (relations); close friends"],
    ["政治", "政治", "zhèngzhì", "politics"],
    ["汉语", "漢語", "Hànyǔ", "Chinese (language)"],
    ["音乐", "音樂", "yīnyuè", "music"],
    ["困难", "困難", "kùnnan5", "difficulty; difficult; problem"],
    ["方法", "方法", "fāngfǎ", "method; way; means"],
    ["反对", "反對", "fǎnduì", "oppose; fight against"],
    ["感到", "感到", "gǎndào", "feel; to sense; have the feeling that"],
    ["一会儿", "一會兒", "yíhuìr5", "a while; a moment"],
    ["开学", "開學", "kāi xué", "start school; begin a term"],
    ["汉字", "漢字", "Hànzì", "Chinese character"],
    ["互相", "互相", "hùxiāng", "mutual; each other"],
    ["看见", "看見", "kànjiàn", "see; catch sight of"],
    ["上去", "上去", "shàngqù", "go up"],
    ["下去", "下去", "xiàqù", "go down; descend; to go on (continue)"],
    [
      "好看",
      "好看",
      "hǎokàn",
      "good-looking; nice-looking; attractive; interesting; good (of a movie, book, TV show, etc.)"
    ],
    ["宴会", "宴會", "yànhuì", "banquet; feast; dinner party"],
    [
      "接着",
      "接着",
      "jiēzhe",
      "then; immediately following; continuing; to catch"
    ],
    ["语法", "語法", "yǔfǎ", "grammar"],
    ["牛奶", "牛奶", "niúnǎi", "cow's milk"],
    ["法语", "法語", "Fǎyǔ", "French (language)"],
    [
      "多么",
      "多麼",
      "duōme",
      "how (wonderful, etc.); what (a great idea); to what extent"
    ],
    ["黑板", "黑板", "hēibǎn", "blackboard"],
    ["会话", "會話", "huìhuà", "conversation"],
    ["没意思", "沒意思", "méi yìsi", "boring; dull"],
    ["极了", "极了", "jíle", "extremely; exceedingly"],
    ["反正", "反正", "fǎnzhèng", "anyway"],
    [
      "开放",
      "開放",
      "kāifàng",
      'to bloom; open up; be open-minded; release; liberalization; China\'s 1978 "open policy"'
    ],
    ["质量", "質量", "zhìliàng", "quality; mass (physics)"],
    ["接受", "接受", "jiēshòu", "accept; receive (honors, etc.)"],
    ["包括", "包括", "bāokuò", "comprise; include; consist of"],
    [
      "支持",
      "支持",
      "zhīchí",
      "sustain; hold out; support; stand by (e.g. international support)"
    ],
    ["存在", "存在", "cúnzài", "to exist; to be"],
    ["直接", "直接", "zhíjiē", "direct; immediate"],
    ["按照", "按照", "ànzhào", "according to; in accordance with; in light of"],
    ["达到", "達到", "dá dào", "achieve; attain; to reach"],
    ["看法", "看法", "kànfǎ", "point of view; opinion"],
    [
      "双方",
      "雙方",
      "shuāngfāng",
      "bilateral; both sides; both parties involved"
    ],
    ["奇怪", "奇怪", "qíguài", "strange; odd"],
    ["担心", "擔心", "dānxīn", "worry; feel anxious"],
    ["无论", "無論", "wúlùn", "no matter what; regardless"],
    ["设备", "設備", "shèbèi", "equipment; facilities; installations"],
    ["到处", "到處", "dàochù", "everywhere; in all places; all over"],
    ["叔叔", "叔叔", "shūshu", "father's younger brother; uncle"],
    ["设计", "設計", "shèjì", "to plan; to design; design"],
    ["享受", "享受", "xiǎngshòu", "enjoy; enjoyment; pleasure; treat"],
    ["难过", "難過", "nánguò", "have a hard time; feel sad"],
    ["对方", "對方", "duìfāng", "counterpart; the other party involved"],
    ["奶奶", "奶奶", "nǎinai", "grandma; paternal grandmother"],
    ["至少", "至少", "zhìshǎo", "at least; (to say the) least"],
    ["吸烟", "吸煙", "xīyān", "to smoke (cigarettes)"],
    ["开会", "開會", "kāi huì", "have a meeting; be at a meeting"],
    ["鼻子", "鼻子", "bízi", "nose"],
    ["可爱", "可愛", "kě'ài", "cute; lovely"],
    [
      "想法",
      "想法",
      "xiǎngfǎ",
      "idea; way of thinking; opinion; to think of a way"
    ],
    ["难受", "難受", "nánshòu", "feel unwell; suffer pain"],
    ["观点", "觀點", "guāndiǎn", "point of view; standpoint"],
    ["对话", "對話", "duìhuà", "dialogue; conversation"],
    ["周到", "周到", "zhōudào", "thoughtful; considerate; thorough; attentive"],
    ["批准", "批准", "pīzhǔn", "approve; ratify"],
    ["难道", "難道", "nándào", "could it be that ...?; don't tell me ..."],
    ["相互", "相互", "xiānghù", "mutual; reciprocal; each other"],
    [
      "构成",
      "構成",
      "gòuchéng",
      "constitute; to form; compose; make up; formation"
    ],
    ["到达", "到達", "dàodá", "to reach; arrive"],
    ["接到", "接到", "jiē dào", "receive (a letter, etc.)"],
    ["提前", "提前", "tíqián", "in advance; ahead of time; bring forward"],
    ["后天", "后天", "hòutiān", "the day after tomorrow"],
    ["热心", "熱心", "rèxīn", "enthusiastic; zealous; warmhearted"],
    ["手指", "手指", "shǒuzhǐ", "finger"],
    ["爱好", "愛好", "àihào", "hobby; fond of; to like; interest"],
    ["误会", "誤會", "wùhuì", "misunderstand; make a mistake"],
    ["及时", "及時", "jíshí", "timely; in time; promptly; without delay"],
    ["相反", "相反", "xiāngfǎn", "opposite; contrary"],
    [
      "反复",
      "反復",
      "fǎnfù",
      "repeatedly; over and over; relapse; go back; reversal"
    ],
    ["乐观", "樂觀", "lèguān", "optimism; optimistic; hopeful"],
    [
      "落后",
      "落后",
      "luòhòu",
      "backward; to lag (in technology); to fall behind"
    ],
    ["热爱", "熱愛", "rè'ài", "love ardently; adore; passion"],
    ["主观", "主觀", "zhǔguān", "subjective"],
    ["打针", "打針", "dǎzhēn", "inject; get a shot"],
    ["树林", "樹林", "shùlín", "forest; woods; grove"],
    ["按时", "按時", "ànshí", "on time; on schedule"],
    ["背后", "背后", "bèihòu", "behind; at the back; in the rear"],
    ["看样子", "看樣子", "kàn yàngzi", "it seems; it looks as if"],
    ["心爱", "心愛", "xīn'ài", "beloved; dear to one's heart"],
    ["战友", "戰友", "zhànyǒu", "comrade-in-arms"],
    [
      "指点",
      "指點",
      "zhǐdiǎn",
      "give directions; enlighten; show (how to do sth)"
    ],
    ["茶话会", "茶話會", "cháhuàhuì", "tea party"],
    ["品质", "品質", "pǐnzhì", "quality; character"],
    ["研制", "研制", "yánzhì", "research and develop; produce"],
    ["投资", "投資", "tóuzī", "investment; invest"],
    ["设立", "設立", "shèlì", "set up; establish"],
    ["治理", "治理", "zhìlǐ", "bring under control; govern; manage"],
    ["对手", "對手", "duìshǒu", "opponent; adversary; match"],
    ["去世", "去世", "qùshì", "pass away; die"],
    [
      "执政",
      "執政",
      "zhí zhèng",
      "to come into power; to hold power; to be in office; to be at the helm of the state; to rule"
    ],
    ["开心", "開心", "kāixīn", "feel happy; have fun; make fun of somebody"],
    ["治安", "治安", "zhì'ān", "law and order; public security"],
    [
      "国会",
      "國會",
      "guóhuì",
      "parliament; (in the U.S.) Congress; (in Japan) the Diet"
    ],
    ["差异", "差異", "chāyì", "difference; discrepancy; divergence"],
    ["集会", "集會", "jíhuì", "assembly; meeting; gathering"],
    ["设置", "設置", "shèzhì", "to set up; to install; to fit; settings"],
    [
      "开刀",
      "開刀",
      "kāidāo",
      "perform or have an operation; (archaic) decapitate"
    ],
    [
      "敌对",
      "敵對",
      "díduì",
      "hostile; antagonistic; enemy (factions); combative"
    ],
    [
      "壮观",
      "壯觀",
      "zhuàngguān",
      "spectacular; grand (of buildings, monuments, scenery, etc.)"
    ],
    ["开支", "開支", "kāizhī", "expenditures; pay; expenses"],
    ["团圆", "團圓", "tuányuán", "have a reunion; reunite as a family; round"],
    [
      "可观",
      "可觀",
      "kěguān",
      "worth seeing; considerable; impressive; sizable; significant"
    ],
    ["歌手", "歌手", "gēshǒu", "singer; vocalist"],
    ["好在", "好在", "hǎozài", "fortunately; luckily (for good situations)"],
    ["手法", "手法", "shǒufǎ", "technique; trick; skill; tact"],
    [
      "下台",
      "下台",
      "xià tái",
      "step down (from office, etc.); go off the stage"
    ],
    ["担忧", "擔憂", "dānyōu", "to worry; be anxious"],
    ["刑法", "刑法", "xíngfǎ", "criminal law"],
    ["外流", "外流", "wàiliú", "outflow; flow out; to drain"],
    [
      "无意",
      "無意",
      "wúyì",
      "have no intention (of doing sth.); accidental; inadvertent"
    ],
    ["提早", "提早", "tízǎo", "ahead of schedule; be earlier than expected"],
    ["固执", "固執", "gùzhí", "obstinate; stubborn"],
    ["抚养", "撫養", "fǔyǎng", "foster; bring up; raise"],
    ["手艺", "手藝", "shǒuyì", "craft; workmanship; one's cooking"],
    [
      "想方设法",
      "想方設法",
      "xiǎng fāng shè fǎ",
      "(saying) think of or try every possible method; by all means possible"
    ],
    ["玩弄", "玩弄", "wánnòng", "play with; dally with; toy with"],
    ["看望", "看望", "kànwàng", "visit; call on; see"],
    [
      "担子",
      "擔子",
      "dànzi",
      "load; burden; a carrying pole and the loads on it"
    ],
    [
      "大同小异",
      "大同小異",
      "dà tóng xiǎo yì",
      "much the same but with minor differences; almost identical except with slight differences; very much/virtually the same; differing only on small points"
    ],
    ["省会", "省會", "shěnghuì", "provincial capital"],
    ["养育", "養育", "yǎngyù", "to bring up; to rear"],
    [
      "反思",
      "反思",
      "fǎnsī",
      "think back over something that happened; to reflect; introspection"
    ],
    ["炎热", "炎熱", "yánrè", "blistering hot; sizzling hot (weather)"],
    ["刑场", "刑場", "xíngchǎng", "execution ground; gallows"],
    [
      "开工",
      "開工",
      "kāi gōng",
      "begin factory operations; start a construction job"
    ],
    ["热潮", "熱潮", "rècháo", "upsurge; popular craze"],
    ["批复", "批復", "pīfù", "reply officially to a subordinate"],
    ["存放", "存放", "cúnfàng", "to deposit; leave in sb.'s care"],
    ["大批", "大批", "dàpī", "large quantities of; a great deal of"],
    ["针对", "針對", "zhēnduì", "aimed at; directed against"],
    ["白菜", "白菜", "báicài", "Chinese cabbage; bok choi; pak choi"],
    ["杂技", "雜技", "zájì", "acrobatics"],
    ["敬爱", "敬愛", "jìng'ài", "respect and love; revere"],
    ["会场", "會場", "huìchǎng", "meeting place; conference hall"],
    ["推广", "推广", "tuīguǎng", "popularize; spread; promote; generalization"],
    [
      "接见",
      "接見",
      "jiējiàn",
      "to receive (a visitor); to grant an interview"
    ],
    ["自我", "自我", "zìwǒ", "self; oneself; ego"],
    ["会客", "會客", "huì kè", "receive a visitor"],
    [
      "小朋友",
      "小朋友",
      "xiǎopéngyou",
      "child; little friend (term of address for children)"
    ],
    ["反抗", "反抗", "fǎnkàng", "to resist; to revolt; to rebel; resistance"],
    ["工会", "工會", "gōnghuì", "labor union; trade union"],
    ["大会", "大會", "dàhuì", "general assembly; mass meeting; convention"],
    ["先后", "先后", "xiānhòu", "early or late; priority; order; successively"],
    ["指挥", "指揮", "zhǐhuī", "to command; to conduct; commander"],
    ["对比", "對比", "duìbǐ", "compare; to contrast; comparison"],
    ["直到", "直到", "zhídào", "until; up to"],
    ["补充", "補充", "bǔchōng", "replenish; to supplement; to complement"],
    ["及格", "及格", "jígé", "pass an exam; meet minimum standard"],
    ["大型", "大型", "dàxíng", "large-scale; wide-scale"],
    ["指导", "指導", "zhǐdǎo", "to guide; supervise; give directions"],
    [
      "召开",
      "召開",
      "zhàokāi",
      "convene (a conference or meeting); call together"
    ],
    ["难看", "難看", "nánkàn", "ugly; unsightly"],
    ["开明", "開明", "kāimíng", "enlightened; open-minded"],
    ["会见", "會見", "huìjiàn", "meet with; see visitors"],
    ["采购", "采購", "cǎigòu", "procure; purchase"],
    ["手工", "手工", "shǒugōng", "hand-made; handicraft; manual"],
    ["构造", "構造", "gòuzào", "structure; construction"],
    ["会谈", "會談", "huìtán", "talks; discussions"],
    ["本质", "本質", "běnzhì", "essence; nature; innate character"],
    ["机构", "機構", "jīgòu", "structure; organization; institution"],
    ["负担", "負擔", "fùdān", "to (bear a) burden; burden"],
    ["开幕", "開幕", "kāimù", "to open (an event); inaugurate"],
    ["无法", "無法", "wú fǎ", "unable; have no way"],
    ["学会", "學會", "xuéhuì", "to learn; academy; to master"],
    ["客观", "客觀", "kèguān", "objective; impartial; unbiased"],
    ["相对", "相對", "xiāngduì", "opposite; facing; relatively; to oppose"],
    ["法子", "法子", "fǎzi", "way; method; means"],
    ["娱乐", "娛樂", "yúlè", "amusement; entertainment; recreation"],
    ["感受", "感受", "gǎnshòu", "feel; experience; emotion; impression"],
    ["合法", "合法", "héfǎ", "lawful; legitimate; legal"],
    ["法制", "法制", "fǎzhì", "legal system and institutions; legality"],
    ["说法", "說法", "shuōfa", "wording; statement; way of speaking"],
    [
      "连接",
      "連接",
      "liánjiē",
      "to join; to link; to connect; to attach; connection; a link (on web page)"
    ],
    ["树木", "樹木", "shùmù", "trees"],
    ["难题", "難題", "nántí", "difficult problem; tough question"],
    ["热量", "熱量", "rèliàng", "quantity of heat; calorific value"],
    ["热带", "熱帶", "rèdài", "tropic; tropical"],
    ["轮流", "輪流", "lúnliú", "to alternate; take turns; rotate"],
    ["模型", "模型", "móxíng", "model; pattern"],
    ["打败", "打敗", "dǎbài", "to defeat; be defeated"],
    ["河流", "河流", "héliú", "river"],
    ["担负", "擔負", "dānfù", "to shoulder; to bear; take on; be charged with"],
    ["乐器", "樂器", "yuèqì", "musical instrument"],
    ["难怪", "難怪", "nánguài", "no wonder"],
    ["财富", "財富", "cáifù", "wealth; riches; fortune"],
    ["欢乐", "歡樂", "huānlè", "gaiety; happy; glee; delighted"],
    ["天才", "天才", "tiāncái", "talent; gift; a genius; talented"],
    [
      "忍受",
      "忍受",
      "rěnshòu",
      "to bear; to endure; to undergo; to suffer; to stand; to tolerate"
    ],
    ["开口", "開口", "kāi kǒu", "open one's mouth; start to talk"],
    ["无比", "無比", "wúbǐ", "matchless; incomparable"],
    ["开水", "開水", "kāishuǐ", "boiled water; boil water"],
    ["梳子", "梳子", "shūzi", "comb; hairbrush"],
    ["提包", "提包", "tíbāo", "handbag; bag; valise"],
    ["对了", "對了", "duìle", "right; correct; yes; by the way"],
    ["接连", "接連", "jiēlián", "one after another; in a row; in succession"],
    ["友爱", "友愛", "yǒu'ài", "friendship; affectionate"],
    ["树立", "樹立", "shùlì", "set up; establish"],
    ["对立", "對立", "duìlì", "oppose; to counter"],
    ["顺手", "順手", "shùnshǒu", "conveniently; smoothly"],
    ["设法", "設法", "shèfǎ", "to try; think of a way"],
    ["观看", "觀看", "guānkàn", "to watch; to view"],
    ["财政", "財政", "cáizhèng", "public finances; financial"],
    ["地质", "地質", "dìzhì", "geology"],
    ["原始", "原始", "yuánshǐ", "first; original; primitive"],
    ["蛋白质", "蛋白質", "dànbáizhì", "protein"],
    ["着手", "着手", "zhuóshǒu", "put one's hand to; commence"],
    ["前后", "前后", "qiánhòu", "around (a time); altogether; front and back"],
    ["打量", "打量", "dǎliang5", "take measure of; size up"],
    ["后方", "后方", "hòufāng", "rear; behind (the front lines)"],
    ["自治", "自治", "zìzhì", "autonomy; autonomous; self-government"],
    [
      "投机",
      "投機",
      "tóujī",
      "speculate (financial markets); be opportunistic"
    ],
    ["集团", "集團", "jítuán", "group; bloc; circle; clique"],
    ["惊异", "驚異", "jīngyì", "amazement; surprised"],
    [
      "主持",
      "主持",
      "zhǔchí",
      "preside over; manage; to direct; to chair; uphold; stand for"
    ],
    ["杂质", "雜質", "zázhì", "impurity"],
    ["地板", "地板", "dìbǎn", "floor; floor board"],
    ["设想", "設想", "shèxiǎng", "imagine; consider; form a plan"],
    ["消极", "消极", "xiāojí", "passive; negative; inactive"],
    ["没说的", "沒說的", "méi shuō de", "really good; it goes without saying"],
    ["流水", "流水", "liúshuǐ", "running water"],
    ["灾难", "災難", "zāinàn", "disaster; catastrophe"],
    ["放手", "放手", "fàng shǒu", "let go; relinquish; have a free hand"],
    [
      "开设",
      "開設",
      "kāishè",
      "to offer (goods or services); to open (for business)"
    ],
    ["美观", "美觀", "měiguān", "pleasing to the eye; beautiful; artistic"],
    ["培育", "培育", "péiyù", "to help grow; to nurture; to breed"],
    ["观测", "觀測", "guāncè", "observation; observe"],
    ["招手", "招手", "zhāo shǒu", "to beckon; wave a hand"],
    ["团员", "團員", "tuányuán", "group member"],
    ["学派", "學派", "xuépài", "school of thought"],
    ["推测", "推測", "tuīcè", "speculate; conjecture; infer"],
    ["法定", "法定", "fǎdìng", "legally established; statutory"],
    ["抱负", "抱負", "bàofù", "aspiration; ambition"],
    ["法则", "法則", "fǎzé", "law; rule; method"],
    ["执照", "執照", "zhízhào", "a license; a permit"],
    [
      "投放",
      "投放",
      "tóufàng",
      "put into (circulation, service, etc.); release; launch"
    ],
    [
      "照会",
      "照會",
      "zhàohuì",
      "note (esp. diplomatic or formal); deliver a note to"
    ],
    ["享乐", "享樂", "xiǎnglè", "seek pleasure"],
    ["观光", "觀光", "guānguāng", "go sightseeing; visit; tourism"],
    ["主流", "主流", "zhǔliú", "mainstream; main aspect"],
    ["造反", "造反", "zào fǎn", "rebel; revolt"],
    ["会员", "會員", "huìyuán", "member"],
    ["会同", "會同", "huìtóng", "handle jointly"],
    ["采集", "采集", "cǎijí", "gather; collect"],
    [
      "一手",
      "一手",
      "yìshǒu",
      "skill; mastery of a trade; all by oneself; without the help of others"
    ],
    ["推选", "推選", "tuīxuǎn", "elect; choose; nominate"],
    ["财会", "財會", "cáikuài", "finance and accounting"],
    ["上台", "上台", "shàng tái", "rise to authority; go up on stage"],
    ["对照", "對照", "duìzhào", "to contrast; compare side-by-side"],
    ["反攻", "反攻", "fǎngōng", "counter attack; counter-offensive"],
    ["指望", "指望", "zhǐwàng", "hope for; count on; hope"],
    ["理会", "理會", "lǐhuì", "pay attention to; take notice of"],
    ["库存", "庫存", "kùcún", "reserve; material held in reserve; stock"],
    [
      "接二连三",
      "接二連三",
      "jiē èr lián sān",
      "(saying) one after another; in quick succession"
    ],
    ["世界观", "世界觀", "shìjièguān", "world view; world outlook"],
    ["抚育", "撫育", "fǔyù", "nurture; raise; foster; tend"],
    [
      "有口无心",
      "有口無心",
      "yǒu kǒu wú xīn",
      "(saying) speak harshly but without any bad intent"
    ],
    [
      "开采",
      "開采",
      "kāicǎi",
      "extract ore or some other natural resource from a mine"
    ],
    ["此后", "此后", "cǐhòu", "after this; afterwards; hereafter; hence-forth"],
    ["增设", "增設", "zēngshè", "increase; augment; add sth. new"],
    ["国法", "國法", "guófǎ", "national law"],
    [
      "构想",
      "構想",
      "gòuxiǎng",
      "conceive; concept; idea; preposition; suggestion"
    ],
    [
      "构思",
      "構思",
      "gòusī",
      "outline a story; make preliminary sketch; to conceive; conception"
    ],
    ["推理", "推理", "tuīlǐ", "reasoning; speculative; inference"],
    [
      "直至",
      "直至",
      "zhízhì",
      "lasting until; up till (the present); directly to"
    ],
    ["选手", "選手", "xuǎnshǒu", "athlete; contestant; player"],
    ["指定", "指定", "zhǐdìng", "to appoint; to assign"],
    ["反感", "反感", "fǎngǎn", "(strongly) dislike; antipathy"],
    ["苦难", "苦難", "kǔnàn", "tribulation; suffering"],
    [
      "外观",
      "外觀",
      "wàiguān",
      "to view sth. from the outside; exterior appearance or condition"
    ],
    ["后台", "后台", "hòutái", "backstage; behind the scenes supporter"],
    ["前提", "前提", "qiántí", "premise; precondition"],
    ["指针", "指針", "zhǐzhēn", "pointer on a gauge; clock hand; cursor"],
    ["埋没", "埋沒", "máimò", "oblivion; bury; neglect"],
    ["古怪", "古怪", "gǔguài", "eccentric; grotesque; odd"],
    ["无理", "無理", "wúlǐ", "irrational; unreasonable"],
    ["汉学", "漢學", "hànxué", "Sinology; studies of classical Chinese"],
    ["推论", "推論", "tuīlùn", "infer; a deduction; a corollary"],
    ["提名", "提名", "tí míng", "nominate"],
    [
      "公布",
      "公布",
      "gōngbù",
      "to make public; to announce; to publicize to promulgate; to publish"
    ],
    ["分布", "分布", "fēnbù", "distributed (over an area); scattered"],
    ["放松", "放松", "fàngsōng", "relax; loosen; slacken"],
    ["过分", "過分", "guòfèn", "excessive; overly"],
    ["分工", "分工", "fēn gōng", "division of labor; divide up work"],
    ["万岁", "萬歲", "wànsuì", "long live"],
    ["分明", "分明", "fēnmíng", "clear; distinct; evidently; clearly"],
    ["浴室", "浴室", "yùshì", "bathroom; washroom"],
    ["容许", "容許", "róngxǔ", "to permit; allow"],
    ["分量", "分量", "fènliàng", "weight; quantity; measure"],
    ["松树", "松樹", "sōngshù", "pine tree"],
    ["分子", "分子", "fēnzǐ", "molecule; numerator"],
    ["(fèn-: member of a class or group)", "", "", ""],
    ["水分", "水分", "shuǐfèn", "moisture content; exaggeration"],
    [
      "出息",
      "出息",
      "chūxi",
      "future prospects; promise; profit; to mature; grow up"
    ],
    ["贫苦", "貧苦", "pínkǔ", "poor; impoverished"],
    ["山谷", "山谷", "shāngǔ", "mountain valley; ravine"],
    ["谷子", "谷子", "gǔzi", "millet"],
    ["万分", "萬分", "wànfēn", "very much; extremely"],
    ["出难题", "出難題", "chū nántí", "raise a tough question"],
    ["公式", "公式", "gōngshì", "formula"],
    [
      "出洋相",
      "出洋相",
      "chū yángxiàng",
      "make an exhibition of oneself; make a spectacle of oneself"
    ],
    ["公安", "公安", "gōng'ān", "public security"],
    ["山地", "山地", "shāndì", "mountainous region; hilly country"],
    ["容器", "容器", "róngqì", "container; receptacle; vessel"],
    ["出差", "出差", "chūchāi", "go on a business trip"],
    ["贫困", "貧困", "pínkùn", "poor; impoverished"],
    [
      "山水",
      "山水",
      "shānshuǐ",
      "water from a mountain; mountains and rivers; scenery with hills and water; traditional Chinese painting of mountains and waters; landscape painting; landscape"
    ],
    ["出入", "出入", "chūrù", "come and go; discrepancy; inconsistency"],
    ["公分", "公分", "gōngfēn", "centimeter; gram"],
    ["出名", "出名", "chū míng", "well-known for sth.; make one's mark"],
    ["比分", "比分", "bǐfēn", "score (sports)"],
    [
      "外出",
      "外出",
      "wàichū",
      "to go out; to leave; to go away (on a trip, etc.)"
    ],
    ["养分", "養分", "yǎngfèn", "nutrient"],
    ["容量", "容量", "róngliàng", "capacity; volume; quantitative (science)"],
    [
      "万水千山",
      "萬水千山",
      "wàn shuǐ qiān shān",
      "(saying) the trails and tribulations of a long journey"
    ],
    ["山河", "山河", "shānhé", "the mountains and rivers; country's land"],
    ["入口", "入口", "rùkǒu", "entrance"],
    ["支出", "支出", "zhīchū", "spend; pay out; expense"],
    [
      "分寸",
      "分寸",
      "fēncun5",
      "propriety; proper speech or action; appropriate behavior; within the norms"
    ],
    ["公证", "公證", "gōngzhèng", "notarization"],
    ["分外", "分外", "fènwài", "particularly; especially; very"],
    ["机密", "機密", "jīmì", "secret; classified (information)"],
    ["出世", "出世", "chūshì", "enter the world; be born"],
    ["密封", "密封", "mìfēng", "seal up; pressurize"],
    ["公有", "公有", "gōngyǒu", "publically owned; communal"],
    ["公然", "公然", "gōngrán", "openly; undisguised"],
    ["输出", "輸出", "shūchū", "send out; export; output"],
    ["百分比", "百分比", "bǎifēnbǐ", "percentage"],
    ["入境", "入境", "rù jìng", "enter a country"],
    ["划分", "划分", "huàfēn", "divide up; differentiate"],
    [
      "规定",
      "規定",
      "guīdìng",
      "stipulate; provide; to fix; to set; rule; regulation"
    ],
    ["记得", "記得", "jìde", "remember"],
    ["正常", "正常", "zhèngcháng", "normal; regular; ordinary"],
    ["激烈", "激烈", "jīliè", "intense; acute; sharp; fierce"],
    ["运动员", "運動員", "yùndòngyuán", "athlete; player"],
    ["失去", "失去", "shīqù", "lose (time, an opportunity, work, etc.)"],
    ["行李", "行李", "xíngli", "luggage; baggage"],
    ["分别", "分別", "fēnbié", "distinguish; split up; difference; to part"],
    ["规模", "規模", "guīmó", "scale; scope; extent"],
    ["运动会", "運動會", "yùndònghuì", "a sports competition; games"],
    ["成为", "成為", "chéngwéi", "become; turn into"],
    ["一边", "一邊", "yìbiān", "one side; at the same time"],
    ["执行", "執行", "zhíxíng", "to implement; carry out; execute"],
    ["有力", "有力", "yǒulì", "powerful; forceful; vigorous"],
    ["告别", "告別", "gàobié", "say goodbye; take leave"],
    ["道德", "道德", "dàodé", "morals; morality; ethics"],
    ["获得", "獲得", "huòdé", "obtain; acquire; to gain"],
    ["有趣", "有趣", "yǒuqù", "interesting; fascinating; amusing"],
    ["激动", "激動", "jīdòng", "excite; agitate"],
    ["取消", "取消", "qǔxiāo", "cancel; abolish"],
    ["往往", "往往", "wǎngwǎng", "often; frequently; more often than not"],
    ["办公", "辦公", "bàn gōng", "to work; handle official business"],
    ["行动", "行動", "xíngdòng", "to move; get around; action"],
    ["街道", "街道", "jiēdào", "street; residential area"],
    ["日常", "日常", "rìcháng", "daily; everyday"],
    ["自动", "自動", "zìdòng", "automatic"],
    ["推动", "推動", "tuīdòng", "promote; push forward; actuate"],
    ["消失", "消失", "xiāoshī", "disappear; fade away; dissolve"],
    ["主动", "主動", "zhǔdòng", "take initiative; be proactive"],
    ["右边", "右邊", "yòubian5", "the right (directional) side"],
    ["力量", "力量", "lìliang5", "power; force; strength"],
    ["更加", "更加", "gèngjiā", "more; even more"],
    ["招待", "招待", "zhāodài", "receive (guests); entertain; reception"],
    ["失败", "失敗", "shībài", "be defeated; fail; lose"],
    ["失望", "失望", "shīwàng", "disappointed; lose hope"],
    ["热烈", "熱烈", "rèliè", "warm; enthusiastic"],
    ["动手", "動手", "dòngshǒu", "to get to work; to touch; to strike a blow"],
    ["感动", "感動", "gǎndòng", "move; be moved; touch emotionally"],
    ["左边", "左邊", "zuǒbian5", "left side"],
    ["招待会", "招待會", "zhāodàihuì", "press conference; reception"],
    ["对待", "對待", "duìdài", "to treat; deal with"],
    ["功夫", "功夫", "gōngfu", "kung fu; skill; art; labor"],
    [
      "规律",
      "規律",
      "guīlv4",
      "rule (e.g. of science); regular pattern; discipline"
    ],
    ["被子", "被子", "bèizi", "quilt; blanket"],
    ["异常", "異常", "yìcháng", "exceptional; abnormal"],
    ["心得", "心得", "xīndé", "knowledge gained (from work, study, etc.)"],
    ["职工", "職工", "zhígōng", "worker; staff; employee"],
    ["工夫", "工夫", "gōngfu", "time; workmanship; labor; effort"],
    ["照常", "照常", "zhàocháng", "as usual; normal"],
    ["个别", "個別", "gèbié", "individual; specific; isolated; very few"],
    [
      "入学",
      "入學",
      "rù xué",
      "enter a school; go to school for the first time as a child"
    ],
    ["出售", "出售", "chūshòu", "sell; offer for sale"],
    ["输入", "輸入", "shūrù", "input; enter; import"],
    ["出品", "出品", "chūpǐn", "produce an item; manufacture"],
    ["岁月", "歲月", "suìyuè", "the years of a person's life"],
    ["容忍", "容忍", "róngrěn", "to put up with; to tolerate; to condone"],
    ["分母", "分母", "fēnmǔ", "denominator of a fraction"],
    [
      "入手",
      "入手",
      "rùshǒu",
      "to set one's hand to; to start with; to proceed from; to take as the point of departure"
    ],
    ["欲望", "欲望", "yùwàng", "desire; lust"],
    ["超出", "超出", "chāochū", "exceed; overstep; go too far; encroach"],
    [
      "周密",
      "周密",
      "zhōumì",
      "meticulous; careful; thorough; dense; impenetrable"
    ],
    [
      "公告",
      "公告",
      "gōnggào",
      "announcement; public announcement; proclamation; notice; public notice"
    ],
    ["分批", "分批", "fēn pī", "do sth. in batches or groups"],
    ["公道", "公道", "gōngdao", "fair; just; reasonable; impartial"],
    ["公有制", "公有制", "gōngyǒuzhì", "public ownership"],
    ["茂密", "茂密", "màomì", "lush; dense; thick (plants, hair, etc.)"],
    ["出境", "出境", "chū jìng", "leave the country or region; emigration"],
    ["火山", "火山", "huǒshān", "volcano"],
    ["因为", "因為", "yīnwèi", "because; owing to; on account of"],
    ["特别", "特別", "tèbié", "special; especially; particular"],
    ["觉得", "覺得", "juéde", "feel; think"],
    ["取得", "取得", "qǔdé", "obtain; acquire; to gain"],
    ["增加", "增加", "zēngjiā", "increase; raise; add"],
    ["办法", "辦法", "bànfǎ", "way (of doing sth.); means; measure; method"],
    ["活动", "活動", "huódòng", "activity; exercise; move about"],
    [
      "为了",
      "為了",
      "wèile",
      "in order to; for the sake of; for the purpose of"
    ],
    ["努力", "努力", "nǔlì", "work hard; strive"],
    ["历史", "曆史", "lìshǐ", "history"],
    ["得到", "得到", "dédào", "get; obtain"],
    [
      "运动",
      "運動",
      "yùndòng",
      "(physical) to exercise; movements; sports; campaign"
    ],
    ["办公室", "辦公室", "bàngōngshì", "office"],
    ["最后", "最后", "zuìhòu", "final; last; finally; at last"],
    ["自行车", "自行車", "zìxíngchē", "bike; bicycle"],
    ["旁边", "旁邊", "pángbiān", "side; beside"],
    ["常常", "常常", "chángcháng", "often; usually; frequently"],
    ["里边", "里邊", "lǐbian5", "inside; in; within; interior"],
    ["大夫", "大夫", "dàifu", "doctor; physician"],
    ["外边", "外邊", "wàibian5", "outside; exterior; abroad"],
    ["最初", "最初", "zuìchū", "first; primary; initial"],
    ["下边", "下邊", "xiàbian5", "below; under; lower level"],
    ["后边", "后邊", "hòubian5", "back; rear; behind; latter"],
    ["别的", "別的", "biéde", "other"],
    ["前边", "前邊", "qiánbian5", "in front; ahead"],
    ["北边", "北邊", "běibian5", "north; northern side; north of"],
    [
      "上边",
      "上邊",
      "shàngbian5",
      "above; over; upwards; those higher up; on top"
    ],
    ["成功", "成功", "chénggōng", "success; succeed"],
    ["最好", "最好", "zuìhǎo", "the best; had better ...; it would be best"],
    [
      "采取",
      "采取",
      "cǎiqǔ",
      "carry out or adopt; take (measures, policies, attitudes, etc.)"
    ],
    ["另外", "另外", "lìngwài", "another; in addition; besides"],
    ["法律", "法律", "fǎlv4", "law; statute"],
    ["德语", "德語", "Déyǔ", "German (language)"],
    ["大街", "大街", "dàjiē", "main street; avenue"],
    ["接待", "接待", "jiēdài", "receive (a visitor); admit (entry to)"],
    ["动员", "動員", "dòngyuán", "mobilize"],
    ["加工", "加工", "jiāgōng", "to process; processing; machining"],
    ["晓得", "曉得", "xiǎode", "know"],
    ["党员", "黨員", "dǎngyuán", "political party member"],
    ["反动", "反動", "fǎndòng", "reaction; reactionary"],
    ["行为", "行為", "xíngwéi", "action; behavior; conduct"],
    ["打破", "打破", "dǎ pò", "to break; to smash; to crack; destroy"],
    ["压力", "壓力", "yālì", "pressure; stress"],
    ["男子", "男子", "nánzǐ", "man; a male"],
    ["加入", "加入", "jiārù", "to join; add; enter; put in"],
    ["大力", "大力", "dàlì", "energetic; vigorously"],
    ["流行", "流行", "liúxíng", "to spread; prevalent; be popular"],
    ["职员", "職員", "zhíyuán", "office worker; staff member"],
    ["规则", "規則", "guīzé", "rule; law; regulation"],
    ["难得", "難得", "nándé", "hard to come by; difficult to get; rare"],
    ["死亡", "死亡", "sǐwáng", "to die; death; be dead"],
    ["开办", "開辦", "kāibàn", "to open; set up and run (a business, etc.)"],
    ["行列", "行列", "hángliè", "procession; ranks; queue"],
    ["飞行", "飛行", "fēixíng", "(of planes etc) to fly; aviation; flying"],
    ["列车", "列車", "lièchē", "train (railway term)"],
    ["吵架", "吵架", "chǎo jià", "to quarrel; to squabble; bicker"],
    ["吸取", "吸取", "xīqǔ", "absorb; assimilate"],
    ["品德", "品德", "pǐndé", "moral character; morality; morals"],
    ["架子", "架子", "jiàzi", "shelf; frame; stand; skeleton; haughty manner"],
    ["动机", "動機", "dòngjī", "motive; motivation; intention"],
    ["得意", "得意", "déyì", "proud of oneself; complacent"],
    ["趣味", "趣味", "qùwèi", "fun; interest; delight; taste; preference"],
    ["常识", "常識", "chángshí", "common sense; general knowledge"],
    [
      "得了",
      "得了",
      "déle",
      "be finished; be ready; that's enough!, (also -liǎo: stop it; really serious; be able to)"
    ],
    ["吃力", "吃力", "chīlì", "strenuous; exhausting"],
    ["主力", "主力", "zhǔlì", "main force; main strength of an army"],
    ["到为止", "到為止", "dào ... wéizhǐ", "up until"],
    ["烈士", "烈士", "lièshì", "martyr"],
    ["党派", "黨派", "dǎngpài", "partisan; party faction"],
    ["势力", "勢力", "shìlì", "power; influence"],
    ["机动", "機動", "jīdòng", "motorized; mobile; flexible"],
    ["别处", "別處", "biéchù", "elsewhere; other places"],
    [
      "一行",
      "一行",
      "yìxíng",
      "a party; a delegation; a group (traveling together)"
    ],
    ["别字", "別字", "biézì", "mispronounced or wrongly written character"],
    ["失掉", "失掉", "shīdiào", "lose; to miss"],
    ["为止", "為止", "wéizhǐ", "until"],
    ["办理", "辦理", "bànlǐ", "to handle; to transact; to conduct"],
    ["下列", "下列", "xiàliè", "following; listed below"],
    ["姿势", "姿勢", "zīshì", "posture; position; pose"],
    ["力求", "力求", "lìqiú", "make every effort; do one's best"],
    ["破烂", "破爛", "pòlàn", "worn-out; junk; dilapidated"],
    ["惊动", "驚動", "jīngdòng", "alarm; alert; startle; disturb"],
    ["开玩笑", "開玩笑", "kāi wánxiào", "joke; play a joke; make fun of"],
    ["本来", "本來", "běnlái", "originally; at first"],
    ["人口", "人口", "rénkǒu", "population; the populace"],
    ["后来", "后來", "hòulái", "afterwards; after; later"],
    ["越来越", "越來越", "yuèláiyuè", "more and more"],
    ["工程", "工程", "gōngchéng", "engineering; engineering project"],
    ["顺利", "順利", "shùnlì", "go smoothly; without a hitch; successful"],
    ["政策", "政策", "zhèngcè", "policy"],
    ["客人", "客人", "kèrén", "guest; customer"],
    ["个人", "個人", "gèrén", "individual; personal; oneself"],
    ["人员", "人員", "rényuán", "staff; crew; personnel"],
    [
      "人家",
      "人家",
      "rénjiā",
      "other people; others; they; I; family; household"
    ],
    ["少数", "少數", "shǎoshù", "small number; minority; few"],
    ["算了", "算了", "suàn le", "forget it; let it be; never mind"],
    ["大多数", "大多數", "dàduōshù", "majority; most"],
    ["流利", "流利", "liúlì", "fluent; smooth"],
    ["积极", "積极", "jījí", "active; positive; energetic"],
    ["箱子", "箱子", "xiāngzi", "chest; trunk; baggage; suitcase"],
    ["来自", "來自", "láizì", "come from; originate from"],
    ["人才", "人才", "réncái", "talent; talented person"],
    ["工程师", "工程師", "gōngchéngshī", "engineer"],
    ["数量", "數量", "shùliàng", "amount; quantity; number"],
    ["主人", "主人", "zhǔrén", "master; host; owner"],
    ["过程", "過程", "guòchéng", "course of events; process"],
    ["未来", "未來", "wèilái", "future"],
    ["数字", "數字", "shùzì", "number; numeral; figure; digit"],
    ["多数", "多數", "duōshù", "most; majority"],
    ["日程", "日程", "rìchéng", "schedule; itinerary"],
    ["看来", "看來", "kànlái", "apparently; it seems; it appears"],
    ["大人", "大人", "dàren5", "adult"],
    ["微笑", "微笑", "wēixiào", "smile"],
    ["人工", "人工", "réngōng", "man-made; manpower; manual work"],
    ["人类", "人類", "rénlèi", "humanity; human race; mankind"],
    ["种子", "種子", "zhǒngzi", "seed"],
    ["笑话", "笑話", "xiàohua", "joke; laugh at"],
    ["移动", "移動", "yídòng", "to move; to shift; mobile; migration"],
    ["男人", "男人", "nánrén", 'man; male; menfolk; husband; "hubby"'],
    ["无数", "無數", "wúshù", "countless; innumerable"],
    ["竹子", "竹子", "zhúzi", "bamboo"],
    ["女人", "女人", "nv3rén", "woman; women"],
    ["认得", "認得", "rènde", "recognize; know; remember"],
    ["敌人", "敵人", "dírén", "enemy; foe"],
    ["冰箱", "冰箱", "bīngxiāng", "refrigerator"],
    ["答案", "答案", "dá'àn", "answer; solution"],
    ["香皂", "香皂", "xiāngzào", "scented soap; facial soap"],
    ["动人", "動人", "dòngrén", "touching; moving"],
    ["委员", "委員", "wěiyuán", "committee member"],
    ["有利", "有利", "yǒulì", "advantageous; beneficial"],
    ["计算", "計算", "jìsuàn", "to count; calculate; compute"],
    ["移到", "移到", "yídào", "move; to shift"],
    ["职务", "職務", "zhíwù", "post; a position; job; duties"],
    ["往日", "往日", "wǎngrì", "in former days"],
    ["家常", "家常", "jiācháng", "homestyle"],
    [
      "往常",
      "往常",
      "wǎngcháng",
      "habitually (in the past); as one used to do; as it used to be"
    ],
    ["反常", "反常", "fǎncháng", "abnormal; unusual"],
    ["前列", "前列", "qiánliè", "front row; the very front"],
    [
      "烂漫",
      "爛漫",
      "lànmàn",
      "bright colored; unaffected (i.e. behaving naturally); innocent"
    ],
    ["行贿", "行賄", "xínghuì", "to bribe; bribery"],
    ["死刑", "死刑", "sǐxíng", "death penalty"],
    ["自行", "自行", "zìxíng", "do by oneself; voluntary; autonomous"],
    [
      "全力",
      "全力",
      "quánlì",
      "full strength; sparing no effort; fully (support)"
    ],
    ["烟雾", "煙霧", "yānwù", "smoke; mist; vapor; smog"],
    ["动脉", "動脈", "dòngmài", "artery"],
    ["动乱", "動亂", "dòngluàn", "turmoil; upheaval; disturbance"],
    [
      "同行",
      "同行",
      "tóngháng",
      "(person) of the same profession; (-xíng: journey together)"
    ],
    ["动态", "動態", "dòngtài", "development; trend; dynamic state"],
    ["威力", "威力", "wēilì", "might; power that invokes fear"],
    ["极力", "极力", "jílì", "do at all costs; make a supreme effort"],
    ["烈火", "烈火", "lièhuǒ", "raging fire"],
    ["壮烈", "壯烈", "zhuàngliè", "brave; heroic"],
    ["外行", "外行", "wàiháng", "layman; amateur; nonprofessional"],
    ["外力", "外力", "wàilì", "external force; foreign pressure"],
    ["微观", "微觀", "wēiguān", "microscopic; micro-"],
    ["失误", "失誤", "shīwù", "mistake; lapse; miss"],
    ["有待", "有待", "yǒudài", "not yet (done); pending"],
    ["被告", "被告", "bèigào", "defendant; the accused"],
    ["各别", "各別", "gèbié", "distinct; individual; be different"],
    ["势必", "勢必", "shìbì", "certainly will...; is bound to..."],
    ["铁道", "鐵道", "tiědào", "railway; railway tracks"],
    ["激励", "激勵", "jīlì", "urge; encourage; motivation"],
    [
      "派别",
      "派別",
      "pàibié",
      "denomination; group; school; faction; school of thought; sect"
    ],
    ["正规", "正規", "zhèngguī", "formal; regular; according to standards"],
    ["武力", "武力", "wǔlì", "(make use of) military force; military power"],
    ["波动", "波動", "bōdòng", "undulate; fluctuate; wave motion"],
    ["就职", "就職", "jiù zhí", "take office; assume a post; inauguration"],
    ["务必", "務必", "wùbì", "must; need to; be sure to"],
    ["罗列", "羅列", "luóliè", "spread out; enumerate"],
    ["选取", "選取", "xuǎnqǔ", "to choose; to select; selection"],
    ["定律", "定律", "dìnglv4", "law; established law"],
    ["规章", "規章", "guīzhāng", "regulations; rules"],
    [
      "动工",
      "動工",
      "dòng gōng",
      "start (a building project, construction, etc.)"
    ],
    ["看待", "看待", "kàndài", "look upon; regard"],
    ["往返", "往返", "wǎngfǎn", "go back and forth; go to and from"],
    ["先行", "先行", "xiānxíng", "precede others; ground-breaking; antecedent"],
    ["步行", "步行", "bùxíng", "go on foot; walk"],
    ["破旧", "破舊", "pòjiù", "shabby; worn out"],
    ["行军", "行軍", "xíng jūn", "(of troops) to march; a march (army)"],
    [
      "运行",
      "運行",
      "yùnxíng",
      "to move; in motion; operate; to function; Run (Windows function)"
    ],
    [
      "政协",
      "政協",
      "zhèngxié",
      "(abbr.) Chinese People's Political Consultative Committee (CPPCC)"
    ],
    [
      "破获",
      "破獲",
      "pòhuò",
      "solve a criminal case; uncover (a criminal plot)"
    ],
    [
      "常务",
      "常務",
      "chángwù",
      "routine business; everyday duties; administrative"
    ],
    ["财务", "財務", "cáiwù", "financial affairs"],
    ["财力", "財力", "cáilì", "financial resources"],
    [
      "提取",
      "提取",
      "tíqǔ",
      "extract; refine; withdraw from a bank or storage location"
    ],
    ["列入", "列入", "lièrù", "put on a list; include (on a roster)"],
    ["常见", "常見", "chángjiàn", "commonly seen; to see something frequently"],
    ["常规", "常規", "chángguī", "conventional; common; routine"],
    ["一律", "一律", "yílv4", "same; uniformly; all; without exception"],
    ["出动", "出動", "chūdòng", "start out on a trip; dispatch troops"],
    ["边境", "邊境", "biānjìng", "border; frontier"],
    ["过失", "過失", "guòshī", "defect; fault"],
    ["党章", "黨章", "dǎngzhāng", "political party constitution"],
    ["冲破", "沖破", "chōngpò", "quickly break through an obstacle"],
    ["办学", "辦學", "bàn xué", "run a school"],
    ["观赏", "觀賞", "guānshǎng", "enjoy the sight of; see and enjoy"],
    ["略微", "略微", "lvèwēi", "a little bit; appreciably; slightly"],
    ["得力", "得力", "délì", "able; competent"],
    ["品行", "品行", "pǐnxíng", "behavior; moral conduct; morality"],
    [
      "包办",
      "包辦",
      "bāobàn",
      "to run the whole show; to take care of everything concerning a job"
    ],
    ["试行", "試行", "shìxíng", "try out; test out sth."],
    ["失学", "失學", "shīxué", "unable to go to school; miss school"],
    [
      "总务",
      "總務",
      "zǒngwù",
      "general matters; person in charge of general matters"
    ],
    ["皮带", "皮帶", "pídài", "strap; leather belt"],
    ["获取", "獲取", "huòqǔ", "obtain; get; gain; win; reap"],
    ["求得", "求得", "qiúdé", "ask for and receive; try to obtain"],
    ["力图", "力圖", "lìtú", "try hard; strive"],
    [
      "大有可为",
      "大有可為",
      "dàyǒukěwéi",
      "(saying) sth. is well worth doing; with great prospects for the future"
    ],
    [
      "主办",
      "主辦",
      "zhǔbàn",
      "to host (a conference or sports event); organize"
    ],
    ["加热", "加熱", "jiā rè", "heating"],
    ["往后", "往后", "wǎnghòu", "in the future; from now on"],
    ["回来", "回來", "huílái", "to return; come back"],
    ["认为", "認為", "rènwéi", "believe; think (that); consider; to feel"],
    ["原来", "原來", "yuánlái", "original; former; as it turns out"],
    [
      "起来",
      "起來",
      "qǐ lai",
      "(beginning or continuing an action); to rise; get up (from bed)"
    ],
    ["出来", "出來", "chūlái", "come out; emerge"],
    ["认识", "認識", "rènshi", "know; recognize; acquainted with (a person)"],
    ["各种", "各種", "gèzhǒng", "every; all kinds of"],
    ["过来", "過來", "guò lai", "come here; come over; be able to handle"],
    [
      "下来",
      "下來",
      "xià lái",
      "come down; (verb suffix indicating continuation, etc.)"
    ],
    ["别人", "別人", "biérén", "other people; others"],
    ["打算", "打算", "dǎsuàn", "to plan; intend"],
    ["回答", "回答", "huídá", "reply; answer"],
    ["夫人", "夫人", "fūrén", "lady; madam; Mrs.; wife"],
    [
      "认真",
      "認真",
      "rènzhēn",
      "serious; earnest; take seriously, conscientious"
    ],
    ["将来", "將來", "jiānglái", "the future"],
    ["工人", "工人", "gōngrén", "worker"],
    ["爱人", "愛人", "àiren5", "spouse; husband; wife; lover"],
    ["数学", "數學", "shùxué", "mathematics; maths"],
    [
      "上来",
      "上來",
      "shàng lái",
      "come up; begin; at the beginning; in sum; (verb complement indicating success or degree)"
    ],
    ["秋天", "秋天", "qiūtiān", "autumn; fall"],
    ["种种", "種種", "zhǒngzhǒng", "all kinds of"],
    ["历来", "曆來", "lìlái", "always; throughout (a period of time)"],
    [
      "同等",
      "同等",
      "tóngděng",
      "having the same social class or status; equal to; the same"
    ],
    ["四季", "四季", "sìjì", "the four seasons"],
    ["认可", "認可", "rènkě", "to approve; approval; acknowledgment; OK"],
    ["分类", "分類", "fēnlèi", "classification; to sort"],
    ["人格", "人格", "réngé", "personality; moral integrity; character"],
    ["成人", "成人", "chéngrén", "adult; to grow up; become full-grown"],
    ["和尚", "和尚", "héshang5", "Buddhist monk"],
    ["推算", "推算", "tuīsuàn", "calculate an amount; calculate"],
    ["到来", "到來", "dàolái", "arrival; advent; to come to a place"],
    ["来历", "來曆", "láilì", "history; antecedents; origin"],
    ["就算", "就算", "jiùsuàn", "granted that ...; even if ..."],
    ["种地", "種地", "zhòngdì", "to farm; cultivate land"],
    ["人均", "人均", "rénjūn", "per capita"],
    [
      "总的来说",
      "總的來說",
      "zǒng de lái shuō",
      "generally speaking; on the whole; in summary"
    ],
    ["立方米", "立方米", "lìfāngmǐ", "cubic meter (unit of volume)"],
    ["粉末", "粉末", "fěnmò", "fine powder; dust"],
    ["运算", "運算", "yùnsuàn", "(mathematical) operation"],
    ["对策", "對策", "duìcè", "countermeasure for dealing with a situation"],
    ["策划", "策划", "cèhuà", "plot; scheme; bring about"],
    [
      "推来推去",
      "推來推去",
      "tuī lái tuī qù",
      "(idiom) to evade responsibility and push it to others"
    ],
    ["小数", "小數", "xiǎoshù", "decimal digit"],
    ["同类", "同類", "tónglèi", "similar; of the same type; alike"],
    ["策略", "策略", "cèlvè", "strategy; tactics; plot"],
    ["奶粉", "奶粉", "nǎifěn", "powdered milk"],
    ["前程", "前程", "qiánchéng", "future (career, etc) prospects"],
    ["胡来", "胡來", "húlái", "to act without regard for rules; cause trouble"],
    ["人为", "人為", "rénwéi", "artificial; man-made"],
    ["方程", "方程", "fāngchéng", "mathematical equation"],
    [
      "恩人",
      "恩人",
      "ēnrén",
      "a benefactor; a person who has significantly helped someone else"
    ],
    ["利息", "利息", "lìxī", "interest (finance)"],
    [
      "积压",
      "積壓",
      "jīyā",
      "overstock; backlog; having more than can be managed"
    ],
    ["数额", "數額", "shù'é", "amount; sum of money; fixed number"],
    ["人质", "人質", "rénzhì", "hostage"],
    ["欢笑", "歡笑", "huānxiào", "laugh happily; belly-laugh"],
    ["名人", "名人", "míngrén", "celebrity; personage; notable"],
    [
      "看起来",
      "看起來",
      "kànqilai",
      "seemingly; apparently; looks as if (based upon what is known so far)"
    ],
    ["上等", "上等", "shàngděng", "highest quality; top-notch"],
    [
      "认定",
      "認定",
      "rèndìng",
      "maintain (that sth. is true); firmly believe; decided"
    ],
    ["嘲笑", "嘲笑", "cháoxiào", "ridicule; deride; make fun of"],
    ["容积", "容積", "róngjī", "volume; capacity; physical space"],
    [
      "目中无人",
      "目中無人",
      "mù zhōng wú rén",
      "condescending; consider everyone below oneself"
    ],
    [
      "章程",
      "章程",
      "zhāngchéng",
      "written rules; statute; regulations; charter of a corporation"
    ],
    ["淡季", "淡季", "dànjì", "off season; slow business season"],
    ["调和", "調和", "tiáohé", "harmonious; mediate; reconcile; compromise"],
    ["盲人", "盲人", "mángrén", "blind person"],
    ["中等", "中等", "zhōngděng", "medium"],
    ["香味", "香味", "xiāngwèi", "fragrance; sweet smell; bouquet"],
    ["法人", "法人", "fǎrén", "legal entity (i.e., a corporation)"],
    ["品种", "品種", "pǐnzhǒng", "breed; variety"],
    ["玉米", "玉米", "yùmǐ", "corn; maize"],
    ["等待", "等待", "děngdài", "wait (for); expect"],
    ["大米", "大米", "dàmǐ", "rice"],
    ["来得及", "來得及", "lái de jí", "there's still time"],
    ["人造", "人造", "rénzào", "man-made; artificial; synthetic"],
    ["计算机", "計算機", "jìsuànjī", "computer; calculator"],
    ["水利", "水利", "shuǐlì", "water conservancy; irrigation works"],
    ["往来", "往來", "wǎnglái", "dealings; contact; go back and forth"],
    ["等到", "等到", "děngdào", "wait until; by the time; when"],
    ["来往", "來往", "láiwǎng", "come and go; reciprocation; communication"],
    ["来回", "來回", "láihuí", "make a round trip; return journey"],
    ["来源", "來源", "láiyuán", "source; origin"],
    ["香烟", "香煙", "xiāngyān", "cigarette; incense smoke"],
    ["自来水", "自來水", "zìláishuǐ", "tap/running water"],
    ["本人", "本人", "běnrén", "I; me; myself; oneself; in person"],
    ["种类", "種類", "zhǒnglèi", "kind; category; class"],
    ["商人", "商人", "shāngrén", "merchant; businessman"],
    ["岁数", "歲數", "suìshu", "age (number of years old)"],
    ["人力", "人力", "rénlì", "manpower; human labor"],
    ["行人", "行人", "xíngrén", "pedestrian"],
    ["玩笑", "玩笑", "wánxiào", "joke; jest"],
    ["算是", "算是", "suànshì", "consider to be; regard as; count as"],
    ["向来", "向來", "xiànglái", "always; all along"],
    ["诗人", "詩人", "shīrén", "poet; bard"],
    ["总算", "總算", "zǒngsuàn", "at long last; finally; on the whole"],
    ["高等", "高等", "gāoděng", "higher; high-level; advanced"],
    ["透明", "透明", "tòumíng", "transparent; open (non-secretive)"],
    ["笑容", "笑容", "xiàoróng", "smile; smiling expression"],
    ["可笑", "可笑", "kěxiào", "laughable; funny; ridiculous; absurd"],
    ["楼道", "樓道", "lóudào", "corridor; hallway"],
    ["谜语", "謎語", "míyǔ", "riddle; conundrum"],
    ["合算", "合算", "hésuàn", "worthwhile; reckon up; calculate"],
    ["种植", "種植", "zhòngzhí", "to plant; grow; crop"],
    ["冬季", "冬季", "dōngjì", "winter"],
    ["军人", "軍人", "jūnrén", "soldier; military personnel"],
    ["夏季", "夏季", "xiàjì", "summer; summertime"],
    ["来客", "來客", "láikè", "guest"],
    ["人心", "人心", "rénxīn", "popular feeling; the will of the people"],
    ["数目", "數目", "shùmù", "amount; number"],
    ["类型", "類型", "lèixíng", "type; category"],
    ["党委", "黨委", "dǎngwěi", "political party committee"],
    ["答复", "答復", "dáfù", "to answer; to reply"],
    ["人士", "人士", "rénshì", "person; public figure"],
    ["惊人", "驚人", "jīngrén", "astonishing; amazing"],
    ["分数", "分數", "fēnshù", "fraction; school mark/grade; score"],
    ["秋季", "秋季", "qiūjì", "autumn"],
    ["球迷", "球迷", "qiúmí", "fan (of ball games)"],
    ["总数", "總數", "zǒngshù", "total number; a sum"],
    [
      "公认",
      "公認",
      "gōngrèn",
      "publicly know (to be); recognize; generally acknowledged"
    ],
    ["中秋", "中秋", "zhōngqiū", "Moon Festival; Mid-Autumn Festival"],
    [
      "行程",
      "行程",
      "xíngchéng",
      "a journey; travel route; itinerary; course (of history)"
    ],
    [
      "来回来去",
      "來回來去",
      "lái huí lái qù",
      "repeatedly; back and forth again"
    ],
    ["测算", "測算", "cèsuàn", "take measurements and calculate"],
    ["总和", "總和", "zǒnghé", "sum"],
    ["秀丽", "秀麗", "xiùlì", "beautiful; pretty"],
    ["互利", "互利", "hùlì", "mutually beneficial"],
    [
      "来看",
      "來看",
      "láikàn",
      "to come and see; to see a topic from a certain point of view"
    ],
    ["禾苗", "禾苗", "hémiáo", "grain crop seedling"],
    ["古人", "古人", "gǔrén", "people from ancient times; ancient man"],
    ["友人", "友人", "yǒurén", "friend"],
    ["前人", "前人", "qiánrén", "predecessors; ancestors; forefathers"],
    [
      "迷失",
      "迷失",
      "míshī",
      "become lost; lose one's bearings, Lost (TV show)"
    ],
    ["小米", "小米", "xiǎomǐ", "millet"],
    ["小数点", "小數點", "xiǎoshùdiǎn", "decimal point"],
    [
      "来说",
      "來說",
      "láishuō",
      "have one's say; interpret a topic (from a certain point of view); now we come to talk about it"
    ],
    ["次数", "次數", "cìshù", "frequency; number of times; order number"],
    ["相等", "相等", "xiāngděng", "be equal to; equally; equivalent"],
    ["什么", "什麼", "shénme", "what; whatever; anything; something"],
    ["但是", "但是", "dànshì", "but; however"],
    ["政府", "政府", "zhèngfǔ", "government"],
    ["条件", "條件", "tiáojiàn", "condition; circumstances; prerequisite"],
    ["方便", "方便", "fāngbiàn", "convenient; practical; useful"],
    [
      "体育",
      "體育",
      "tǐyù",
      "physical training; physical education (P.E.); sports"
    ],
    ["休息", "休息", "xiūxi", "to rest; take a break"],
    ["为什么", "為什麼", "wèishénme", "why"],
    ["内容", "內容", "nèiróng", "content; substance; details"],
    ["相信", "相信", "xiāngxìn", "believe (sb.); be convinced of"],
    ["现代", "現代", "xiàndài", "modern times; modern age"],
    ["化学", "化學", "huàxué", "chemistry"],
    ["全体", "全體", "quántǐ", "all; entire"],
    ["信封", "信封", "xìnfēng", "envelope"],
    ["例如", "例如", "lìrú", "for example; for instance"],
    [
      "从前",
      "從前",
      "cóngqián",
      "previously; formerly; in the past; once upon a time"
    ],
    ["保持", "保持", "bǎochí", "keep; maintain; preserve"],
    [
      "从来",
      "從來",
      "cónglái",
      "all along; from the past till the present; always; at all times; (when followed by 没有) never"
    ],
    ["地位", "地位", "dìwèi", "position; status; standing"],
    ["现代化", "現代化", "xiàndàihuà", "to modernize; modernization"],
    ["保证", "保證", "bǎozhèng", "to guarantee; ensure; pledge; assure"],
    ["具体", "具體", "jùtǐ", "concrete; definite; specific"],
    ["时代", "時代", "shídài", "age; era; period"],
    ["值得", "值得", "zhíde", "be worth; deserve"],
    ["价格", "價格", "jiàgé", "price"],
    ["仍然", "仍然", "réngrán", "still; yet"],
    ["信心", "信心", "xìnxīn", "confidence; faith (in sb. or sth.)"],
    ["优秀", "優秀", "yōuxiù", "outstanding; excellent"],
    ["古代", "古代", "gǔdài", "ancient times"],
    ["体育场", "體育場", "tǐyùchǎng", "stadium; sports field"],
    ["集体", "集體", "jítǐ", "collective; group"],
    ["比例", "比例", "bǐlì", "proportion; scale"],
    ["水力", "水力", "shuǐlì", "water power; hydraulic power"],
    ["流动", "流動", "liúdòng", "flow; circulate"],
    [
      "只得",
      "只得",
      "zhǐdé",
      "{adverb} have no choice but to; be obliged to; have to"
    ],
    ["微小", "微小", "wēixiǎo", "tiny; small"],
    ["被动", "被動", "bèidòng", "passive"],
    ["开动", "開動", "kāidòng", "to start; set in motion; move; march"],
    ["差别", "差別", "chābié", "difference; disparity"],
    ["打架", "打架", "dǎjià", "to fight; scuffle; come to blows"],
    ["火力", "火力", "huǒlì", "fire; firepower"],
    ["总得", "總得", "zǒngděi", "must; be bound to"],
    ["政党", "政黨", "zhèngdǎng", "political party"],
    ["可行", "可行", "kěxíng", "feasible"],
    ["调动", "調動", "diàodòng", "to transfer; to maneuver (troops, etc.)"],
    ["协定", "協定", "xiédìng", "an agreement; an accord"],
    ["手势", "手勢", "shǒushì", "gesture; sign; signal"],
    ["时常", "時常", "shícháng", "time and again; often; frequently"],
    ["调皮", "調皮", "tiáopí", "naughty; mischievous; unruly"],
    ["动力", "動力", "dònglì", "power; motion; driving force"],
    ["为首", "為首", "wéishǒu", "be headed by; be led by"],
    ["带动", "帶動", "dàidòng", "to spur; provide impetus; drive"],
    ["规划", "規划", "guīhuà", "planning; program; project"],
    [
      "特务",
      "特務",
      "tèwu",
      "special assignment (military); special agent; operative; spy"
    ],
    ["地势", "地勢", "dìshì", "terrain; topography"],
    ["边界", "邊界", "biānjiè", "boundary; border"],
    ["行政", "行政", "xíngzhèng", "administration; administrative"],
    ["省得", "省得", "shěngde", "so as to avoid; save"],
    [
      "对得起",
      "對得起",
      "duìdeqǐ",
      "not let sb. down; treat sb. fairly; be worthy of; to not have the slightest guilt/shame toward somebody; Variant: ~~住"
    ],
    ["协会", "協會", "xiéhuì", "an association; a society"],
    ["律师", "律師", "lv4shī", "lawyer"],
    ["地铁", "地鐵", "dìtiě", "subway"],
    ["法规", "法規", "fǎguī", "laws and regulation; statute; code"],
    ["协调", "協調", "xiétiáo", "coordinate; harmonize"],
    ["推行", "推行", "tuīxíng", "put into effect; carry out (a policy, etc.)"],
    ["前往", "前往", "qiánwǎng", "leave for; proceed to; to go"],
    ["外婆", "外婆", "wàipó", "maternal grandmother"],
    ["协商", "協商", "xiéshāng", "consult with; talk things over"],
    ["家务", "家務", "jiāwù", "household chores"],
    ["活力", "活力", "huólì", "energy; vitality; vigor"],
    ["大臣", "大臣", "dàchén", "chancellor; cabinet minister"],
    [
      "学历",
      "學曆",
      "xuélì",
      "record of formal schooling; academic credentials; academic background"
    ],
    [
      "婆婆",
      "婆婆",
      "pópo",
      "husband's mother; mother-in-law; (dialect) maternal grandmother; old lady"
    ],
    [
      "现行",
      "現行",
      "xiànxíng",
      "currently in effect; in force; in operation; (of a criminal) active"
    ],
    ["乐趣", "樂趣", "lèqù", "delight; pleasure; joy; fun"],
    ["识别", "識別", "shíbié", "to identify; to distinguish; to discern"],
    ["天堂", "天堂", "tiāntáng", "paradise; heaven"],
    ["美德", "美德", "měidé", "virtue; moral excellence"],
    ["国力", "國力", "guólì", "a nation's power"],
    ["规格", "規格", "guīgé", "standard; norm; specification"],
    ["公务", "公務", "gōngwù", "public affairs; official business"],
    ["向往", "向往", "xiàngwǎng", "yearn for; look forward to"],
    ["仅仅", "僅僅", "jǐnjǐn", "only; barely; merely"],
    ["丈夫", "丈夫", "zhàngfu", "husband; man"],
    ["观众", "觀眾", "guānzhòng", "spectator; audience"],
    ["自从", "自從", "zìcóng", "since; ever since"],
    ["鲜花", "鮮花", "xiānhuā", "fresh flower"],
    ["顺便", "順便", "shùnbiàn", "conveniently; in passing; on the way"],
    ["倒是", "倒是", "dàoshì", "to the contrary; actually; that's true (but)"],
    ["座位", "座位", "zuòwèi", "a seat; a place"],
    ["做梦", "做夢", "zuò mèng", "to dream; have a dream"],
    ["如何", "如何", "rúhé", "how; what; what way"],
    ["好久", "好久", "hǎojiǔ", "a long time; quite a while"],
    ["花园", "花園", "huāyuán", "garden"],
    ["例子", "例子", "lìzi", "example; case; instance"],
    ["优点", "優點", "yōudiǎn", "merit; good point; a strength; a benefit"],
    ["伤心", "傷心", "shāngxīn", "sad; grieve; brokenhearted"],
    ["个体", "個體", "gètǐ", "individual"],
    ["棉花", "棉花", "miánhua", "cotton"],
    ["优美", "優美", "yōuměi", "graceful; fine; elegant"],
    [
      "做法",
      "做法",
      "zuòfǎ",
      "way of doing or making things; work method; practice"
    ],
    ["来信", "來信", "láixìn", "incoming letter; send a letter here"],
    ["保存", "保存", "bǎocún", "conserve; to preserve; to keep; save a file"],
    [
      "代替",
      "代替",
      "dàitì",
      "to replace; to take the place of; to substitute for"
    ],
    ["消化", "消化", "xiāohuà", "to digest"],
    ["回信", "回信", "huí xìn", "to reply (to a letter); write back"],
    ["从此", "從此", "cóngcǐ", "from now on; since then"],
    ["做客", "做客", "zuò kè", "be a guest"],
    ["什么的", "什麼的", "shénmede", "and so on; et cetera"],
    [
      "打倒",
      "打倒",
      "dǎ dǎo",
      "to knock/beat down; to overthrow; Down with...!"
    ],
    ["口袋", "口袋", "kǒudai", "pocket; bag; sack"],
    [
      "没什么",
      "沒什麼",
      "méi shénme",
      "it's nothing; never mind; it doesn't matter"
    ],
    ["便条", "便條", "biàntiáo", "note; memo"],
    ["座谈", "座談", "zuòtán", "to discuss; informal discussion"],
    ["位置", "位置", "wèizhi", "position; place; seat"],
    ["从没", "從沒", "cóng méi", "never; have never"],
    ["体积", "體積", "tǐjī", "volume; bulk"],
    [
      "价值",
      "價值",
      "jiàzhí",
      "value; worth; fig. values (ethical, cultural etc)"
    ],
    ["对付", "對付", "duìfu", "to handle; deal with"],
    ["停止", "停止", "tíngzhǐ", "to stop; cease"],
    [
      "体会",
      "體會",
      "tǐhuì",
      "know from experience; realize; understanding; experience"
    ],
    ["信息", "信息", "xìnxī", "information; news; message"],
    ["团体", "團體", "tuántǐ", "group; organization; team"],
    ["价钱", "價錢", "jiàqián", "price"],
    ["化工", "化工", "huàgōng", "chemical engineering; chemical industry"],
    ["华人", "華人", "huárén", "ethnic Chinese person"],
    [
      "证件",
      "證件",
      "zhèngjiàn",
      "paperwork; credentials; papers; certificates"
    ],
    ["健全", "健全", "jiànquán", "robust; sound; perfect; strengthen; amplify"],
    ["体力", "體力", "tǐlì", "physical strength; physical power"],
    ["学位", "學位", "xuéwèi", "academic degree; educational level"],
    ["人体", "人體", "réntǐ", "human body"],
    ["行使", "行使", "xíngshǐ", "to exercise (a right); to perform; to wield"],
    ["敞开", "敞開", "chǎngkāi", "open wide"],
    ["雄壮", "雄壯", "xióngzhuàng", "majestic; awesome; sturdy; strong"],
    ["外向型", "外向型", "wàixiàngxíng", "export-oriented (economic model)"],
    ["提升", "提升", "tíshēng", "promote; upgrade; raise"],
    [
      "更正",
      "更正",
      "gēngzhèng",
      "to correct; to make corrections (of errors in published statements or articles)"
    ],
    [
      "思前想后",
      "思前想后",
      "sī qián xiǎng hòu",
      "(saying) to consider over and over again"
    ],
    [
      "抗战",
      "抗戰",
      "kàngzhàn",
      "war of resistance; especially the war against Japan (1937-1945)"
    ],
    ["小型", "小型", "xiǎoxíng", "small-scale; small size"],
    ["对抗", "對抗", "duìkàng", "withstand; resist; antagonize"],
    ["指明", "指明", "zhǐmíng", "show clearly; indicate"],
    ["恩爱", "恩愛", "ēn'ài", "conjugal love"],
    ["执法", "執法", "zhífǎ", "law enforcement; execute the law"],
    ["皇后", "皇后", "huánghòu", "empress"],
    [
      "乐意",
      "樂意",
      "lèyì",
      "be happy to do something; willing to; content; satisfied"
    ],
    ["雄厚", "雄厚", "xiónghòu", "abundant; strong and solid; rich"],
    [
      "及早",
      "及早",
      "jízǎo",
      "as soon as possible; at the earliest possible time"
    ],
    [
      "总督",
      "總督",
      "zǒngdū",
      "governor general; a person in charge of a foreign possession or territory"
    ],
    ["会计", "會計", "kuàijì", "accountant; accounting"],
    ["中型", "中型", "zhōngxíng", "medium-sized; middle"],
    ["守法", "守法", "shǒu fǎ", "abide by the law"],
    ["更改", "更改", "gēnggǎi", "alter; change"],
    ["提案", "提案", "tí'àn", "proposal; motion (to be debated)"],
    ["涉及", "涉及", "shèjí", "involve; in relation to; touch upon; concern"],
    ["潮流", "潮流", "cháoliú", "tide; current; trend"],
    ["过后", "過后", "guòhòu", "after the event; afterwards"],
    ["返回", "返回", "fǎnhuí", "return to; come (or go) back"],
    [
      "无话可说",
      "無話可說",
      "wú huà kě shuō",
      "to have nothing to say (idiom); be speechless"
    ],
    ["手巾", "手巾", "shǒujīn", "hand towel"],
    [
      "批改",
      "批改",
      "pīgǎi",
      "correct (homework, exam etc. and possibly add criticisms)"
    ],
    ["全会", "全會", "quánhuì", "plenary session"],
    ["定购", "定購", "dìnggòu", "to place an order for sth."],
    ["至多", "至多", "zhìduō", "up to the maximum; upper limit; at most"],
    ["在意", "在意", "zài yì", "care about; mind; care"],
    [
      "造型",
      "造型",
      "zàoxíng",
      "to model; to shape; appearance; style; design; form; pose"
    ],
    ["分钟", "分鐘", "fēnzhōng", "minute; (mw for time)"],
    [
      "十分",
      "十分",
      "shífēn",
      "very; extremely; one hundred percent; completely; utterly; absolutely"
    ],
    ["出现", "出現", "chūxiàn", "appear; arise; emerge"],
    ["公里", "公里", "gōnglǐ", "kilometer"],
    ["出去", "出去", "chūqù", "go out"],
    ["公园", "公園", "gōngyuán", "public park"],
    ["指出", "指出", "zhǐchū", "indicate; point out"],
    ["充分", "充分", "chōngfèn", "full; abundant; ample"],
    ["出口", "出口", "chūkǒu", "to speak; to utter; "],
    ["exit; way out; ", "", "", ""],
    ["to export; (of ships) to leave port;", "", "", ""],
    ["exhaust; outfall; outlet; egress; discharge point; vent", "", "", ""],
    ["公开", "公開", "gōngkāi", "public; make public"],
    [
      "密切",
      "密切",
      "mìqiè",
      "close; familiar; intimate; become intimate; forge close links"
    ],
    ["投入", "投入", "tóurù", "put into operation; throw into; invest"],
    ["公元", "公元", "gōngyuán", "(year) AD or CE"],
    ["成分", "成分", "chéngfèn", "ingredient; composition; social status"],
    ["山脉", "山脈", "shānmài", "mountain range"],
    ["处分", "處分", "chǔfèn", "punish; punishment; discipline; sanction"],
    ["付出", "付出", "fùchū", "to pay; spend"],
    ["从未", "從未", "cóngwèi", "never; have never"],
    ["体贴", "體貼", "tǐtiē", "show consideration for; thoughtful"],
    ["为何", "為何", "wèihé", "(written) why?, for what reason?"],
    ["朝代", "朝代", "cháodài", "dynasty; reign (of a king)"],
    ["例外", "例外", "lìwài", "exception; be an exception"],
    ["化妆", "化妝", "huàzhuāng", "makeup; apply makeup"],
    ["内心", "內心", "nèixīn", "heart; innermost being"],
    ["华丽", "華麗", "huálì", "gorgeous; magnificent"],
    ["从小", "從小", "cóngxiǎo", "from childhood; as a child"],
    ["腐化", "腐化", "fǔhuà", "become corrupt; degenerate; decay"],
    ["兰花", "蘭花", "lánhuā", "orchid; cymbidium"],
    ["硬件", "硬件", "yìngjiàn", "hardware"],
    [
      "造价",
      "造價",
      "zàojià",
      "construction cost; manufacturing cost; building cost"
    ],
    ["内行", "內行", "nèiháng", "expert; experienced"],
    [
      "职称",
      "職稱",
      "zhíchēng",
      "job title (technical and professional positions)"
    ],
    [
      "做工",
      "做工",
      "zuò gōng",
      "do manual work; work with one's hands; workmanship"
    ],
    ["优质", "優質", "yōuzhì", "excellent quality; high quality; high grade"],
    ["桃花", "桃花", "táohuā", "peach blossom"],
    [
      "健美",
      "健美",
      "jiànměi",
      "bodybuilding; strong and handsome (of men); healthy and pretty (of women)"
    ],
    ["健壮", "健壯", "jiànzhuàng", "robust; healthy; sturdy"],
    ["对称", "對稱", "duìchèn", "symmetry"],
    ["体质", "體質", "tǐzhì", "physique; physical condition"],
    ["惯例", "慣例", "guànlì", "convention; usual practice"],
    [
      "床位",
      "床位",
      "chuángwèi",
      "bed (in hospital, hotel, train, etc.); berth; bunk"
    ],
    ["担保", "擔保", "dānbǎo", "to assure; to guarantee; to vouch for"],
    ["宣称", "宣稱", "xuānchēng", "assert; claim"],
    ["优先", "優先", "yōuxiān", "have priority; take precedence"],
    ["依次", "依次", "yīcì", "in proper order; in succession"],
    [
      "感化",
      "感化",
      "gǎnhuà",
      "corrective influence; to put sb. on the right path by word or example"
    ],
    ["花样", "花樣", "huāyàng", "(decorative) pattern; variety"],
    ["伤员", "傷員", "shāngyuán", "wounded person; injured"],
    ["优异", "優異", "yōuyì", "exceptional; excellent; outstandingly good"],
    ["代数", "代數", "dàishù", "algebra"],
    ["立体", "立體", "lìtǐ", "solid; three dimensional; stereoscopic"],
    ["伪造", "偽造", "wěizào", "forge; to fake; to counterfeit"],
    ["替代", "替代", "tìdài", "be a substitute for; replace; supersede"],
    ["元件", "元件", "yuánjiàn", "element; component"],
    [
      "名称",
      "名稱",
      "míngchēng",
      "name (of a thing); name (of an organization)"
    ],
    ["何等", "何等", "héděng", "what kind?; how, what?"],
    ["溶化", "溶化", "rónghuà", "dissolve (of sugar etc.)"],
    ["无从", "無從", "wúcóng", "not have the means or ability; have no way"],
    ["从中", "從中", "cóngzhōng", "out of; from among; therefrom"],
    ["众人", "眾人", "zhòngrén", "everybody; everyone"],
    ["分化", "分化", "fēnhuà", "split apart; polarize; differentiation"],
    ["主体", "主體", "zhǔtǐ", "main part; subject; agent"],
    [
      "大体",
      "大體",
      "dàtǐ",
      "in general; more or less; on the whole; the big picture"
    ],
    ["称心", "稱心", "chèn xīn", "satisfactory; agreeable; OK"],
    ["开化", "開化", "kāihuà", "be civilized; have laws and culture"],
    ["保健", "保健", "bǎojiàn", "health care"],
    [
      "无论如何",
      "無論如何",
      "wúlùn rúhé",
      "no matter what; anyhow; anyway; in any case"
    ],
    ["何必", "何必", "hébì", "why should; there is no need to"],
    ["代价", "代價", "dàijià", "price; cost; expense"],
    ["何况", "何況", "hékuàng", "let alone; much less; moreover"],
    [
      "保守",
      "保守",
      "bǎoshǒu",
      "conservative (ideas, estimates, politically, etc.); to guard; to keep"
    ],
    ["便利", "便利", "biànlì", "convenient; easy; facilitate"],
    ["依照", "依照", "yīzhào", "according to; in light of"],
    ["后代", "后代", "hòudài", "posterity; later generations; descendants"],
    ["自信", "自信", "zìxìn", "self-confidence; be self-confident"],
    ["大便", "大便", "dàbiàn", "defecate; excrement; feces"],
    ["肌肉", "肌肉", "jīròu", "muscle; flesh"],
    ["迷信", "迷信", "míxìn", "superstition; blind faith"],
    ["梅花", "梅花", "méihuā", "plum blossom; clubs (playing cards)"],
    ["体现", "體現", "tǐxiàn", "embody; reflect; represent"],
    ["仍旧", "仍舊", "réngjiù", "still (remaining); remain (the same); yet"],
    ["小便", "小便", "xiǎobiàn", "urinate; urine"],
    ["大使", "大使", "dàshǐ", "an ambassador; an envoy"],
    ["在座", "在座", "zàizuò", "be present (at a meeting, etc.)"],
    ["优势", "優勢", "yōushì", "advantage; superiority; dominant position"],
    ["照例", "照例", "zhàolì", "as a rule; as usual; usually"],
    ["保密", "保密", "bǎo mì", "keep secret; confidential"],
    ["持久", "持久", "chíjiǔ", "duration; enduring; lasting; persistent"],
    ["依旧", "依舊", "yījiù", "as before; still"],
    ["依然", "依然", "yīrán", "still; as before"],
    ["使得", "使得", "shǐde", "to make; to cause; usable; workable; feasible"],
    ["大众", "大眾", "dàzhòng", "the masses; people; public"],
    ["伤口", "傷口", "shāngkǒu", "wound; cut"],
    ["化石", "化石", "huàshí", "fossil"],
    ["百货", "百貨", "bǎihuò", "general merchandise"],
    ["条例", "條例", "tiáolì", "rules; regulations"],
    ["哗哗", "嘩嘩", "huāhuā", "(sound of gurgling water)"],
    ["渴望", "渴望", "kěwàng", "thirst for; long for; yearn"],
    ["化合", "化合", "huàhé", "chemical compound; synthesize"],
    ["座儿", "座兒", "zuòr5", "seat; pedestal; base"],
    ["固体", "固體", "gùtǐ", "solid"],
    ["从容", "從容", "cóngróng", "leisurely; calm"],
    [
      "代理",
      "代理",
      "dàilǐ",
      "surrogate; acting as an agent/proxy; act on behalf of sb. in a responsible position (for a certain time)"
    ],
    ["优越", "優越", "yōuyuè", "superior; superiority; advantageous"],
    ["售货", "售貨", "shòu huò", "sell goods"],
    [
      "代办",
      "代辦",
      "dàibàn",
      "be an agent; act for another; diplomatic representative"
    ],
    ["案件", "案件", "ànjiàn", "legal case; judicial case"],
    ["体制", "體制", "tǐzhì", "system; organization"],
    ["受伤", "受傷", "shòu shāng", "be injured"],
    ["软件", "軟件", "ruǎnjiàn", "software (computer); application (mobile)"],
    ["腐败", "腐敗", "fǔbài", "corruption; to corrupt; rotten"],
    ["取代", "取代", "qǔdài", "substitute; replace; supersede"],
    ["众多", "眾多", "zhòngduō", "numerous; multitudinous"],
    [
      "内政",
      "內政",
      "nèizhèng",
      "internal/domestic/home affairs (of a country)"
    ],
    ["他人", "他人", "tārén", "other person; someone else; others"],
    ["历代", "曆代", "lìdài", "successive dynasties; past dynasties"],
    ["忽然", "忽然", "hūrán", "suddenly; all of a sudden"],
    ["房子", "房子", "fángzi", "house; building"],
    ["保护", "保護", "bǎohù", "protect; defend; to safeguard"],
    ["京剧", "京劇", "jīngjù", "Beijing Opera"],
    ["护照", "護照", "hùzhào", "passport"],
    [
      "人物",
      "人物",
      "rénwù",
      "figure; personage; character (in a play, story, etc.)"
    ],
    ["据说", "據說", "jùshuō", "it is said that; reportedly"],
    [
      "尽量",
      "儘量",
      "jǐnliàng",
      "as much as possible; to the best of one's ability"
    ],
    ["护士", "護士", "hùshi", "nurse; doctor’s helper"],
    ["动物园", "動物園", "dòngwùyuán", "zoo"],
    ["水泥", "水泥", "shuǐní", "cement"],
    ["物质", "物質", "wùzhì", "matter; substance; material"],
    ["旅客", "旅客", "lv3kè", "traveler; tourist"],
    ["剧场", "劇場", "jùchǎng", "theater"],
    ["爱护", "愛護", "àihù", "love and protect; cherish"],
    ["同屋", "同屋", "tóngwū", "roommate"],
    ["游泳池", "游泳池", "yóuyǒngchí", "swimming pool"],
    [
      "好容易",
      "好容易",
      "hǎoróngyì",
      "with great difficulty; have a hard time"
    ],
    ["施工", "施工", "shī gōng", "to construct; construction; to build"],
    ["植物", "植物", "zhíwù", "plant; botanical; vegetation"],
    ["物价", "物價", "wùjià", "(commodity) prices"],
    ["旅游", "旅游", "lv3yóu", "trip; journey; tour"],
    ["实施", "實施", "shíshī", "to implement; put into effect; carry out"],
    ["居住", "居住", "jūzhù", "reside; dwell; to live (in a place)"],
    ["话剧", "話劇", "huàjù", "stage play; modern drama"],
    ["房屋", "房屋", "fángwū", "house; building"],
    ["游戏", "游戲", "yóuxì", "game; play; recreation"],
    ["歌剧", "歌劇", "gējù", "(Western-style) opera"],
    ["尽力", "儘力", "jìnlì", "do one's best; strive"],
    [
      "居然",
      "居然",
      "jūrán",
      "unexpectedly; to one's surprise; go so far as to"
    ],
    ["戏剧", "戲劇", "xìjù", "drama; play; theater"],
    ["读物", "讀物", "dúwù", "reading material"],
    ["泥土", "泥土", "nítǔ", "earth; soil; dirt; clay; mud"],
    [
      "个体户",
      "個體戶",
      "gètǐhù",
      "self-employed worker; small private business"
    ],
    ["数据", "數據", "shùjù", "data; numbers; digital"],
    ["货物", "貨物", "huòwù", "goods; commodity; merchandise"],
    ["全局", "全局", "quánjú", "overall situation"],
    ["景物", "景物", "jǐngwù", "scenery"],
    ["物品", "物品", "wùpǐn", "articles; goods; materials"],
    ["剧烈", "劇烈", "jùliè", "acute; violent; severe; intensively"],
    ["证据", "證據", "zhèngjù", "evidence; proof; testimony"],
    ["楼房", "樓房", "lóufáng", "building of two or more stories"],
    ["物体", "物體", "wùtǐ", "object; body; substance"],
    ["物资", "物資", "wùzī", "goods and materials; commodity"],
    [
      "上游",
      "上游",
      "shàngyóu",
      "upper reaches (of a river); advanced position"
    ],
    [
      "依据",
      "依據",
      "yījù",
      "according to; in light of; on the basis of; judging by; basis; grounds; foundation"
    ],
    ["游行", "游行", "yóuxíng", "march; parade; demonstration"],
    [
      "下游",
      "下游",
      "xiàyóu",
      "lower reaches (of a river); backward position swimming"
    ],
    ["尺子", "尺子", "chǐzi", "ruler (measuring instrument)"],
    ["尺寸", "尺寸", "chǐcun5", "size; dimension; measurement"],
    ["以至", "以至", "yǐzhì", "down to; up to; so much so that..."],
    ["中年", "中年", "zhōngnián", "middle-aged"],
    [
      "切实",
      "切實",
      "qièshí",
      "realistic; feasible; conscientiously; practical"
    ],
    ["学年", "學年", "xuénián", "school year"],
    ["出卖", "出賣", "chūmài", "sell; betray; sell out"],
    ["溶液", "溶液", "róngyè", "(chem.) solution; liquid"],
    ["任意", "任意", "rènyì", "arbitrarily; at will; at random"],
    ["多劳多得", "多勞多得", "duō láo duō dé", "work more and get more"],
    ["实力", "實力", "shílì", "(actual) strength"],
    ["劳动力", "勞動力", "láodònglì", "labor force; manpower"],
    [
      "镜头",
      "鏡頭",
      "jìngtóu",
      "camera shot (in a movie, etc.); scene; camera lens"
    ],
    ["法庭", "法庭", "fǎtíng", "court (of law)"],
    [
      "并存",
      "并存",
      "bìngcún",
      "to coexist; to exist simultaneously; coexistence; side-by-side"
    ],
    ["童年", "童年", "tóngnián", "childhood"],
    [
      "埋头",
      "埋頭",
      "mái tóu",
      "to immerse oneself in; engrossed in sth.; to lower the head (e.g. to avoid rain); countersunk (of screws, rivets, etc.)"
    ],
    ["往年", "往年", "wǎngnián", "in former years; in previous years"],
    ["头子", "頭子", "tóuzi", "boss; chief; gang leader"],
    ["逐年", "逐年", "zhúnián", "year after year; on an annual basis"],
    ["以往", "以往", "yǐwǎng", "in the past; formerly"],
    [
      "连年",
      "連年",
      "liánnián",
      "successive years; over many years; once again this year"
    ],
    ["对头", "對頭", "duìtóu", "correct; (longstanding) opponent; enemy"],
    ["开头", "開頭", "kāitóu", "beginning"],
    ["合并", "合并", "hébìng", "merge; annex"],
    [
      "连夜",
      "連夜",
      "liányè",
      "that very night; into the night; through the night"
    ],
    ["得以", "得以", "déyǐ", "be able to (as a result of sth.)"],
    ["并列", "并列", "bìngliè", "stand side by side; juxtaposed"],
    ["接头", "接頭", "jiētóu", "connect; get in touch with; connection"],
    ["实体", "實體", "shítǐ", "entity; substance"],
    ["心头", "心頭", "xīntóu", "mind; heart"],
    ["来年", "來年", "láinián", "next year; the coming year"],
    ["购买力", "購買力", "gòumǎilì", "purchasing power"],
    ["卖国", "賣國", "mài guó", "betray one's country; treason; be a traitor"],
    ["常年", "常年", "chángnián", "an entire year; perennial; for a long time"],
    ["上任", "上任", "shàng rèn", "take office"],
    [
      "同年",
      "同年",
      "tóngnián",
      "the same year; (dialect) of the same age; candidates who passed the imperial examinations in the same year"
    ],
    ["攻读", "攻讀", "gōngdú", "major (in a field); specialize"],
    [
      "年头儿",
      "年頭兒",
      "niántóur5",
      "a whole year; many years duration; period; time; epoch"
    ],
    ["山头", "山頭", "shāntóu", "mountain top; hilltop"],
    [
      "落实",
      "落實",
      "luòshí",
      "practicable; workable; fix or decide in advance; ascertain; fulfill; implement; put into effect; feel at ease"
    ],
    [
      "宣读",
      "宣讀",
      "xuāndú",
      "read out loud to an audience; a prepared speech"
    ],
    [
      "一头",
      "一頭",
      "yìtóu",
      "one head; a head full of sth; one end (of a stick); one side; headlong; directly; rapidly; simultaneously; wholeheartedly"
    ],
    ["从头", "從頭", "cóngtóu", "from the beginning; anew"],
    [
      "合营",
      "合營",
      "héyíng",
      "jointly operate; manage with a business partner"
    ],
    ["容易", "容易", "róngyì", "easy"],
    ["游泳", "游泳", "yóuyǒng", "to swim"],
    ["动物", "動物", "dòngwù", "animal"],
    ["旅行", "旅行", "lv3xíng", "to travel; a journey"],
    ["物理", "物理", "wùlǐ", "physics; innate laws of things; law of nature"],
    ["握手", "握手", "wò shǒu", "to shake hands"],
    ["屋子", "屋子", "wūzi", "room; house"],
    ["游客", "游客", "yóukè", "tourist; traveler"],
    ["住房", "住房", "zhùfáng", "housing; lodging"],
    ["导游", "導游", "dǎoyóu", "tour guide; to guide on a tour"],
    ["剧团", "劇團", "jùtuán", "theatrical group"],
    ["忽略", "忽略", "hūlvè", "ignore; forget about; neglect"],
    ["中游", "中游", "zhōngyóu", "middle reaches (of a river)"],
    ["占据", "占據", "zhànjù", "occupy; to hold; inhabit"],
    ["格局", "格局", "géjú", "structure; layout; setup; pattern"],
    ["游人", "游人", "yóurén", "tourist; sightseer; visitor (to a park, etc.)"],
    ["雇员", "雇員", "gùyuán", "employee"],
    ["剧本", "劇本", "jùběn", "script (for a play, opera, movie, etc.)"],
    ["上层", "上層", "shàngcéng", "upper layer; the higher ups (hierarchy)"],
    [
      "施行",
      "施行",
      "shīxíng",
      "put in force; implement; apply; execute; perform"
    ],
    [
      "物力",
      "物力",
      "wùlì",
      "physical resources (as opposed to labor resources)"
    ],
    ["设施", "設施", "shèshī", "facilities; installation"],
    ["布局", "布局", "bùjú", "arrangement; composition; layout"],
    ["旅店", "旅店", "lv3diàn", "inn; small hotel"],
    ["定居", "定居", "dìngjū", "settle down; fix a place to live"],
    ["混合物", "混合物", "hùnhéwù", "mixture"],
    ["施加", "施加", "shījiā", "exert (effort or pressure)"],
    ["公尺", "公尺", "gōngchǐ", "meter"],
    ["库房", "庫房", "kùfáng", "storehouse; storage room; warehouse"],
    [
      "厂房",
      "厂房",
      "chǎngfáng",
      "a building used as a factory; workshop; factory (building)"
    ],
    ["居室", "居室", "jūshì", "room; apartment; flat; apartment; dwelling"],
    ["实物", "實物", "shíwù", "material object; real goods"],
    [
      "顾全大局",
      "顧全大局",
      "gùquán dàjú",
      "take the big picture into consideration"
    ],
    ["局势", "局勢", "júshì", "situation; state (of affairs)"],
    ["农户", "農戶", "nónghù", "peasant household; rural household; farmer(s)"],
    ["层次", "層次", "céngcì", "level; organization of ideas; gradation"],
    ["尸体", "尸體", "shītǐ", "dead body; corpse; carcass"],
    ["据点", "據點", "jùdiǎn", "stronghold; strong point; fortified point"],
    [
      "加剧",
      "加劇",
      "jiājù",
      "aggravate; intensify; sharpen; accelerate; exacerbate"
    ],
    [
      "户口",
      "戶口",
      "hùkǒu",
      "registered permanent residence (for census taking, etc.)"
    ],
    ["大局", "大局", "dàjú", "general situation; present conditions"],
    ["社会", "社會", "shèhuì", "society; community"],
    ["水果", "水果", "shuǐguǒ", "fruit"],
    ["上课", "上課", "shàngkè", "attend class; give a lesson; go to class"],
    ["礼物", "禮物", "lǐwù", "a gift; a present"],
    ["课本", "課本", "kèběn", "textbook"],
    ["下课", "下課", "xià kè", "to finish class"],
    ["如果", "如果", "rúguǒ", "if; in the event that"],
    ["自由", "自由", "zìyóu", "freedom; free; liberty"],
    ["目标", "目標", "mùbiāo", "target; goal; objective"],
    ["标准", "標准", "biāozhǔn", "(an official) standard; norm; criterion"],
    ["警察", "警察", "jǐngchá", "police"],
    ["禁止", "禁止", "jìnzhǐ", "ban; forbid; prohibit"],
    ["观察", "觀察", "guānchá", "observe; to watch; to survey"],
    ["理由", "理由", "lǐyóu", "justification; grounds; argument"],
    ["抽烟", "抽煙", "chōuyān", "to smoke (a cigarette, pipe, etc.)"],
    ["石油", "石油", "shíyóu", "oil; petroleum"],
    [
      "保养",
      "保養",
      "bǎoyǎng",
      "take good care of (or conserve) one's health; keep in good repair"
    ],
    ["腐烂", "腐爛", "fǔlàn", "to rot; to putrefy; (fig.) corrupt"],
    ["内战", "內戰", "nèizhàn", "civil war"],
    ["世代", "世代", "shìdài", "for generations; generation to generation"],
    ["座右铭", "座右銘", "zuòyòumíng", "motto"],
    ["比价", "比價", "bǐjià", "price relations; rate of exchange; parity"],
    ["停滞", "停滯", "tíngzhì", "stagnation; be at a standstill; bogged down"],
    ["便道", "便道", "biàndào", "shortcut; pavement; sidewalk"],
    [
      "奇花异草",
      "奇花異草",
      "qí huā yì cǎo",
      "rare and unusual (of flowers/flora)"
    ],
    [
      "内幕",
      "內幕",
      "nèimù",
      "inside story; non-public information; behind the scenes"
    ],
    ["几何", "几何", "jǐhé", "geometry; how much/many"],
    ["巫婆", "巫婆", "wūpó", "witch; sorceress; female shaman"],
    ["股份", "股份", "gǔfèn", "a share; stock (in a company)"],
    ["导体", "導體", "dǎotǐ", "electrical conductor"],
    ["盲从", "盲從", "mángcóng", "to follow blindly"],
    [
      "永久",
      "永久",
      "yǒngjiǔ",
      "everlasting; perpetual; lasting; forever; permanent"
    ],
    ["内在", "內在", "nèizài", "intrinsic; innate"],
    ["内地", "內地", "nèidì", "inland; interior; hinterland"],
    ["威信", "威信", "wēixìn", "prestige; popular trust"],
    ["信件", "信件", "xìnjiàn", "letter (i.e. sent in the mail)"],
    ["机体", "機體", "jītǐ", "organism; human body; body (of an engine)"],
    ["支付", "支付", "zhīfù", "pay (money); defray"],
    ["定货", "定貨", "dìng huò", "order goods"],
    ["月份", "月份", "yuèfèn", "month"],
    ["休养", "休養", "xiūyǎng", "recuperate; recover; convalesce"],
    ["反倒", "反倒", "fǎndào", "(informal) on the contrary; instead"],
    ["定价", "定價", "dìngjià", "fixed price; to set a price"],
    ["负伤", "負傷", "fù shāng", "suffer wounds; wounded; injured"],
    ["麻袋", "麻袋", "mádài", "burlap sack; gunnysack; gunnybag"],
    ["可以", "可以", "kěyǐ", "can; may; possible; okay"],
    ["去年", "去年", "qùnián", "last year"],
    ["以后", "以后", "yǐhòu", "after; afterwards; later"],
    ["以前", "以前", "yǐqián", "before; formerly; previously"],
    ["实现", "實現", "shíxiàn", "achieve; implement; realize"],
    ["明年", "明年", "míngnián", "next year"],
    ["家庭", "家庭", "jiātíng", "family; household"],
    ["任何", "任何", "rènhé", "any; whatever; whichever"],
    ["劳动", "勞動", "láodòng", "work; toil; (physical) labor"],
    ["以为", "以為", "yǐwéi", "think (mistakenly); consider (that); believe"],
    ["钟头", "鐘頭", "zhōngtóu", "hour (in spoken Chinese)"],
    ["以及", "以及", "yǐjí", "as well as; too; (formal) and"],
    [
      "以上",
      "以上",
      "yǐshàng",
      "more than; above; over; the above; the above-mentioned"
    ],
    ["改善", "改善", "gǎishàn", "improve; make better; ameliorate; to perfect"],
    ["以来", "以來", "yǐlái", "since (a previous event)"],
    ["年代", "年代", "niándài", "decade; era"],
    ["实在", "實在", "shízài", "really; in truth"],
    ["实行", "實行", "shíxíng", "to implement; put into practice; carry out"],
    ["营养", "營養", "yíngyǎng", "nutrition; nourishment; sustenance"],
    ["主任", "主任", "zhǔrèn", "director; head; chief; person in charge"],
    ["现实", "現實", "xiànshí", "reality; actuality; practical; real; actual"],
    ["任务", "任務", "rènwu", "a mission; assignment; a task"],
    ["石头", "石頭", "shítou", "stone; rock"],
    ["以下", "以下", "yǐxià", "below; under; following; less than"],
    ["真实", "真實", "zhēnshí", "true; real; authentic"],
    ["买卖", "買賣", "mǎimai", "trade; buying and selling; business dealings"],
    ["木头", "木頭", "mùtou", "wood; log; timber"],
    [
      "回头",
      "回頭",
      "huítóu",
      "turn one's head around; turn around; repent; (informal) later; by and by"
    ],
    ["相似", "相似", "xiāngsì", "similar; resemble; be like"],
    ["光荣", "光榮", "guāngróng", "glory; honor"],
    ["诚实", "誠實", "chéngshí", "honest; honorable"],
    ["过年", "過年", "guò nián", "celebrate the Chinese New Year"],
    ["前年", "前年", "qiánnián", "the year before last"],
    ["舌头", "舌頭", "shétou", "tongue"],
    [
      "加以",
      "加以",
      "jiāyǐ",
      "(used before polysyllabic verb to indicate action directed towards sth. or sb. mentioned earlier); in addition; plus"
    ],
    ["担任", "擔任", "dānrèn", "hold the post of; serve as"],
    ["以外", "以外", "yǐwài", "beyond; apart from; other than; except for"],
    ["夜里", "夜里", "yèli", "at night; nighttime"],
    ["后年", "后年", "hòunián", "the year after next"],
    ["少年", "少年", "shàonián", "juvenile; youngster; early youth"],
    ["以内", "以內", "yǐnèi", "within; less than"],
    ["里头", "里頭", "lǐtou", "interior; inside"],
    ["周年", "周年", "zhōunián", "anniversary; annual"],
    ["购买", "購買", "gòumǎi", "to purchase; to buy"],
    ["类似", "類似", "lèisì", "similar; analogous"],
    ["难以", "難以", "nányǐ", "hard to; difficult to"],
    ["国营", "國營", "guóyíng", "state-owned; nationalized"],
    ["前头", "前頭", "qiántou", "in front; ahead; above"],
    [
      "带头",
      "帶頭",
      "dài tóu",
      "take the lead; be the first; take the initiative; set an example"
    ],
    ["实习", "實習", "shíxí", "to practice; field work; work as an intern"],
    ["外头", "外頭", "wàitou", "outside; outdoors"],
    ["日夜", "日夜", "rìyè", "day and night; around the clock"],
    ["上头", "上頭", "shàngtou", "above; on top of; on the surface of"],
    ["后头", "后頭", "hòutou", "at the back; rear; the rear side; later"],
    ["实况", "實況", "shíkuàng", "what is actually happening; scene"],
    ["黑夜", "黑夜", "hēiyè", "night"],
    ["指头", "指頭", "zhǐtou", "finger; toe"],
    ["似的", "似的", "shìde", "seems as if; rather like"],
    [
      "开夜车",
      "開夜車",
      "kāi yèchē",
      "burn the midnight oil; work late into the night"
    ],
    ["以便", "以便", "yǐbiàn", "so that; in order to"],
    ["完善", "完善", "wánshàn", "perfect; improve; consummate"],
    ["历年", "曆年", "lìnián", "over the years; calendar year"],
    ["充实", "充實", "chōngshí", "substantial; rich; enrich; substantiate"],
    ["信任", "信任", "xìnrèn", "to trust; have confidence in"],
    ["功劳", "功勞", "gōngláo", "contribution; credit"],
    ["实质", "實質", "shízhì", "substance; essence; crux"],
    ["证实", "證實", "zhèngshí", "to confirm (sth. to be true); to verify"],
    ["实话", "實話", "shíhuà", "truth"],
    ["液体", "液體", "yètǐ", "liquid"],
    ["口头", "口頭", "kǒutóu", "oral; verbal"],
    [
      "标本",
      "標本",
      "biāoběn",
      "specimen; sample; the root cause and symptoms of a disease"
    ],
    ["神态", "神態", "shéntài", "appearance; looks; manner; expression"],
    ["享福", "享福", "xiǎng fú", "live comfortably; enjoy a happy life"],
    ["崇敬", "崇敬", "chóngjìng", "revere; admire; veneration"],
    [
      "示意图",
      "示意圖",
      "shìyìtú",
      "drawing used to convey basic meaning; sketch"
    ],
    ["指甲", "指甲", "zhǐjia", "fingernail"],
    ["敌视", "敵視", "díshì", "be hostile; adopt a negative attitude towards"],
    ["商标", "商標", "shāngbiāo", "trademark; logo"],
    ["自由市场", "自由市場", "zìyóu shìchǎng", "free market"],
    [
      "出神",
      "出神",
      "chū shén",
      "lost in thought; entranced; preoccupation; Trance (music genre)"
    ],
    [
      "由此可见",
      "由此可見",
      "yóu cǐ kě jiàn",
      "from this, it can be seen that... (used for summary); thus it can be seen; this shows; that proves"
    ],
    ["提示", "提示", "tíshì", "point out; draw attention; hint; cue"],
    ["葬礼", "葬禮", "zànglǐ", "burial; funeral"],
    ["工作", "工作", "gōngzuò", "work; a job"],
    ["所以", "所以", "suǒyǐ", "so; therefore; as a result"],
    ["怎么", "怎麼", "zěnme", "how; however; what; why"],
    ["昨天", "昨天", "zuótiān", "yesterday"],
    [
      "怎么样",
      "怎麼樣",
      "zěnmeyàng",
      "how?; how about?; how was it?; how are things?"
    ],
    ["告诉", "告訴", "gàosu", "to tell; inform; let sb. know"],
    ["最近", "最近", "zuìjìn", "recently; lately; these days"],
    ["利用", "利用", "lìyòng", "make use of; exploit; take advantage of"],
    ["当然", "當然", "dāngrán", "of course; naturally"],
    ["公斤", "公斤", "gōngjīn", "kilogram"],
    ["科学", "科學", "kēxué", "science; scientific knowledge"],
    ["使用", "使用", "shǐyòng", "use; employ; apply; administer; manipulate"],
    ["所有", "所有", "suǒyǒu", "all; to have; to possess"],
    ["健康", "健康", "jiànkāng", "health; healthy"],
    ["听见", "聽見", "tīngjiàn", "to hear"],
    ["着急", "着急", "zháojí", "to worry; feel anxious"],
    ["听说", "聽說", "tīngshuō", "to hear of"],
    ["确实", "確實", "quèshí", "indeed; in truth; reliable"],
    ["故事", "故事", "gùshi", "story; tale"],
    ["录音", "錄音", "lùyīn", "sound recording; to record"],
    ["正确", "正確", "zhèngquè", "correct; proper"],
    ["怎样", "怎樣", "zěnyàng", "how?; in a certain way; in any way"],
    ["当时", "當時", "dāngshí", "then; at that time; while"],
    ["妇女", "婦女", "fùnv3", "woman; women in general"],
    [
      "作用",
      "作用",
      "zuòyòng",
      "act on; to affect; action; use; effect; purpose"
    ],
    ["合作", "合作", "hézuò", "cooperate; collaborate; work together"],
    ["资料", "資料", "zīliào", "data; material; resources; information"],
    [
      "相当",
      "相當",
      "xiāngdāng",
      "equivalent to; appropriate; considerably; quite; rather"
    ],
    ["动作", "動作", "dòngzuò", "movement; motion; action"],
    ["然而", "然而", "rán'ér", "however; yet; but"],
    ["群众", "群眾", "qúnzhòng", "the masses; multitude"],
    ["科学家", "科學家", "kēxuéjiā", "scientist"],
    ["寻找", "尋找", "xúnzhǎo", "seek; look for; quest"],
    [
      "从事",
      "從事",
      "cóngshì",
      "to be engaged in; to deal with; to do (eg. for work, with one's life, etc.)"
    ],
    ["作为", "作為", "zuòwéi", "regard as; act as; action; deed"],
    ["当地", "當地", "dāngdì", "local"],
    ["的确", "的確", "díquè", "really; indeed"],
    ["成果", "成果", "chéngguǒ", "result; achievement; gain"],
    ["果然", "果然", "guǒrán", "really; sure enough; as expected"],
    ["课程", "課程", "kèchéng", "course; curriculum; class"],
    ["礼堂", "禮堂", "lǐtáng", "assembly hall; auditorium"],
    ["社会学", "社會學", "shèhuìxué", "sociology"],
    ["标点", "標點", "biāodiǎn", "punctuation; punctuation mark; punctuate"],
    ["补课", "補課", "bǔ kè", "make up, supplement, or redo a lesson"],
    ["崇高", "崇高", "chónggāo", "lofty; sublime"],
    ["敬礼", "敬禮", "jìnglǐ", "to salute; best regards"],
    ["指示", "指示", "zhǐshì", "indicate; instruct; instructions; directives"],
    ["开课", "開課", "kāi kè", "start of school; give a course; teach a class"],
    ["功课", "功課", "gōngkè", "homework; schoolwork"],
    ["标志", "標志", "biāozhì", "sign; mark; signal; symbol"],
    ["后果", "后果", "hòuguǒ", "consequences; aftermath"],
    ["社论", "社論", "shèlùn", "editorial; leading article"],
    [
      "加油",
      "加油",
      "jiā yóu",
      "refuel; lubricate; make an extra effort; cheer sb. on; Go!; Step on it!; Encore!"
    ],
    ["神话", "神話", "shénhuà", "mythology; fairy tale"],
    ["忽视", "忽視", "hūshì", "neglect; ignore; to overlook"],
    ["果树", "果樹", "guǒshù", "fruit tree"],
    ["标语", "標語", "biāoyǔ", "slogan; poster"],
    ["课堂", "課堂", "kètáng", "classroom"],
    ["指标", "指標", "zhǐbiāo", "target; norm; index; indicator"],
    ["神圣", "神聖", "shénshèng", "divine; holy; sacred"],
    ["宗派", "宗派", "zōngpài", "sect"],
    ["注视", "注視", "zhùshì", "watch attentively; gaze at; stare"],
    [
      "示威",
      "示威",
      "shìwēi",
      "to demonstrate (as a protest); a demonstration; a military show of force"
    ],
    ["果实", "果實", "guǒshí", "fruit; gains; results"],
    ["油田", "油田", "yóutián", "oil field"],
    ["福利", "福利", "fúlì", "material benefits; welfare; well-being"],
    [
      "课题",
      "課題",
      "kètí",
      "(for discussion or study) question; topic; issue; problem"
    ],
    ["宗旨", "宗旨", "zōngzhǐ", "purpose; objective; aim; goal"],
    ["公社", "公社", "gōngshè", "commune"],
    ["神奇", "神奇", "shénqí", "miraculous; magical; mystical"],
    [
      "摩擦",
      "摩擦",
      "mócā",
      "friction; clash (between two parties); conflict; to rub"
    ],
    ["暗示", "暗示", "ànshì", "drop a hint; suggest"],
    ["视力", "視力", "shìlì", "vision; eyesight"],
    ["标题", "標題", "biāotí", "title; header; headline; caption"],
    ["甲板", "甲板", "jiǎbǎn", "deck (of a boat etc.)"],
    ["社员", "社員", "shèyuán", "member (of an association or society)"],
    [
      "批示",
      "批示",
      "pīshì",
      "written instructions; official comments (on a report)"
    ],
    ["视察", "視察", "shìchá", "inspect (as a visitor); examine"],
    ["礼品", "禮品", "lǐpǐn", "gift; present; product"],
    ["视觉", "視覺", "shìjué", "sight; visual; seeing"],
    ["课时", "課時", "kèshí", "class; period"],
    ["油菜", "油菜", "yóucài", "rapeseed plant; canola plant"],
    ["延伸", "延伸", "yánshēn", "extend; spread; stretch"],
    ["原油", "原油", "yuányóu", "crude oil"],
    ["觉察", "覺察", "juéchá", "sense; perceive; detect"],
    [
      "伸手",
      "伸手",
      "shēnshǒu",
      "stretch / hold out one's hand; ask for help; apply oneself to; meddle in"
    ],
    ["投标", "投標", "tóu biāo", "to submit a tender; to make a bid"],
    ["确认", "確認", "quèrèn", "confirm; confirmation; verify"],
    ["群体", "群體", "qúntǐ", "colony; community; group"],
    ["乐曲", "樂曲", "yuèqǔ", "musical composition"],
    ["心灵", "心靈", "xīnlíng", "heart; soul; smart; quick-witted"],
    ["史料", "史料", "shǐliào", "historical material or data"],
    ["听众", "聽眾", "tīngzhòng", "audience; listeners"],
    ["起诉", "起訴", "qǐsù", "sue; bring a lawsuit against"],
    ["当心", "當心", "dāngxīn", "take care; watch out"],
    [
      "充当",
      "充當",
      "chōngdāng",
      "to serve as; to act as; to play the part of"
    ],
    [
      "理所当然",
      "理所當然",
      "lǐ suǒ dāng rán",
      "(idiom) it goes without saying; certainly; of course; be natural and right"
    ],
    ["派出所", "派出所", "pàichūsuǒ", "local police station"],
    [
      "目录",
      "目錄",
      "mùlù",
      "catalog; table of contents; directory (on computer hard drive)"
    ],
    ["忙碌", "忙碌", "mánglù", "busy; bustle about"],
    ["照料", "照料", "zhàoliào", "tend; take care of; care for"],
    ["糖果", "糖果", "tángguǒ", "candy"],
    [
      "争先恐后",
      "爭先恐后",
      "zhēng xiān kǒng hòu",
      "strive to be first and fear to lag behind; vie with one another in doing something"
    ],
    ["高档", "高檔", "gāodàng", "top quality; first rate; high class"],
    ["听话", "聽話", "tīng huà", "do what one is told; to be obedient"],
    ["外事", "外事", "wàishì", "foreign affairs"],
    ["确信", "確信", "quèxìn", "confident; certain of; firmly believe"],
    ["看作", "看作", "kànzuò", "look upon as; regard as"],
    ["确保", "確保", "quèbǎo", "ensure; to guarantee"],
    ["就近", "就近", "jiùjìn", "nearby; in a close neighborhood"],
    [
      "人事",
      "人事",
      "rénshì",
      "human affairs; ways of the world; personnel matters; what is humanly possible; the facts of life"
    ],
    ["惯用语", "慣用語", "guànyòngyǔ", "idiom; commonly used word or phrase"],
    [
      "周折",
      "周折",
      "zhōuzhé",
      "setback; twists and turns; problem; complication"
    ],
    ["科目", "科目", "kēmù", "(school) subject"],
    ["果断", "果斷", "guǒduàn", "firm; decisive"],
    ["将近", "將近", "jiāngjìn", "almost; nearly; close to"],
    ["机灵", "機靈", "jīling5", "clever; quick-witted; smartness"],
    [
      "当事人",
      "當事人",
      "dāngshìrén",
      "persons involved or implicated; party (to an affair)"
    ],
    ["而后", "而后", "érhòu", "after that; moreover"],
    [
      "用人",
      "用人",
      "yòngren5",
      "servant; to use people; to employ sb. for a job; to manage people; to be in need of staff"
    ],
    ["近年", "近年", "jìnnián", "in the last year; recent year(s)"],
    ["争端", "爭端", "zhēngduān", "dispute; controversy; conflict"],
    ["急切", "急切", "jíqiè", "eager; impatient; in haste"],
    ["急剧", "急劇", "jíjù", "rapid; sudden"],
    [
      "时而",
      "時而",
      "shí'ér",
      "occasionally; often, but not at any fixed time"
    ],
    ["试用", "試用", "shìyòng", "try something out; trial"],
    ["所得", "所得", "suǒdé", "earnings; one's gains"],
    ["争吵", "爭吵", "zhēngchǎo", "dispute; quarrel; strife"],
    ["瑞雪", "瑞雪", "ruìxuě", "timely snow; auspicious snowfall"],
    ["常用", "常用", "chángyòng", "in common use; frequently use"],
    ["时事", "時事", "shíshì", "current events; the present situation"],
    ["理事", "理事", "lǐshì", "trustee; member of council"],
    ["用意", "用意", "yòngyì", "purpose; intention; goal"],
    ["前所未有", "前所未有", "qiánsuǒwèiyǒu", "unprecedented; unheard of"],
    [
      "所有制",
      "所有制",
      "suǒyǒuzhì",
      "ownership of the means of production (in Marxism); system of ownership"
    ],
    ["用户", "用戶", "yònghù", "user; consumer; subscriber; customer"],
    ["断定", "斷定", "duàndìng", "conclude; determine; figure out"],
    ["之上", "之上", "zhī shàng", "(formal) above"],
    ["从不", "從不", "cóngbù", "never"],
    ["用不着", "用不着", "yòng bu zháo", "to have no use for; to not need"],
    ["出席", "出席", "chūxí", "attend; be present; participate"],
    ["一半", "一半", "yíbàn", "(one) half"],
    ["半拉", "半拉", "bàn lǎ", "half"],
    ["高度", "高度", "gāodù", "height; altitude; high degree; apogee"],
    ["不是", "不是", "búshì", "no; not; is not; fault; blame"],
    ["不对", "不對", "bú duì", "incorrect; wrong"],
    ["是否", "是否", "shìfǒu", "whether (or not); if"],
    [
      "不利",
      "不利",
      "búlì",
      "unfavorable; disadvantageous; harmful; detrimental; unsuccessful"
    ],
    ["过渡", "過渡", "guòdù", "cross a river by ferry; transition; interim"],
    ["裁判", "裁判", "cáipàn", "judge; referee"],
    ["之内", "之內", "zhīnèi", "inside of; among; within"],
    ["不顾", "不顧", "búgù", "in spite of; regardless of; to disregard"],
    ["不见得", "不見得", "bújiànde", "not necessarily; not likely"],
    [
      "怪不得",
      "怪不得",
      "guài bu de",
      "no wonder; so that's why; not to blame"
    ],
    ["不够", "不夠", "búgòu", "not enough; insufficient; inadequate"],
    ["不安", "不安", "bù'ān", "uneasy; unstable; disturbed"],
    ["不停", "不停", "bùtíng", "incessant; constantly"],
    ["不只", "不只", "bùzhǐ", "not only; not merely"],
    ["多半", "多半", "duōbàn", "for the most part; mostly; most likely"],
    ["大半", "大半", "dàbàn", "more than half; most; most likely; probably"],
    ["不见", "不見", "bújiàn", "not see; disappear; vanish"],
    [
      "总之",
      "總之",
      "zǒngzhī",
      "in a nutshell; in a word; in short; in brief; anyway; anyhow"
    ],
    ["不成", "不成", "bùchéng", "won't do; have never done"],
    ["不禁", "不禁", "bùjīn", "cannot help; can't refrain from"],
    ["忍不住", "忍不住", "rěnbuzhù", "cannot help but; unable to bear"],
    ["明信片", "明信片", "míngxìnpiàn", "postcard"],
    ["说不定", "說不定", "shuōbudìng", "can't say for sure; perhaps; maybe"],
    ["坏蛋", "壞蛋", "huàidàn", "rotten egg; bad person; scoundrel; villain"],
    [
      "可不是",
      "可不是",
      "kě bu shì",
      "(Spoken) exactly; isn't that the truth?"
    ],
    ["借口", "借口", "jièkǒu", "excuse; pretext"],
    [
      "不是就是",
      "不是就是",
      "búshì ... jiùshì",
      "if not (this) ... then (that)"
    ],
    [
      "不怎么样",
      "不怎麼樣",
      "bù zěnmeyàng",
      "not up to much; not particularly good"
    ],
    ["同伴", "同伴", "tóngbàn", "companion; comrade; fellow"],
    ["不可", "不可", "bùkě", "cannot; should not; must not"],
    ["总而言之", "總而言之", "zǒngéryánzhī", "in short; in a word"],
    ["不料", "不料", "búliào", "unexpectedly; to one's surprise"],
    ["错字", "錯字", "cuòzì", "wrong character; typo"],
    ["不是而是", "不是而是", "búshì ... érshì", "not be ... but"],
    ["不止", "不止", "bùzhǐ", "incessantly; more than; not only"],
    ["拳头", "拳頭", "quántou", "fist"],
    ["之类", "之類", "zhīlèi", "and so on; and such"],
    ["不由得", "不由得", "bùyóude", "can't help; cannot but"],
    ["分散", "分散", "fēnsàn", "to scatter; disperse; distribute"],
    ["之外", "之外", "zhīwài", "beyond; outside"],
    ["不觉", "不覺", "bùjué", "unconsciously; unknowingly"],
    ["不比", "不比", "bùbǐ", "incomparable"],
    ["散布", "散布", "sànbù", "to scatter; disseminate; to spread"],
    ["不用", "不用", "búyòng", "need not; no need for..."],
    ["对不起", "對不起", "duìbuqǐ", "sorry"],
    ["不但", "不但", "búdàn", "not only"],
    ["杯子", "杯子", "bēizi", "cup; glass"],
    ["散步", "散步", "sàn bù", "go for a walk"],
    ["半天", "半天", "bàntiān", "half a day; a long time"],
    ["分之", "分之", "fēnzhī", "(indicating a fraction)"],
    ["环境", "環境", "huánjìng", "environment; surroundings"],
    [
      "不过",
      "不過",
      "búguò",
      "but; however; only; cannot be more (intensifier for adjectives)"
    ],
    ["差不多", "差不多", "chàbuduō", "almost; about the same"],
    ["照片", "照片", "zhàopiàn", "picture; photograph"],
    ["制度", "制度", "zhìdù", "system; institution"],
    [
      "不断",
      "不斷",
      "búduàn",
      "unceasing; uninterrupted; continuously; unbroken"
    ],
    ["主席", "主席", "zhǔxí", "chairperson; president"],
    ["之前", "之前", "zhī qián", "before; prior to; ago"],
    ["否则", "否則", "fǒuzé", "if not; otherwise; or else"],
    ["出版", "出版", "chūbǎn", "publish"],
    ["之后", "之后", "zhīhòu", "after; later; following"],
    ["程度", "程度", "chéngdù", "degree; extent; level"],
    [
      "不得了",
      "不得了",
      "bùdéliǎo",
      "extremely; very; terribly; my god! (expression of surprise)"
    ],
    ["来不及", "來不及", "láibují", "not enough time; too late"],
    ["不行", "不行", "bùxíng", "won't do; be out of the question; not ok"],
    [
      "不得不",
      "不得不",
      "bù dé bù",
      "have to; have no choice but to; cannot but"
    ],
    ["不必", "不必", "búbì", "need not; does not have to; not necessarily"],
    ["半夜", "半夜", "bànyè", "midnight; middle of the night"],
    ["不仅", "不僅", "bùjǐn", "not only; not just"],
    ["判断", "判斷", "pànduàn", "to judge; judgment; to decide"],
    ["之一", "之一", "zhī yī", "one of (something)"],
    ["谈判", "談判", "tánpàn", "negotiate; negotiation; conference"],
    ["不然", "不然", "bùrán", "otherwise; if not; not so"],
    ["不论", "不論", "búlùn", "no matter (what, how, etc.); regardless of"],
    ["破坏", "破壞", "pòhuài", "destroy; destruction; to wreck; to break"],
    ["不好意思", "不好意思", "bù hǎoyìsi", "embarrassed; ill at ease; sorry"],
    [
      "了不起",
      "了不起",
      "liǎobuqǐ",
      "incredible; extraordinary; great; amazing"
    ],
    ["否定", "否定", "fǒudìng", "deny; reject; negate; negative"],
    ["不大", "不大", "búdà", "not very; not too; not often"],
    ["不许", "不許", "bùxǔ", "not allow; be not allowed; must not; can't"],
    ["之下", "之下", "zhī xià", "(formal) under; beneath; less than"],
    [
      "不敢当",
      "不敢當",
      "bù gǎndāng",
      "lit. I dare not (accept the honor); fig. I don't deserve your praise / you flatter me"
    ],
    ["看不起", "看不起", "kànbuqǐ", "look down upon; despise"],
    ["没错", "沒錯", "méi cuò", "that's right; quite sure; not wrong"],
    ["不少", "不少", "bùshǎo", "quite a few; many"],
    ["坏处", "壞處", "huàichu", "disadvantage; harm; troubles"],
    ["不住", "不住", "búzhù", "continuously; constantly"],
    [
      "不一定",
      "不一定",
      "bù yídìng",
      "uncertain; not sure; not necessarily; maybe"
    ],
    ["半导体", "半導體", "bàndǎotǐ", "semiconductor; transistor radio"],
    [
      "度过",
      "度過",
      "dùguò",
      "to pass; to spend (time); to survive; to get through"
    ],
    ["相片", "相片", "xiàngpiàn", "image; photograph"],
    ["批判", "批判", "pīpàn", "criticize; critique"],
    ["之中", "之中", "zhī zhōng", "inside; in; in the process of"],
    ["暂时", "暫時", "zànshí", "temporary; transient; for the moment"],
    ["争取", "爭取", "zhēngqǔ", "fight for; compete for; strive"],
    ["逐渐", "逐漸", "zhújiàn", "gradually; by degrees"],
    ["事实", "事實", "shìshí", "fact"],
    [
      "当年",
      "當年",
      "dāngnián",
      "in those days; then; in those years (also dàng-: the same year, that very year)"
    ],
    ["军事", "軍事", "jūnshì", "military affairs; military matters"],
    ["记录", "記錄", "jìlù", "to record; take notes; transcribe"],
    ["作品", "作品", "zuòpǐn", "works (of literature and art)"],
    ["用功", "用功", "yònggōng", "diligent; industrious; hardworking"],
    ["战争", "戰爭", "zhànzhēng", "war; conflict"],
    ["灵活", "靈活", "línghuó", "flexible; nimble; agile"],
    ["作家", "作家", "zuòjiā", "author; writer"],
    ["明确", "明確", "míngquè", "clear-cut; clearly; clarify"],
    ["裙子", "裙子", "qúnzi", "skirt; dress"],
    ["办事", "辦事", "bànshì", "to handle (affairs); to work"],
    ["争论", "爭論", "zhēnglùn", "argue; to dispute; contend; argument"],
    ["准确", "准確", "zhǔnquè", "accurate; precise, exact"],
    ["事件", "事件", "shìjiàn", "event; happening; incident"],
    ["打听", "打聽", "dǎting5", "ask about; inquire about"],
    ["哲学", "哲學", "zhéxué", "philosophy"],
    ["实用", "實用", "shíyòng", "practical; pragmatic; functional"],
    ["斗争", "斗爭", "dòuzhēng", "struggle; fight for; battle"],
    ["没用", "沒用", "méi yòng", "useless"],
    ["适用", "適用", "shìyòng", "applicable; suitable"],
    ["事先", "事先", "shìxiān", "in advance; beforehand; prior"],
    [
      "没事儿",
      "沒事兒",
      "méishìr5",
      "it doesn't matter; no problem; be free from work"
    ],
    ["渐渐", "漸漸", "jiànjiàn", "gradually; by degrees; little by little"],
    [
      "日用品",
      "日用品",
      "rìyòngpǐn",
      "daily necessities; articles of everyday use"
    ],
    ["近来", "近來", "jìnlái", "recently; lately"],
    ["录音机", "錄音機", "lùyīnjī", "tape/sound recorder"],
    ["用处", "用處", "yòngchu", "usefulness; use"],
    ["事物", "事物", "shìwù", "thing; object"],
    ["用力", "用力", "yòng lì", "exert oneself (physically)"],
    ["当作", "當作", "dàngzuò", "treat as; regard as; look upon"],
    ["上当", "上當", "shàng dàng", "be fooled; be duped; be taken in"],
    ["有用", "有用", "yǒuyòng", "useful"],
    ["好听", "好聽", "hǎotīng", "pleasant to hear"],
    [
      "本事",
      "本事",
      "běnshi",
      "ability; skill; capability; (-shì: this matter; literary source)"
    ],
    ["急忙", "急忙", "jímáng", "in a hurry; in haste; hurriedly; hastily"],
    ["接近", "接近", "jiējìn", "near; to be close to; to approach"],
    ["适当", "適當", "shìdàng", "suitable; appropriate; proper"],
    ["采用", "采用", "cǎiyòng", "adopt; employ; use"],
    ["因而", "因而", "yīn'ér", "therefore; as a result; thus"],
    ["战斗", "戰斗", "zhàndòu", "to fight; to battle; to struggle"],
    ["运用", "運用", "yùnyòng", "to use; apply; wield; utilize"],
    ["科研", "科研", "kēyán", "scientific research"],
    ["从而", "從而", "cóng'ér", "thus; thereby; as a result"],
    ["原料", "原料", "yuánliào", "raw material; ingredients"],
    ["确定", "確定", "quèdìng", "define; determine; definite; certain"],
    [
      "当前",
      "當前",
      "dāngqián",
      "facing one; current; today's; modern; present"
    ],
    [
      "实事求是",
      "實事求是",
      "shí shì qiú shì",
      "be practical and realistic; seek truth from facts"
    ],
    ["竞争", "競爭", "jìngzhēng", "compete; competition"],
    ["科技", "科技", "kējì", "science and technology"],
    ["反而", "反而", "fǎn'ér", "on the contrary; instead"],
    ["当初", "當初", "dāngchū", "at that time; at the outset; originally"],
    ["事务", "事務", "shìwù", "work; routine; general affairs"],
    ["当中", "當中", "dāngzhōng", "among; in the middle; in the center"],
    ["用品", "用品", "yòngpǐn", "articles for use; products; goods"],
    ["当代", "當代", "dāngdài", "present day; contemporary"],
    ["歌曲", "歌曲", "gēqǔ", "song"],
    ["事故", "事故", "shìgù", "accident; mishap"],
    ["所在", "所在", "suǒzài", "location; place; whereabouts"],
    ["制作", "制作", "zhìzuò", "make; manufacture"],
    ["逝世", "逝世", "shìshì", "to pass away; to die"],
    ["农作物", "農作物", "nóngzuòwù", "(farm) crops"],
    ["人群", "人群", "rénqún", "crowd"],
    ["打扫", "打掃", "dǎsǎo", "to clean; to sweep"],
    ["心事", "心事", "xīnshì", "sth. weighing on one's mind; a worry"],
    ["极端", "极端", "jíduān", "extreme"],
    ["内科", "內科", "nèikē", "internal medicine; general medicine"],
    ["出事", "出事", "chū shì", "have an accident; meet with a mishap"],
    ["外科", "外科", "wàikē", "surgical department"],
    ["正当", "正當", "zhèngdāng", "timely; just when, (dàng) proper"],
    ["端正", "端正", "duānzhèng", "upright; regular; proper; correct"],
    [
      "力争",
      "力爭",
      "lìzhēng",
      "work hard; do all one can to; strive for; argue strongly"
    ],
    ["妇人", "婦人", "fùrén", "woman; married woman"],
    ["中断", "中斷", "zhōngduàn", "interrupt; break off"],
    ["折合", "折合", "zhéhé", "convert into (currency); amount to"],
    ["曲折", "曲折", "qūzhé", "winding; zigzag; complicated"],
    ["用心", "用心", "yòngxīn", "motive; intention; attentively; diligently"],
    ["养料", "養料", "yǎngliào", "nutriment; nourishment"],
    ["协作", "協作", "xiézuò", "cooperation; coordination"],
    ["雪花", "雪花", "xuěhuā", "snowflake"],
    ["日用", "日用", "rìyòng", "of everyday use"],
    ["作物", "作物", "zuòwù", "crop"],
    ["必需", "必需", "bìxū", "essential; indispensable"],
    ["学科", "學科", "xuékē", "subject; branch of learning; course"],
    ["染料", "染料", "rǎnliào", "dye"],
    ["近代", "近代", "jìndài", "modern times; latest generation"],
    ["公用", "公用", "gōngyòng", "public; for public use"],
    [
      "作战",
      "作戰",
      "zuò zhàn",
      "to conduct (military operations); to fight; combat"
    ],
    ["档案", "檔案", "dàng'àn", "file; record; archive"],
    [
      "当家",
      "當家",
      "dāng jiā",
      "manage household affairs; have the final say; take the leading part"
    ],
    ["同事", "同事", "tóngshì", "colleague; co-worker"],
    ["夫妇", "夫婦", "fūfù", "married couple; husband and wife"],
    ["场所", "場所", "chǎngsuǒ", "location; place"],
    ["需求", "需求", "xūqiú", "requirement; demand (economics)"],
    [
      "信用",
      "信用",
      "xìnyòng",
      "one's credit (i.e. trustworthiness); credit (i.e. possible bank loan)"
    ],
    [
      "录取",
      "錄取",
      "lùqǔ",
      "select and admit, enroll (qualified people); recruit"
    ],
    ["刑事", "刑事", "xíngshì", "criminal; penal"],
    ["而已", "而已", "éryǐ", "that's all; nothing more"],
    [
      "工事",
      "工事",
      "gōngshì",
      "structures used to protect military troops; fortifications"
    ],
    ["急需", "急需", "jíxū", "urgently need"],
    ["录用", "錄用", "lùyòng", "hire as an employee; employ"],
    [
      "油料",
      "油料",
      "yóuliào",
      "oil plants; vegetable material that can be pressed to extract oil"
    ],
    ["失事", "失事", "shī shì", "be involved in a crash; (have an) accident"],
    ["往事", "往事", "wǎngshì", "past events; the past; former happenings"],
    ["事例", "事例", "shìlì", "example; exemplar; typical case"],
    ["住所", "住所", "zhùsuǒ", "habitation; residence"],
    ["动用", "動用", "dòngyòng", "put something to use; utilize"],
    ["近视", "近視", "jìnshì", "shortsighted; nearsighted; myopia"],
    ["当场", "當場", "dāngchǎng", "at the scene; on the spot"],
    ["曲子", "曲子", "qǔzi", "folk tune; music; melody"],
    ["作主", "作主", "zuò zhǔ", "to decide; make decisions"],
    [
      "尖端",
      "尖端",
      "jiānduān",
      "highest peak; the tip; sharp pointed end; most advanced and sophisticated"
    ],
    [
      "上诉",
      "上訴",
      "shàngsù",
      "to appeal (a judicial case); appeal (to a higher court)"
    ],
    ["确切", "確切", "quèqiè", "definite; exact; precise"],
    ["事态", "事態", "shìtài", "situation; existing state of affairs"],
    [
      "副作用",
      "副作用",
      "fùzuòyòng",
      "side effect; by-effect; <mechanics> secondary action"
    ],
    [
      "作法",
      "作法",
      "zuòfǎ",
      "course of action; method of doing something; practice"
    ],
    ["意料", "意料", "yìliào", "expectation; to anticipate; to think ahead"],
    ["寻求", "尋求", "xúnqiú", "seek; look for"],
    ["近似", "近似", "jìnsì", "similar; about the same"],
    ["当选", "當選", "dāngxuǎn", "be elected"],
    ["听取", "聽取", "tīngqǔ", "to hear (news) of; to listen to"],
    ["净化", "淨化", "jìnghuà", "purify; cleanse"],
    ["作案", "作案", "zuò àn", "commit a crime"],
    ["斗志", "斗志", "dòuzhì", "will to fight"],
    ["用具", "用具", "yòngjù", "appliance; utensil; tool"],
    [
      "怎么着",
      "怎麼着",
      "zěnmezhe",
      "whatever, used to replace some verbs in a sentence to form a more general sentence"
    ],
    [
      "无所作为",
      "無所作為",
      "wú suǒ zuò wéi",
      "(saying) coasting; without any initiative or drive"
    ],
    ["用法", "用法", "yòngfǎ", "usage"],
    ["选用", "選用", "xuǎnyòng", "select and put to use"],
    ["确立", "確立", "quèlì", "to establish; to institute"],
    ["雪白", "雪白", "xuěbái", "(adj) snow-white"],
    ["顶端", "頂端", "dǐngduān", "top; peak; apex"],
    ["军用", "軍用", "jūnyòng", "(for) military use"],
    ["档次", "檔次", "dàngcì", "grade; quality; class; level"],
    [
      "加急",
      "加急",
      "jiājí",
      "require urgent measures to handle a matter; become more urgent"
    ],
    ["当局", "當局", "dāngjú", "authorities"],
    ["当天", "當天", "dàngtiān", "that day; the same day"],
    ["备用", "備用", "bèiyòng", "reserve; spare; alternate"],
    ["事项", "事項", "shìxiàng", "matter; item"],
    [
      "还是",
      "還是",
      "háishi",
      "or (for questions only); still; yet; nevertheless; had better"
    ],
    ["不同", "不同", "bùtóng", "different; distinct; not the same"],
    ["态度", "態度", "tàidu", "manner; bearing; attitude; approach"],
    ["不错", "不錯", "búcuò", "not bad; pretty good; correct"],
    ["不久", "不久", "bùjiǔ", "not long (after); soon"],
    ["错误", "錯誤", "cuòwù", "error; mistake; mistaken"],
    [
      "不如",
      "不如",
      "bùrú",
      "not as good as; inferior to; it would be better to"
    ],
    ["图片", "圖片", "túpiàn", "image; picture; photograph"],
    ["否认", "否認", "fǒurèn", "deny; declare to be untrue"],
    ["判处", "判處", "pànchǔ", "to sentence; condemn"],
    ["卡片", "卡片", "kǎpiàn", "card"],
    [
      "不得已",
      "不得已",
      "bùdéyǐ",
      "act against one's will; have no alternative"
    ],
    ["不等", "不等", "bùděng", "vary; differ; different"],
    ["胖子", "胖子", "pàngzi", "fat person"],
    ["宴席", "宴席", "yànxí", "banquet; feast"],
    [
      "无微不至",
      "無微不至",
      "wú wēi bú zhì",
      "in every possible way; meticulously; scrupulous"
    ],
    ["不容", "不容", "bùróng", "not to tolerate; not allow; not brook"],
    [
      "半边天",
      "半邊天",
      "bànbiāntiān",
      "half of the sky; women of the new society"
    ],
    ["半数", "半數", "bànshù", "half the number"],
    [
      "反之",
      "反之",
      "fǎnzhī",
      "whereas ...; on the other hand ...; conversely ..."
    ],
    [
      "顾不得",
      "顧不得",
      "gù bu de",
      "unable to change sth.; unable to deal with"
    ],
    ["不公", "不公", "bùgōng", "unjust; unfair"],
    ["密度", "密度", "mìdù", "density; thickness; consistency"],
    ["季度", "季度", "jìdù", "(financial) quarter; period of three months"],
    [
      "首席",
      "首席",
      "shǒuxí",
      "chief (representative, correspondent, etc.); chairman; seat of honor"
    ],
    ["透明度", "透明度", "tòumíngdù", "transparency; (policy) of openness"],
    ["厚度", "厚度", "hòudù", "thickness"],
    ["判定", "判定", "pàndìng", "to judge; decide; judgment; determine"],
    ["贫乏", "貧乏", "pínfá", "lacking; incomplete"],
    [
      "年度",
      "年度",
      "niándù",
      "year (e.g. school year, fiscal year, etc.); annual"
    ],
    [
      "川流不息",
      "川流不息",
      "chuān liú bù xī",
      "lit. the stream flows without stopping (idiom); unending flow; flowing past in an endless stream; never-ending"
    ],
    ["不得", "不得", "bùdé", "must not; may not; not be allowed"],
    ["不当", "不當", "búdàng", "unsuitable; improper; inappropriate"],
    ["极度", "极度", "jídù", "extremely"],
    ["不妨", "不妨", "bùfáng", "there is no harm in; might as well"],
    [
      "讨价还价",
      "討價還價",
      "tǎo jià huán jià",
      "bargaining; haggle over price"
    ],
    ["不定", "不定", "búdìng", "indefinite; indeterminate; adventitious"],
    ["浓度", "濃度", "nóngdù", "concentration; thickness; consistency"],
    ["不时", "不時", "bùshí", "from time to time; sometimes"],
    ["难度", "難度", "nándù", "difficulty level; difficulty; problem"],
    [
      "席位",
      "席位",
      "xíwèi",
      "seat (in a theater stadium, etc.); parliamentary or congressional seat"
    ],
    ["过度", "過度", "guòdù", "excessive; exceeding; lavishly"],
    [
      "敬而远之",
      "敬而遠之",
      "jìng ér yuǎn zhī",
      "show respect from a distance"
    ],
    ["败坏", "敗壞", "bàihuài", "to ruin; to corrupt; undermine"],
    [
      "好坏",
      "好壞",
      "hǎohuài",
      "good and bad; advantageous and disadvantageous"
    ],
    ["格格不入", "格格不入", "gé gé bú rù", "inharmonious; incompatible"],
    ["伴侣", "伴侶", "bànlv3", "companion; partner; mate"],
    [
      "差错",
      "差錯",
      "chācuò",
      "error (in data transmission); mistake; an accident"
    ],
    [
      "不相上下",
      "不相上下",
      "bù xiāng shàng xià",
      "equally matched; about the same"
    ],
    ["不法", "不法", "bùfǎ", "lawless; illegal; unlawful"],
    [
      "还原",
      "還原",
      "huányuán",
      "restore to the original state; (Chemistry) reduce; (Music) natural"
    ],
    ["渡口", "渡口", "dùkǒu", "ferry crossing"],
    [
      "列席",
      "列席",
      "lièxí",
      "attend a meeting as a delegate without voting rights"
    ],
    ["一度", "一度", "yídù", "for a time; at one time; one time; once"],
    ["调度", "調度", "diàodù", "to dispatch; to schedule"],
    ["知道", "知道", "zhīdao", "know; be aware of"],
    ["知识", "知識", "zhīshi", "knowledge; intellectual"],
    ["富强", "富強", "fùqiáng", "rich and powerful; wealth and power"],
    [
      "引人注目",
      "引人注目",
      "yǐn rén zhùmù",
      "attract attention; striking; conspicuous; noticeable; eye-catching"
    ],
    ["减弱", "減弱", "jiǎnruò", "weaken; fall off"],
    [
      "可想而知",
      "可想而知",
      "kě xiǎng érzhī",
      "you can imagine; it is obvious that"
    ],
    ["柔和", "柔和", "róuhé", "gentle; soft; mild"],
    ["临近", "臨近", "línjìn", "to approach; draw near"],
    ["预算", "預算", "yùsuàn", "budget"],
    ["灵巧", "靈巧", "língqiǎo", "handy; skillful; deft"],
    [
      "引诱",
      "引誘",
      "yǐnyòu",
      "tempt; entice; coerce somebody into doing something bad"
    ],
    ["来临", "來臨", "láilín", "near; come closer"],
    [
      "加班",
      "加班",
      "jiā bān",
      "work overtime; work an extra shift; work extra hours"
    ],
    [
      "接班",
      "接班",
      "jiē bān",
      "work one's shift; be a successor to sb.; take over a task"
    ],
    ["予以", "予以", "yǔyǐ", "give; pay out; bestow"],
    ["班子", "班子", "bānzi", "organized group; theater troupe"],
    ["代号", "代號", "dàihào", "code name"],
    ["学校", "學校", "xuéxiào", "school; campus"],
    ["比较", "比較", "bǐjiào", "comparatively; relatively; compare; contrast"],
    ["老师", "老師", "lǎoshī", "teacher"],
    ["教育", "教育", "jiàoyù", "education"],
    ["或者", "或者", "huòzhě", "or; possibly; maybe; perhaps"],
    ["身体", "身體", "shēntǐ", "health; (human) body"],
    ["考试", "考試", "kǎoshì", "test; exam; give or take a test"],
    ["足球", "足球", "zúqiú", "football; soccer"],
    ["感谢", "感謝", "gǎnxiè", "thank; be grateful"],
    ["谢谢", "謝謝", "xièxie", "to thank; thank you"],
    ["跑步", "跑步", "pǎo bù", "to run; to jog"],
    ["教室", "教室", "jiàoshì", "classroom"],
    ["听写", "聽寫", "tīngxiě", "to dictate; dictation"],
    ["记者", "記者", "jìzhě", "reporter; journalist"],
    [
      "交流",
      "交流",
      "jiāoliú",
      "communicate; exchange; give and take; interaction; to alternate"
    ],
    ["教授", "教授", "jiàoshòu", "professor; instruct; to lecture"],
    ["有效", "有效", "yǒuxiào", "effective; valid"],
    [
      "尽管",
      "儘管",
      "jǐnguǎn",
      "despite; although; do not hesitate (to ask, complain etc); feel free"
    ],
    ["管理", "管理", "guǎnlǐ", "supervise; manage"],
    ["著名", "著名", "zhùmíng", "famous; well-known; celebrated"],
    ["外交", "外交", "wàijiāo", "diplomacy; foreign affairs"],
    ["公路", "公路", "gōnglù", "highway; road"],
    ["不管", "不管", "bùguǎn", "no matter (what, how, etc.); regardless of"],
    ["教学", "教學", "jiàoxué", "education; teach (school)"],
    ["老板", "老板", "lǎobǎn", "boss; proprietor; shopkeeper"],
    [
      "老人",
      "老人",
      "lǎorén",
      "old people; the aged; one's aged parents or grandparents"
    ],
    ["铁路", "鐵路", "tiělù", "railroad"],
    ["古老", "古老", "gǔlǎo", "ancient; old"],
    ["教师", "教師", "jiàoshī", "teacher"],
    ["路上", "路上", "lùshang5", "on the way; on a journey; road surface"],
    ["道路", "道路", "dàolù", "road; path; way"],
    ["教训", "教訓", "jiàoxùn", "lesson; a moral"],
    ["老实", "老實", "lǎoshi", "honest; sincere; naive; simpleminded"],
    ["读者", "讀者", "dúzhě", "reader (of books, newspaper, etc)"],
    ["身边", "身邊", "shēnbiān", "at or by one's side"],
    ["坚持", "堅持", "jiānchí", "persist in; persevere"],
    ["弟弟", "弟弟", "dìdi", "younger brother"],
    ["预习", "預習", "yùxí", "prepare a lesson before class; preview"],
    ["单位", "單位", "dānwèi", "unit (of measurement); work unit"],
    ["强调", "強調", "qiángdiào", "emphasize; to stress"],
    ["加强", "加強", "jiāqiáng", "strengthen; reinforce; enhance"],
    [
      "上班",
      "上班",
      "shàng bān",
      "go to work; be on duty; start work; go to the office"
    ],
    ["引起", "引起", "yǐnqǐ", "give rise to; lead to; to draw; attract"],
    ["吸引", "吸引", "xīyǐn", "attract; fascinate; appeal to"],
    ["预备", "預備", "yùbèi", "prepare; make ready"],
    ["消费", "消費", "xiāofèi", "consume; consumption; spending"],
    ["兄弟", "兄弟", "xiōngdì", "brothers; younger brother; brethren"],
    ["费用", "費用", "fèiyòng", "expenses; expenditures; costs"],
    ["挂号", "掛號", "guàhào", "register; check in; send by registered mail"],
    ["下班", "下班", "xià bān", "get off work; finish work"],
    ["强烈", "強烈", "qiángliè", "intense; strong; violent"],
    ["口号", "口號", "kǒuhào", "slogan; catchphrase"],
    ["学费", "學費", "xuéfèi", "tuition"],
    ["坚定", "堅定", "jiāndìng", "firm; staunch; resolute"],
    ["公费", "公費", "gōngfèi", "(at) public (or state) expense"],
    ["强大", "強大", "qiángdà", "large; formidable; powerful"],
    ["号召", "號召", "hàozhào", "call upon; summon; to appeal"],
    ["巧妙", "巧妙", "qiǎomiào", "ingenious; clever"],
    ["坚强", "堅強", "jiānqiáng", "strong (in character); staunch"],
    ["强度", "強度", "qiángdù", "intensity; strength"],
    ["自费", "自費", "zìfèi", "at one's own expense"],
    ["单调", "單調", "dāndiào", "monotonous; dull"],
    ["临时", "臨時", "línshí", "temporary; at the time; when the time comes"],
    ["坐班", "坐班", "zuòbān", "work/keep office hours; on duty"],
    ["田野", "田野", "tiányě", "field; open country"],
    ["增强", "增強", "zēngqiáng", "reinforce; strengthen; to increase"],
    ["引导", "引導", "yǐndǎo", "to guide; to lead; to show around;"],
    [
      "to mentor; to give guidance to;  {computing} boot up; bootstrap;",
      "",
      "",
      ""
    ],
    ["introduction; primer", "", "", ""],
    ["技巧", "技巧", "jìqiǎo", "skill; technique"],
    ["信号", "信號", "xìnhào", "signal"],
    ["原子弹", "原子彈", "yuánzǐdàn", "atom bomb"],
    [
      "光临",
      "光臨",
      "guānglín",
      "(polite) welcome!; honor somebody with one's presence"
    ],
    [
      "知识分子",
      "知識分子",
      "zhīshi fènzǐ",
      "intellectual; the intelligentsia"
    ],
    ["预先", "預先", "yùxiān", "beforehand; prior"],
    ["子弹", "子彈", "zǐdàn", "bullet; cartridge"],
    ["坚硬", "堅硬", "jiānyìng", "hard; solid"],
    ["柔软", "柔軟", "róuruǎn", "soft"],
    ["可巧", "可巧", "kěqiǎo", "by happy coincidence"],
    ["软弱", "軟弱", "ruǎnruò", "weak; feeble; flabby"],
    ["程序", "程序", "chéngxù", "procedure; sequence; computer program"],
    ["弟兄", "弟兄", "dìxiong5", "brothers; comrade"],
    ["坚固", "堅固", "jiāngù", "firm; strong; sturdy"],
    ["预告", "預告", "yùgào", "advance notice; to herald"],
    ["指引", "指引", "zhǐyǐn", "to guide; to show"],
    ["导弹", "導彈", "dǎodàn", "guided missile; cruise missile"],
    ["单独", "單獨", "dāndú", "alone; on one's own; independent"],
    ["著作", "著作", "zhùzuò", "work; book; writing"],
    ["作者", "作者", "zuòzhě", "author; writer"],
    ["滑冰", "滑冰", "huá bīng", "to go ice-skating; to skate"],
    ["动身", "動身", "dòng shēn", "go on a journey; leave"],
    ["老是", "老是", "lǎoshì", "always; all the time; used to"],
    ["骨头", "骨頭", "gǔtou", "bone; moral character"],
    ["老头儿", "老頭兒", "lǎotóur5", "old man (impolite); old chap"],
    ["充足", "充足", "chōngzú", "adequate; sufficient; abundant"],
    [
      "老太太",
      "老太太",
      "lǎotàitai",
      "elderly lady (respectful); (in direct address) Venerable Madam; esteemed mother; (a polite term) your mother; his mother; my mother or grandmother; M:位"
    ],
    ["效果", "效果", "xiàoguǒ", "effect; result"],
    ["教员", "教員", "jiàoyuán", "teacher; instructor"],
    ["学者", "學者", "xuézhě", "scholar"],
    ["宗教", "宗教", "zōngjiào", "religion"],
    ["交易", "交易", "jiāoyì", "business transaction; deal; trade"],
    ["佛教", "佛教", "Fójiào", "Buddhism; Buddhist"],
    ["考察", "考察", "kǎochá", "inspect; investigate; analyze"],
    ["追求", "追求", "zhuīqiú", "pursue; seek; woo"],
    ["不足", "不足", "bùzú", "insufficient; not enough"],
    ["身份", "身份", "shēnfèn", "identity; status; capacity"],
    ["自身", "自身", "zìshēn", "itself; oneself"],
    ["交谈", "交談", "jiāotán", "to converse; to chat"],
    ["滑雪", "滑雪", "huáxuě", "to ski; skiing"],
    ["老婆", "老婆", "lǎopo", "wife (informal)"],
    ["爱好者", "愛好者", "àihàozhě", "enthusiast; fan"],
    ["路口", "路口", "lùkǒu", "intersection (of roads); crossing"],
    ["思考", "思考", "sīkǎo", "reflect on; ponder; consider"],
    ["打交道", "打交道", "dǎ jiāodao", "come into contact with; deal with"],
    ["器官", "器官", "qìguān", "organ (of the body); apparatus"],
    ["教堂", "教堂", "jiàotáng", "church; chapel; cathedral"],
    ["保管", "保管", "bǎoguǎn", "assure; take care of; surely"],
    ["路过", "路過", "lùguò", "pass by or through (a place)"],
    ["注射", "注射", "zhùshè", "injection; inject (medicine)"],
    ["交待", "交待", "jiāodài", "explain; to tell"],
    ["教导", "教導", "jiàodǎo", "instruct; teach; give guidance"],
    ["本身", "本身", "běnshēn", "itself; in itself; per se"],
    ["出身", "出身", "chūshēn", "Class origin, family background;"],
    ["One's previous professional experience", "", "", ""],
    ["出路", "出路", "chūlù", "a way out; outlet"],
    ["身子", "身子", "shēnzi", "body; pregnancy"],
    ["老人家", "老人家", "lǎoren5jia", "(polite term for an old person)"],
    ["军官", "軍官", "jūnguān", "military officer"],
    ["管子", "管子", "guǎnzi", "tube; pipe; drinking straw"],
    ["光滑", "光滑", "guānghuá", "glossy; sleek; smooth"],
    [
      "管道",
      "管道",
      "guǎndào",
      "pipeline; conduit; piping; channel (for communication etc.)"
    ],
    ["跳动", "跳動", "tiàodòng", "pulsate; to beat"],
    ["教研室", "教研室", "jiàoyánshì", "teaching and research section"],
    ["天主教", "天主教", "Tiānzhǔjiào", "Catholic church; Catholicism"],
    ["老年", "老年", "lǎonián", "elderly; old age"],
    ["写作", "寫作", "xiězuò", "write; writing; composition"],
    [
      "交往",
      "交往",
      "jiāowǎng",
      "associate (with); have contact (with); to date"
    ],
    ["校园", "校園", "xiàoyuán", "campus; schoolyard"],
    ["床单", "床單", "chuángdān", "bed sheet"],
    ["费力", "費力", "fèi lì", "great effort; to strain (oneself)"],
    [
      "顽强",
      "頑強",
      "wánqiáng",
      "indomitable; staunch; tenacious; hard to defeat"
    ],
    ["工序", "工序", "gōngxù", "working procedure; process"],
    [
      "单元",
      "單元",
      "dānyuán",
      "unit; module; element; (in a residential building) entrance or staircase"
    ],
    ["花费", "花費", "huāfèi", "expense; cost; spend (time or money)"],
    ["预定", "預定", "yùdìng", "schedule in advance; predetermine"],
    ["赋予", "賦予", "fùyǔ", "confer upon; bestow; endow; entrust (a task)"],
    ["强制", "強制", "qiángzhì", "enforce; control; coerce"],
    [
      "野外",
      "野外",
      "yěwài",
      "open country; undeveloped areas outside the city; wilderness"
    ],
    ["弥补", "彌補", "míbǔ", "make up for a deficiency; remedy; offset"],
    ["顺序", "順序", "shùnxù", "sequence; order"],
    [
      "班机",
      "班機",
      "bānjī",
      "airliner; regular air service; scheduled flight"
    ],
    ["菜单", "菜單", "càidān", "menu; bill of fare"],
    ["型号", "型號", "xínghào", "model number; type"],
    ["坚实", "堅實", "jiānshí", "firm and substantial; solid"],
    ["名单", "名單", "míngdān", "list (of names); roster; roll"],
    ["预料", "預料", "yùliào", "anticipate; predict; forecast; expectation"],
    ["削弱", "削弱", "xuēruò", "weaken; to cripple"],
    ["引入", "引入", "yǐnrù", "draw into; introduce from elsewhere; lead into"],
    ["弥漫", "彌漫", "mímàn", "fill the air; permeate; suffuse"],
    ["称号", "稱號", "chēnghào", "title; term of address; name; designation"],
    ["野心", "野心", "yěxīn", "ambition; wild schemes or ambitions; careerism"],
    ["引用", "引用", "yǐnyòng", "quote; cite"],
    [
      "正巧",
      "正巧",
      "zhèngqiǎo",
      "just by chance; just at the right time; opportune"
    ],
    ["预见", "預見", "yùjiàn", "foresee; envision; predict; intuition"],
    [
      "众所周知",
      "眾所周知",
      "zhòng suǒ zhōu zhī",
      "as everyone well knows; as is known to all"
    ],
    ["次序", "次序", "cìxù", "sequence; order"],
    ["才智", "才智", "cáizhì", "ability and wisdom; intellect; wits"],
    ["记号", "記號", "jìhào", "mark; seal; notation"],
    ["临床", "臨床", "línchuáng", "clinical"],
    ["预测", "預測", "yùcè", "forecast; predict"],
    ["号称", "號稱", "hàochēng", "be known by reputation as; to claim"],
    ["种族", "種族", "zhǒngzú", "race; ethnicity"],
    ["夜班", "夜班", "yèbān", "night shift"],
    ["授予", "授予", "shòuyǔ", "to award; confer"],
    ["视野", "視野", "shìyě", "field of view; horizon"],
    ["无知", "無知", "wúzhī", "ignorance; ignorant"],
    ["预言", "預言", "yùyán", "predict; prophecy"],
    ["序言", "序言", "xùyán", "foreword; preface of a book [xuyan]"],
    ["预计", "預計", "yùjì", "forecast; predict; estimate"],
    ["不知不觉", "不知不覺", "bù zhī bù jué", "unconsciously; unwittingly"],
    ["强化", "強化", "qiánghuà", "strengthen; intensify"],
    ["弱点", "弱點", "ruòdiǎn", "weak point; failing"],
    ["子弟", "子弟", "zǐdì", "children; the younger generation"],
    ["知觉", "知覺", "zhījué", "perception; consciousness; feeling"],
    ["坚信", "堅信", "jiānxìn", "believe firmly without any doubt"],
    ["智力", "智力", "zhìlì", "intelligence; intellect"],
    ["机智", "機智", "jīzhì", "tact; quick-witted; resourceful"],
    ["值班", "值班", "zhí bān", "be on duty; work a shift"],
    ["官员", "官員", "guānyuán", "officer; administrator"],
    [
      "主管",
      "主管",
      "zhǔguǎn",
      "person in charge of (a position, etc.); preside over; be in charge of"
    ],
    ["官方", "官方", "guānfāng", "official; (by the) government"],
    ["提交", "提交", "tíjiāo", "submit (a report, etc.); refer (a problem) to"],
    ["法官", "法官", "fǎguān", "a judge"],
    ["人身", "人身", "rénshēn", "person; personal"],
    ["高考", "高考", "gāokǎo", "college entrance exam"],
    [
      "足以",
      "足以",
      "zúyǐ",
      "sufficient to ...; so much so that; sufficiently"
    ],
    ["老家", "老家", "lǎojiā", "native place; place of origin; hometown"],
    ["半路", "半路", "bànlù", "halfway; midway; on the way"],
    ["与此同时", "與此同時", "yǔ cǐ tóng shí", "at the same time; meanwhile"],
    [
      "立交桥",
      "立交橋",
      "lìjiāoqiáo",
      "overpass; one road goes on top of another; cloverleaf intersection"
    ],
    [
      "美中不足",
      "美中不足",
      "měi zhōng bù zú",
      "everything is fine except for one small defect (idiom); the fly in the ointment"
    ],
    ["跑道", "跑道", "pǎodào", "racetrack; runway"],
    [
      "微不足道",
      "微不足道",
      "wēi bù zú dào",
      "negligible; insignificant; not worth mentioning"
    ],
    [
      "一身",
      "一身",
      "yìshēn",
      "from head to toe; the whole body; a suit of clothes"
    ],
    ["老成", "老成", "lǎochéng", "experienced; trained"],
    [
      "起身",
      "起身",
      "qǐ shēn",
      "to get up; to get out of bed; to leave; to set forth"
    ],
    ["失效", "失效", "shī xiào", "fail; lose effectiveness; expire"],
    ["教会", "教會", "jiàohuì", "Christian church; ecclesiastic"],
    ["路程", "路程", "lùchéng", "course; route; path traveled; journey"],
    ["十足", "十足", "shízú", "full of; complete; 100 percent"],
    ["路子", "路子", "lùzi", "method; way; approach"],
    ["考取", "考取", "kǎo qǔ", "pass an entrance test"],
    ["考古", "考古", "kǎogǔ", "archaeology"],
    ["跳远", "跳遠", "tiàoyuǎn", "{athletics} long jump"],
    ["填写", "填寫", "tiánxiě", "fill in or write in a blank spot on a form"],
    ["交点", "交點", "jiāodiǎn", "point of intersection; node"],
    ["老汉", "老漢", "lǎohàn", "old man; (old man referring to himself)"],
    ["骨肉", "骨肉", "gǔròu", "flesh and blood; kindred; kinship"],
    ["教条", "教條", "jiàotiáo", "religious dogma; creed; doctrine"],
    ["见效", "見效", "jiànxiào", "take effect; produce results"],
    [
      "效力",
      "效力",
      "xiàolì",
      "effectiveness; efficacy; serve (in some capacity)"
    ],
    ["杂交", "雜交", "zájiāo", "create a hybrid; cross-fertilize"],
    ["交错", "交錯", "jiāocuò", "crisscross; stagger; interlace"],
    ["追查", "追查", "zhuīchá", "investigate; track down"],
    ["放射", "放射", "fàngshè", "radiate; radioactive"],
    [
      "老太婆",
      "老太婆",
      "lǎotàipó",
      "old woman (not polite); term to refer to wife"
    ],
    [
      "反射",
      "反射",
      "fǎnshè",
      "to reflect; reflection (from a mirror, etc.); reflex"
    ],
    ["交付", "交付", "jiāofù", "hand over; deliver"],
    ["老化", "老化", "lǎohuà", "aging; becoming old (person or thing)"],
    ["较量", "較量", "jiàoliàng", "competition; to have a contest with sb."],
    ["计较", "計較", "jìjiào", "fuss about; haggle; bicker; argue"],
    ["上交", "上交", "shàngjiāo", "hand in; give to higher authority"],
    ["照射", "照射", "zhàoshè", "irradiate; shine on; light up"],
    ["成效", "成效", "chéngxiào", "effect; result"],
    [
      "相交",
      "相交",
      "xiāngjiāo",
      "cross over (e.g. traffic); intersect; make friends"
    ],
    ["交手", "交手", "jiāo shǒu", "fight hand to hand; compete in a match"],
    ["逃跑", "逃跑", "táopǎo", "flee from sth.; run away; escape"],
    [
      "交涉",
      "交涉",
      "jiāoshè",
      "negotiate; discuss a matter with the opposing side"
    ],
    ["直线", "直線", "zhíxiàn", "straight line; beeline"],
    [
      "断断续续",
      "斷斷續續",
      "duànduàn xùxù",
      "intermittently; off and on; discontinuous"
    ],
    [
      "轻便",
      "輕便",
      "qīngbiàn",
      "lightweight and portable; light and convenient"
    ],
    [
      "公约",
      "公約",
      "gōngyuē",
      "joint pledge; pact; convention (i.e. international agreement)"
    ],
    ["曲线", "曲線", "qūxiàn", "curved shape; indirectly; roundabout"],
    ["细小", "細小", "xìxiǎo", "tiny; petty; wee; minute"],
    ["等级", "等級", "děngjí", "degree; rate; social standing"],
    ["防线", "防線", "fángxiàn", "line of defense; perimeter"],
    ["财经", "財經", "cáijīng", "finance and economics"],
    [
      "经受",
      "經受",
      "jīngshòu",
      "to undergo (hardship); to endure; to withstand"
    ],
    ["天线", "天線", "tiānxiàn", "antenna; mast"],
    ["失约", "失約", "shī yuē", "miss an appointment"],
    ["阵线", "陣線", "zhènxiàn", "front (i.e. militant group)"],
    ["终端", "終端", "zhōngduān", "end; terminal"],
    ["鲜红", "鮮紅", "xiānhóng", "bright red"],
    ["统战", "統戰", "tǒngzhàn", "united front; consolidation"],
    [
      "预约",
      "預約",
      "yùyuē",
      "to reserve; to make an appointment; to book in advance; reservation"
    ],
    ["结算", "結算", "jiésuàn", "settle up the bill; close an account"],
    ["经商", "經商", "jīng shāng", "trade; be in business; do commerce"],
    [
      "通过",
      "通過",
      "tōngguò",
      "by means of; through (a method); pass through; via; pass (a test)"
    ],
    ["服务", "服務", "fúwù", "serve; service"],
    ["领导", "領導", "lǐngdǎo", "to lead; leader; leadership"],
    ["通知", "通知", "tōngzhī", "notify; to inform; notice"],
    ["节目", "節目", "jiémù", "program; item (on a program)"],
    ["衣服", "衣服", "yīfu", "clothes"],
    ["节日", "節日", "jiérì", "holiday; festival"],
    ["服务员", "服務員", "fúwùyuán", "waiter/waitress; server; attendant"],
    ["贸易", "貿易", "màoyì", "(commercial) trade"],
    ["交通", "交通", "jiāotōng", "traffic; transportation; communication"],
    ["创造", "創造", "chuàngzào", "create; bring about; creativity"],
    ["报名", "報名", "bào míng", "sign up; apply"],
    [
      "报告",
      "報告",
      "bàogào",
      "to report; make known; inform; speech; lecture"
    ],
    ["季节", "季節", "jìjié", "season; time; period"],
    ["创作", "創作", "chuàngzuò", "create; to produce; creative work"],
    [
      "零钱",
      "零錢",
      "língqián",
      "small change (of money); pocket money; income other than one's salary or wages"
    ],
    ["危机", "危機", "wēijī", "crisis"],
    [
      "拼命",
      "拼命",
      "pīn mìng",
      "to risk one's life; exerting the utmost strength; with all one's might; at all costs; desperately"
    ],
    ["服从", "服從", "fúcóng", "obey; comply; go along with"],
    ["报道", "報道", "bàodào", "to report; coverage in a newspaper"],
    [
      "保留",
      "保留",
      "bǎoliú",
      "to reserve; hold back; retain; continue to have; keep"
    ],
    ["节省", "節省", "jiéshěng", "save; use sparingly; frugal"],
    ["勇敢", "勇敢", "yǒnggǎn", "brave; courageous"],
    ["节约", "節約", "jiéyuē", "economize; frugal; to save"],
    ["本领", "本領", "běnlǐng", "skill; ability; capability"],
    ["命运", "命運", "mìngyùn", "fate; destiny"],
    ["聊天儿", "聊天兒", "liáotiānr5", "to chat"],
    ["报到", "報到", "bàodào", "report for duty; check in; register"],
    ["命令", "命令", "mìnglìng", "an order; a command"],
    ["克服", "克服", "kèfú", "overcome; conquer"],
    ["保卫", "保衛", "bǎowèi", "defend; to safeguard"],
    ["孝顺", "孝順", "xiàoshùn", "filial piety"],
    [
      "教养",
      "教養",
      "jiàoyǎng",
      "upbringing; education; bring up; nurture and train"
    ],
    ["交替", "交替", "jiāotì", "supersede; replace; alternately; in turn"],
    ["以身作则", "以身作則", "yǐ shēn zuò zé", "set a good example"],
    [
      "成交",
      "成交",
      "chéngjiāo",
      "conclude a transaction; complete a contract; clinch a deal; to seal"
    ],
    ["无效", "無效", "wúxiào", "not valid; ineffective; in vain"],
    ["跳高", "跳高", "tiàogāo", "high jump (athletics)"],
    ["与会", "與會", "yùhuì", "attend a meeting; participate in a conference"],
    [
      "流露",
      "流露",
      "liúlù",
      "to express; to reveal (one's thoughts or feelings)"
    ],
    ["建交", "建交", "jiàn jiāo", "establish diplomatic relations"],
    [
      "只管",
      "只管",
      "zhǐguǎn",
      "no need to think about; by all means; simply; just"
    ],
    ["功效", "功效", "gōngxiào", "effective; effectiveness"],
    ["研究", "研究", "yánjiū", "to study; to research"],
    ["学院", "學院", "xuéyuàn", "college; institute; academy; school"],
    ["附近", "附近", "fùjìn", "(in the) vicinity; nearby; neighboring"],
    ["突然", "突然", "tūrán", "sudden; abrupt"],
    ["太阳", "太陽", "tàiyáng", "the sun"],
    ["国际", "國際", "guójì", "international"],
    ["实际", "實際", "shíjì", "actual; reality; practice"],
    ["随便", "隨便", "suíbiàn", "as one pleases; informal; random; casual"],
    ["控制", "控制", "kòngzhì", "to control"],
    ["深入", "深入", "shēnrù", "thorough; dig deep into; penetrate into"],
    [
      "研究所",
      "研究所",
      "yánjiūsuǒ",
      "graduate studies; graduate school; research institute"
    ],
    ["住院", "住院", "zhù yuàn", "be hospitalized"],
    [
      "防止",
      "防止",
      "fángzhǐ",
      "prevent; guard against; take precautions; forestall; avoid"
    ],
    [
      "突出",
      "突出",
      "tūchū",
      "protruding; prominent; outstanding; to highlight"
    ],
    [
      "究竟",
      "究竟",
      "jiūjìng",
      "after all; when all is said and done; actually"
    ],
    ["出院", "出院", "chū yuàn", "be discharged from hospital"],
    ["院子", "院子", "yuànzi", "courtyard; yard"],
    ["阳光", "陽光", "yángguāng", "sunshine; sunlight"],
    ["交际", "交際", "jiāojì", "socialize; social intercourse; communication"],
    ["空儿", "空兒", "kòngr5", "free/spare time"],
    ["随时", "隨時", "suíshí", "at any time; whenever necessary"],
    ["空前", "空前", "kōngqián", "unprecedented"],
    ["科学院", "科學院", "kēxuéyuàn", "academy of sciences"],
    ["空中", "空中", "kōngzhōng", "in the sky; in the air"],
    ["军队", "軍隊", "jūnduì", "army troops; armed forces"],
    ["下降", "下降", "xiàjiàng", "descend; to decline; to drop"],
    ["冲突", "沖突", "chōngtū", "conflict; clash"],
    ["队员", "隊員", "duìyuán", "team member"],
    ["法院", "法院", "fǎyuàn", "court of law"],
    ["防治", "防治", "fángzhì", "prevent and cure"],
    ["国防", "國防", "guófáng", "national defense"],
    ["士兵", "士兵", "shìbīng", "soldier"],
    ["天空", "天空", "tiānkōng", "sky; space; heavens"],
    ["深度", "深度", "shēndù", "depth"],
    ["大队", "大隊", "dàduì", "group; large team; production brigade"],
    ["阴天", "陰天", "yīntiān", "cloudy day"],
    [
      "随后",
      "隨后",
      "suíhòu",
      "soon after; shortly thereafter; following that"
    ],
    ["随手", "隨手", "suíshǒu", "convenient; without extra trouble"],
    ["深远", "深遠", "shēnyuǎn", "deep and long lasting; profound"],
    [
      "台阶",
      "台階",
      "táijiē",
      "flight of steps; sidestep; fig. way out of an embarrassing situation"
    ],
    ["空想", "空想", "kōngxiǎng", "daydream; fantasy"],
    ["附加", "附加", "fùjiā", "additional; append"],
    ["附和", "附和", "fùhè", "to echo; chime in with"],
    ["阵容", "陣容", "zhènróng", "line-up (sports); troop arrangement"],
    ["已经", "已經", "yǐjīng", "already"],
    ["继续", "繼續", "jìxù", "continue; go on"],
    ["结果", "結果", "jiéguǒ", "result; outcome; finally"],
    ["经过", "經過", "jīngguò", "to pass; go through; as a result of"],
    ["经常", "經常", "jīngcháng", "day-to-day; constantly; often"],
    ["团结", "團結", "tuánjié", "unite; hold a rally; join forces"],
    ["年轻", "年輕", "niánqīng", "young"],
    ["年级", "年級", "niánjí", "grade; year (in school)"],
    ["年纪", "年紀", "niánjì", "age"],
    ["世纪", "世紀", "shìjì", "century"],
    ["总统", "總統", "zǒngtǒng", "president (of a country)"],
    ["手续", "手續", "shǒuxù", "formalities; procedure"],
    ["结构", "結構", "jiégòu", "structure; composition; makeup"],
    ["轻松", "輕松", "qīngsōng", "relaxed; gentle; easygoing"],
    ["经理", "經理", "jīnglǐ", "manager; director"],
    ["曾经", "曾經", "céngjīng", "once; in the past; ever"],
    ["维护", "維護", "wéihù", "defend; safeguard; maintain"],
    ["路线", "路線", "lùxiàn", "itinerary; route; line; political line"],
    ["统一", "統一", "tǒngyī", "unify; unite; integrate; universal"],
    ["经历", "經曆", "jīnglì", "undergo; to experience; an experience"],
    ["结合", "結合", "jiéhé", "to combine; to link; to bind"],
    ["系统", "系統", "xìtǒng", "system; device; process"],
    ["纪律", "紀律", "jìlv4", "discipline; morale; laws and regulations"],
    ["中药", "中藥", "zhōngyào", "traditional Chinese medicine"],
    ["减轻", "減輕", "jiǎnqīng", "lighten; to ease; alleviate"],
    ["大约", "大約", "dàyuē", "approximately; about; probably"],
    ["连续", "連續", "liánxù", "continually; in a row; successively"],
    ["始终", "始終", "shǐzhōng", "from beginning to end; all along"],
    ["结实", "結實", "jiēshi", "robust; sturdy; (also -shí: bear fruit)"],
    ["统治", "統治", "tǒngzhì", "to rule (a country); govern; governance"],
    ["初级", "初級", "chūjí", "junior; primary"],
    ["红茶", "紅茶", "hóngchá", "black tea"],
    ["阶级", "階級", "jiējí", "steps; stairs; rank (trad.); social class"],
    ["约会", "約會", "yuēhuì", "appointment; engagement; date"],
    ["条约", "條約", "tiáoyuē", "treaty; pact"],
    ["上级", "上級", "shàngjí", "higher authorities; superiors"],
    [
      "结论",
      "結論",
      "jiélùn",
      "(logic) conclusion; verdict; to reach a verdict"
    ],
    ["体系", "體系", "tǐxì", "system; setup"],
    ["神经", "神經", "shénjīng", "nerve"],
    ["总结", "總結", "zǒngjié", "summary; summarize; conclude"],
    ["光线", "光線", "guāngxiàn", "light ray; optical cable"],
    [
      "抓紧",
      "抓緊",
      "zhuā jǐn",
      "grasp firmly; pay close attention; make the most of"
    ],
    ["细心", "細心", "xìxīn", "careful; attentive; cautiousness"],
    ["统计", "統計", "tǒngjì", "statistics; to tally; to add up"],
    [
      "突破",
      "突破",
      "tūpò",
      "break through; breakthrough; to surmount or break the back of (a task etc)"
    ],
    ["空军", "空軍", "kōngjūn", "air force"],
    [
      "少先队",
      "少先隊",
      "shàoxiānduì",
      "Young Pioneers (Communist primary school league)"
    ],
    ["投降", "投降", "tóuxiáng", "surrender"],
    ["预防", "預防", "yùfáng", "prevent; take precautions against"],
    ["深夜", "深夜", "shēnyè", "very late at night"],
    ["阶层", "階層", "jiēcéng", "hierarchy; social stratum; class"],
    ["防守", "防守", "fángshǒu", "to defend; protect; to guard"],
    ["剧院", "劇院", "jùyuàn", "theater"],
    ["阵地", "陣地", "zhèndì", "position; front"],
    ["一阵", "一陣", "yízhèn", "a burst of; a fit; a spell (period of time)"],
    [
      "国务院",
      "國務院",
      "guówùyuàn",
      "State Council (PRC); State Department (USA)"
    ],
    ["空调", "空調", "kōngtiáo", "air conditioning"],
    ["球队", "球隊", "qiúduì", "ball team; sports team"],
    ["加深", "加深", "jiāshēn", "deepen"],
    ["降落", "降落", "jiàngluò", "descend; to land; put down"],
    ["空白", "空白", "kòngbái", "blank space; blank"],
    ["太空", "太空", "tàikōng", "outer space"],
    ["乐队", "樂隊", "yuèduì", "band; orchestra; music group"],
    ["伴随", "伴隨", "bànsuí", "accompany; go with; follow"],
    ["随着", "隨着", "suízhe", "along with; in the wake of; following"],
    [
      "空洞",
      "空洞",
      "kōngdòng",
      "cavity; empty; hollow; vacuous; devoid of content"
    ],
    ["随时随地", "隨時隨地", "suí shí suí dì", "anytime and anywhere"],
    [
      "深切",
      "深切",
      "shēnqiè",
      "deeply felt, sincere (emotions); thorough, penetrating (understanding)"
    ],
    [
      "阵营",
      "陣營",
      "zhènyíng",
      "group of people; camp; faction; sides in a dispute"
    ],
    ["随意", "隨意", "suíyì", "as one wishes; according to one's wishes"],
    ["降价", "降價", "jiàng jià", "price reduction; depreciate"],
    ["阴暗", "陰暗", "yīn'àn", "dim; somber; overcast"],
    ["上空", "上空", "shàngkōng", "overhead; in the sky"],
    ["深信", "深信", "shēnxìn", "believe firmly; trust; convince"],
    ["国际法", "國際法", "guójìfǎ", "international law"],
    [
      "空心",
      "空心",
      "kōng xīn",
      "hollow; mindless; fasting; on an empty stomach"
    ],
    ["追究", "追究", "zhuījiū", "investigate; look into; find out"],
    ["深浅", "深淺", "shēnqiǎn", "deep or shallow; limits of decorum"],
    [
      "空话",
      "空話",
      "kōnghuà",
      "empty talk; hollow words; talk with no real content"
    ],
    ["分队", "分隊", "fēnduì", "detachment; platoon; squad"],
    ["步兵", "步兵", "bùbīng", "infantry; foot soldiers"],
    ["控诉", "控訴", "kòngsù", "accuse; make a formal complaint"],
    [
      "深沉",
      "深沉",
      "shēnchén",
      "deep; extreme; low pitched (sound); grave; reserved (of a person)"
    ],
    [
      "防护",
      "防護",
      "fánghù",
      "to defend; to protect; to shelter; to shield; to guard; shielding; protection; proofing"
    ],
    ["抽空", "抽空", "chōu kòng", "find the time to do sth."],
    ["降临", "降臨", "jiànglín", "befall; descend; arrive; come"],
    [
      "深处",
      "深處",
      "shēnchù",
      "deep place; abyss; depths; deepest or most distant part"
    ],
    ["探测", "探測", "tàncè", "probe; take readings; detect; explore"],
    ["探讨", "探討", "tàntǎo", "inquire into; investigate"],
    ["附带", "附帶", "fùdài", "incidental; attach; supplementary"],
    ["深化", "深化", "shēnhuà", "deepen; intensify"],
    ["边防", "邊防", "biānfáng", "border defense"],
    ["高空", "高空", "gāokōng", "high altitude"],
    ["探望", "探望", "tànwàng", "pay a visit; look around"],
    ["高级", "高級", "gāojí", "high-level; high-grade; advanced"],
    ["给予", "給予", "jǐyǔ", "give; confer; bestow"],
    ["维持", "維持", "wéichí", "maintain; preserve"],
    ["紧急", "緊急", "jǐnjí", "urgent; pressing; critical; emergency"],
    ["思维", "思維", "sīwéi", "(line) of thought; thinking"],
    ["药方", "藥方", "yàofāng", "a prescription"],
    ["药水", "藥水", "yàoshuǐ", "liquid medicine"],
    ["药房", "藥房", "yàofáng", "pharmacy"],
    [
      "正经",
      "正經",
      "zhèngjing5",
      "decent; serious; standard; (dialect) really; indeed"
    ],
    ["火药", "火藥", "huǒyào", "gunpowder"],
    ["线路", "線路", "xiànlù", "line; circuit; road"],
    ["自始至终", "自始至終", "zìshǐzhìzhōng", "from start to finish"],
    ["经费", "經費", "jīngfèi", "funds; expenses"],
    ["一系列", "一系列", "yíxìliè", "a series of; a string of"],
    [
      "经营",
      "經營",
      "jīngyíng",
      "engage in (a business activity, etc.); run/operate (a business)"
    ],
    ["农药", "農藥", "nóngyào", "agricultural chemical; pesticide"],
    ["加紧", "加緊", "jiājǐn", "to intensify; to speed up; to step up"],
    ["给以", "給以", "gěiyǐ", "to give; to grant"],
    ["终身", "終身", "zhōngshēn", "lifelong"],
    ["紧密", "緊密", "jǐnmì", "inseparable; close"],
    ["轻视", "輕視", "qīngshì", "look down on; belittle; disdain"],
    ["级别", "級別", "jíbié", "rank; level; grade"],
    ["战线", "戰線", "zhànxiàn", "battle line; battlefront; front"],
    ["统统", "統統", "tǒngtǒng", "totally; completely"],
    ["药物", "藥物", "yàowù", "medicine; drug"],
    ["轻易", "輕易", "qīngyì", "easily; lightly; rashly"],
    ["药品", "藥品", "yàopǐn", "medicine; drug"],
    ["界线", "界線", "jièxiàn", "boundary line; "],
    [
      "(Variant of 界限) demarcation (or dividing) line; limits; bounds;",
      "",
      "",
      ""
    ],
    ["edge; verge; brink", "", "", ""],
    ["持续", "持續", "chíxù", "continue; persist; sustainable; preservation"],
    ["超级", "超級", "chāojí", "super; transcending; high grade"],
    ["绿化", "綠化", "lv4huà", "make green with plants; reforest"],
    [
      "终点",
      "終點",
      "zhōngdiǎn",
      "end point; destination; finish line (in a race)"
    ],
    ["结局", "結局", "jiéjú", "conclusion; ending"],
    [
      "终究",
      "終究",
      "zhōngjiū",
      "in the end; after all is said and done; eventually"
    ],
    [
      "分红",
      "分紅",
      "fēn hóng",
      "a bonus; to award a bonus; receive dividends; share profits"
    ],
    ["视线", "視線", "shìxiàn", "line of sight; view line"],
    ["弹药", "彈藥", "dànyào", "ammunition"],
    ["轻微", "輕微", "qīngwēi", "slight; light; trivial"],
    ["连续剧", "連續劇", "liánxùjù", "serial TV drama"],
    ["延续", "延續", "yánxù", "continue; last longer"],
    ["结晶", "結晶", "jiéjīng", "a crystal; to crystallize"],
    [
      "相继",
      "相繼",
      "xiāngjì",
      "one after another; in succession; closely follow after"
    ],
    [
      "终止",
      "終止",
      "zhōngzhǐ",
      "stop; cease; terminate (legal); cadence (music)"
    ],
    ["下级", "下級", "xiàjí", "low ranking; low level group or people"],
    [
      "前线",
      "前線",
      "qiánxiàn",
      "military front line; battlefront; edge of a construction site"
    ],
    ["和约", "和約", "héyuē", "peace treaty"],
    ["系列", "系列", "xìliè", "series; a set"],
    ["工人阶级", "工人階級", "gōngrén jiējí", "working class"],
    ["终年", "終年", "zhōngnián", "entire year; all year long"],
    ["制约", "制約", "zhìyuē", "restrict; condition"],
    ["厨房", "廚房", "chúfáng", "kitchen"],
    ["眼镜", "眼鏡", "yǎnjìng", "glasses; spectacles"],
    ["旅馆", "旅館", "lv3guǎn", "inn; hotel; hostel"],
    [
      "尊敬",
      "尊敬",
      "zūnjìng",
      "to respect; to honor; to hold in high esteem; honored; honorable; distinguished"
    ],
    ["分配", "分配", "fēnpèi", "distribute; assign; allocate"],
    [
      "遵守",
      "遵守",
      "zūnshǒu",
      "observe; abide by; comply with (commandments, agreements, etc.)"
    ],
    ["配合", "配合", "pèihé", "cooperate; conform; fit in with; to match"],
    ["豆腐", "豆腐", "dòufu", "tofu; bean curd"],
    ["良好", "良好", "liánghǎo", "good; favorable; well"],
    ["体育馆", "體育館", "tǐyùguǎn", "gym; stadium; sports hall"],
    ["浪费", "浪費", "làngfèi", "to waste; to squander; be extravagant"],
    ["食物", "食物", "shíwù", "food"],
    ["大使馆", "大使館", "dàshǐguǎn", "embassy"],
    ["眼前", "眼前", "yǎnqián", "now; at present; before one's eyes"],
    [
      "无限",
      "無限",
      "wúxiàn",
      "infinite; limitless; unlimited; boundless; immeasurable"
    ],
    ["中餐", "中餐", "zhōngcān", "Chinese food"],
    [
      "大娘",
      "大娘",
      "dàniáng",
      "(informal) father's older brother's wife; aunt (a respectful form of address used for an elderly woman)"
    ],
    [
      "既又",
      "既又",
      "jì ... yòu",
      "as well as; already; once again; both ... and"
    ],
    ["副食", "副食", "fùshí", "non-staple food"],
    ["血液", "血液", "xuèyè", "blood"],
    [
      "概括",
      "概括",
      "gàikuò",
      "summarize; generalize; briefly; in broad outline"
    ],
    ["温度", "溫度", "wēndù", "temperature"],
    [
      "跟前",
      "跟前",
      "gēnqián",
      "the front (of) / (in) front / (in) sb's presence / just before (a date)"
    ],
    ["既也", "既也", "jì ... yě", "both ... and ...; as well as"],
    ["立即", "立即", "lìjí", "immediately; at once; promptly"],
    ["优良", "優良", "yōuliáng", "fine; good; excellent"],
    [
      "老大娘",
      "老大娘",
      "lǎodàniáng",
      "aunt (respectful address for elderly woman)"
    ],
    ["土豆", "土豆", "tǔdòu", "potato"],
    ["退休", "退休", "tuìxiū", "retirement (from work); retire"],
    ["监督", "監督", "jiāndū", "control; monitor; supervise; inspect"],
    ["即使", "即使", "jíshǐ", "even if; even though"],
    ["监狱", "監獄", "jiānyù", "prison; jail"],
    ["喜爱", "喜愛", "xǐ'ài", "to like; to love; favorite"],
    ["饭馆", "飯館", "fànguǎn", "restaurant"],
    [
      "眼看",
      "眼看",
      "yǎnkàn",
      "soon; in a moment; to watch helplessly; to look on passively"
    ],
    ["酒店", "酒店", "jiǔdiàn", "hotel; wine shop; liquor store"],
    ["有限", "有限", "yǒuxiàn", "limited; finite"],
    ["温和", "溫和", "wēnhé", "moderate; warm"],
    ["改良", "改良", "gǎiliáng", "improve; to reform"],
    ["体温", "體溫", "tǐwēn", "body temperature"],
    ["茶馆", "茶館", "cháguǎn", "teahouse"],
    ["敬酒", "敬酒", "jìng jiǔ", "propose a toast; to toast"],
    ["欢喜", "歡喜", "huānxǐ", "joyful; happy"],
    ["开饭", "開飯", "kāifàn", "serve a meal"],
    ["银幕", "銀幕", "yínmù", "movie screen"],
    ["支配", "支配", "zhīpèi", "allocate; control; govern; dominate"],
    ["鼓动", "鼓動", "gǔdòng", "agitate; instigate"],
    ["餐车", "餐車", "cānchē", "dining car; diner"],
    ["温带", "溫帶", "wēndài", "temperate zone"],
    ["鲜血", "鮮血", "xiānxuè", "fresh blood"],
    [
      "相通",
      "相通",
      "xiāngtōng",
      "be closely linked; connected; have a connection"
    ],
    ["流通", "流通", "liútōng", "circulate; distribution"],
    ["使命", "使命", "shǐmìng", "a (diplomatic or other) mission"],
    [
      "冷淡",
      "冷淡",
      "lěngdàn",
      "treat coldly; give sb. a cold shoulder; leave sb. (out) in the cold; to slight; cold; chill; indifferent; unconcerned"
    ],
    ["首创", "首創", "shǒuchuàng", "create; originate; be the first to do"],
    ["节育", "節育", "jiéyù", "birth control"],
    ["报答", "報答", "bàodá", "repay; requite"],
    [
      "通商",
      "通商",
      "tōng shāng",
      "have trading relations (i.e. between nations)"
    ],
    [
      "犯法",
      "犯法",
      "fànfǎ",
      "break the law; violate the law; against the law; illegal"
    ],
    ["忘却", "忘卻", "wàngquè", "(literary) forget; fade from memory"],
    ["环节", "環節", "huánjié", "link; sector; segment (of annelid worms)"],
    ["守卫", "守衛", "shǒuwèi", "to guard; defend; ward"],
    ["细节", "細節", "xìjié", "details; particulars"],
    ["警卫", "警衛", "jǐngwèi", "(security) guard"],
    ["公报", "公報", "gōngbào", "announcement; bulletin"],
    [
      "上报",
      "上報",
      "shàngbào",
      "report to one's superiors; appear in a report"
    ],
    [
      "指令",
      "指令",
      "zhǐlìng",
      "to order; to direct; instructions; directive; command"
    ],
    ["使节", "使節", "shǐjié", "(diplomatic) envoy"],
    [
      "命题",
      "命題",
      "mìng tí",
      "assign a topic (for an essay); set a question; {mathematics or logic} proposition"
    ],
    ["创建", "創建", "chuàngjiàn", "to establish; to found; to create"],
    ["报考", "報考", "bàokǎo", "sign up for an examination"],
    ["任命", "任命", "rènmìng", "appoint and nominate"],
    ["零售", "零售", "língshòu", "retail"],
    ["机枪", "機槍", "jīqiāng", "machine gun"],
    [
      "留神",
      "留神",
      "liú shén",
      '(idiom) "take care to ..."; "be careful of ..."'
    ],
    ["领子", "領子", "lǐngzi", "shirt collar"],
    ["下令", "下令", "xià lìng", "to order; give an order"],
    [
      "红领巾",
      "紅領巾",
      "hónglǐngjīn",
      "red scarf worn by the Young Pioneers"
    ],
    ["命名", "命名", "mìngmíng", "give a name; to dub; christen; naming"],
    [
      "通报",
      "通報",
      "tōngbào",
      "to circulate a notice; to circulate information; circular; bulletin; announcement; journal; to notify or  report to (one's superior or master)"
    ],
    [
      "申报",
      "申報",
      "shēnbào",
      "declare; report (to customs or other authority)"
    ],
    ["领事", "領事", "lǐngshì", "consul"],
    ["创办", "創辦", "chuàngbàn", "launch; found; establish"],
    ["喜欢", "喜歡", "xǐhuan5", "to like; be fond of"],
    ["银行", "銀行", "yínháng", "financial bank"],
    ["大概", "大概", "dàgài", "probably; roughly; approximate"],
    ["饭店", "飯店", "fàndiàn", "restaurant; hotel"],
    ["篮球", "籃球", "lánqiú", "basketball"],
    ["早饭", "早飯", "zǎofàn", "breakfast"],
    ["午饭", "午飯", "wǔfàn", "lunch"],
    ["米饭", "米飯", "mǐfàn", "(cooked) rice"],
    ["食堂", "食堂", "shítáng", "dining hall; cafeteria"],
    ["得很", "得很", "dehěn", "very much"],
    ["根本", "根本", "gēnběn", "root; essence; fundamental; basic; simply"],
    ["鼓励", "鼓勵", "gǔlì", "encourage; inspire; urge"],
    ["既然", "既然", "jìrán", "since; given that; now that"],
    ["餐厅", "餐廳", "cāntīng", "dining hall; cafeteria; restaurant"],
    ["食品", "食品", "shípǐn", "foodstuff; provisions"],
    ["根据", "根據", "gēnjù", "according to; based on; basis"],
    ["限制", "限制", "xiànzhì", "restrictions; to limit; to confine"],
    ["监视", "監視", "jiānshì", "oversee; to monitor"],
    ["篮子", "籃子", "lánzi", "basket"],
    ["波浪", "波浪", "bōlàng", "wave"],
    ["盖子", "蓋子", "gàizi", "cover; lid; cap; shell"],
    ["随即", "隨即", "suíjí", "immediately (after); soon after; immediately"],
    ["后退", "后退", "hòutuì", "recoil; fall back; to retreat"],
    ["血管", "血管", "xuèguǎn", "vein; artery; blood-vessel"],
    ["豆子", "豆子", "dòuzi", "bean; pea"],
    ["根源", "根源", "gēnyuán", "origin; root; source"],
    [
      "退步",
      "退步",
      "tuìbù",
      "step backward; fall behind; retrogress; give way; leeway"
    ],
    ["即将", "即將", "jíjiāng", "will shortly; soon; be on the verge of"],
    [
      "眼光",
      "眼光",
      "yǎnguāng",
      "gaze; insight; foresight; vision; way of looking at things"
    ],
    ["厨师", "廚師", "chúshī", "a cook; chef"],
    ["血压", "血壓", "xuèyā", "blood pressure"],
    ["不良", "不良", "bùliáng", "bad; harmful; unhealthy"],
    ["白酒", "白酒", "báijiǔ", "Chinese distilled white liquor"],
    ["善良", "善良", "shànliáng", "good and honest; kind-hearted"],
    ["流浪", "流浪", "liúlàng", "drift about; wander; vagrant"],
    [
      "主食",
      "主食",
      "zhǔshí",
      "entrees; main dishes; staple food; principle food (rice, noodles, dumplings, bread, etc.)"
    ],
    ["食欲", "食欲", "shíyù", "appetite"],
    ["可喜", "可喜", "kěxǐ", "delightful; makes one happy"],
    ["短处", "短處", "duǎnchù", "shortcoming; defect; fault"],
    ["温柔", "溫柔", "wēnróu", "gentle and soft; tender"],
    [
      "心血",
      "心血",
      "xīnxuè",
      "painstaking, meticulous effort (or care); one's great pains (in doing sth.); heart and blood"
    ],
    ["限度", "限度", "xiàndù", "limit; bound; limitation"],
    ["眼下", "眼下", "yǎnxià", "now; at present; at this stage"],
    [
      "鼓吹",
      "鼓吹",
      "gǔchuī",
      "to preach; to play up; to agitate for; to promote enthusiastically; chamber music with percussion and wind instruments"
    ],
    ["退出", "退出", "tuìchū", "to exit; abort; quit; retreat"],
    ["极限", "极限", "jíxiàn", "limit; extreme boundary"],
    ["一概", "一概", "yígài", "all; without any exceptions"],
    ["局限", "局限", "júxiàn", "to limit; confine; restrict or confine sth."],
    ["退还", "退還", "tuìhuán", "return; send back; refund; rebate"],
    ["跟头", "跟頭", "gēntou", "fall down; somersault"],
    [
      "的确良",
      "的確良",
      "díquèliáng",
      "dacron (loanword); PET (Polyethylene terephthalate)"
    ],
    [
      "心眼儿",
      "心眼兒",
      "xīnyǎnr5",
      "one's thoughts; mind; intention; willingness to accept new ideas"
    ],
    [
      "一概而论",
      "一概而論",
      "yígài'érlùn",
      "lump different matters together; generalize"
    ],
    ["跟随", "跟隨", "gēnsuí", "follow"],
    [
      "浪潮",
      "浪潮",
      "làngcháo",
      "fig. tide of...; wave of...; a social movement"
    ],
    ["配备", "配備", "pèibèi", "provide; outfit with; deploy"],
    ["高温", "高溫", "gāowēn", "high temperature"],
    ["即便", "即便", "jíbiàn", "even if; even though"],
    ["食用", "食用", "shíyòng", "edible; food product"],
    ["根据地", "根據地", "gēnjùdì", "base of operations; citadel"],
    ["眼神", "眼神", "yǎnshén", "expression or emotion showing in one's eyes"],
    ["配方", "配方", "pèifāng", "prescriptions; cooking recipe"],
    ["保温", "保溫", "bǎowēn", "heat preservation"],
    ["良种", "良種", "liángzhǒng", "improved type; improved variety"],
    ["高血压", "高血壓", "gāoxuèyā", "high blood pressure"],
    ["喜事", "喜事", "xǐshì", "happy events; wedding"],
    ["短暂", "短暫", "duǎnzàn", "brief; short; transient"],
    ["脑子", "腦子", "nǎozi", "brain; brains; mind"],
    ["收获", "收獲", "shōuhuò", "harvest; acquisition; gain"],
    ["刚刚", "剛剛", "gānggāng", "just recently; just a moment ago; just now"],
    ["美术", "美術", "měishù", "the fine arts; art"],
    ["似乎", "似乎", "sìhū", "it seems; as if; seemingly"],
    ["刻苦", "刻苦", "kèkǔ", "hardworking; assiduous"],
    ["平安", "平安", "píng'ān", "safe and sound; without mishap"],
    ["不幸", "不幸", "búxìng", "misfortune; adversity; unfortunate"],
    ["平原", "平原", "píngyuán", "field; plain; flatlands"],
    ["叫做", "叫做", "jiàozuò", "called; known as"],
    ["议论", "議論", "yìlùn", "discuss; to comment; talk about"],
    ["亲爱", "親愛", "qīn'ài", "dear; beloved"],
    ["寒冷", "寒冷", "hánlěng", "cold (climate); frigid"],
    ["技术员", "技術員", "jìshùyuán", "technician"],
    ["画报", "畫報", "huàbào", "illustrated magazine or newspaper; pictorial"],
    ["亲自", "親自", "qīnzì", "personally; in person; by oneself"],
    ["脑袋", "腦袋", "nǎodai", "head; skull; brains; mental capability"],
    ["风力", "風力", "fēnglì", "wind-force; wind power"],
    ["不平", "不平", "bùpíng", "injustice; unfairness; wrong"],
    ["脱离", "脫離", "tuōlí", "separate; break away; divorce"],
    [
      "开辟",
      "開辟",
      "kāipì",
      "open up; set up; start; build (a road); create (the world)"
    ],
    ["复述", "復述", "fùshù", "to repeat; retell"],
    ["竞赛", "競賽", "jìngsài", "race; contest; competition"],
    ["呼吸", "呼吸", "hūxī", "breathe"],
    ["时刻", "時刻", "shíkè", "moment; point in time; constantly"],
    ["招呼", "招呼", "zhāohu", "call out to; greet; notify; take care of"],
    ["社会主义", "社會主義", "shèhuìzhǔyì", "socialism"],
    ["义务", "義務", "yìwù", "duty; obligation; volunteer duty"],
    ["风格", "風格", "fēnggé", "style; manner; genre"],
    ["上述", "上述", "shàngshù", "above-mentioned; aforementioned"],
    ["画家", "畫家", "huàjiā", "painter (artist)"],
    ["评论", "評論", "pínglùn", "comment on; discuss; remark; review"],
    ["收集", "收集", "shōují", "gather; collect"],
    ["抗议", "抗議", "kàngyì", "protest"],
    ["作风", "作風", "zuòfēng", "work style; way (of doing things)"],
    ["辩论", "辯論", "biànlùn", "argue; debate; argument"],
    ["创新", "創新", "chuàngxīn", "innovate; innovation"],
    ["称呼", "稱呼", "chēnghu", "to call; address as; name"],
    ["头脑", "頭腦", "tóunǎo", "brain; mind"],
    ["资本主义", "資本主義", "zīběnzhǔyì", "capitalism"],
    ["讽刺", "諷刺", "fěngcì", "satirize; ridicule; mock; irony"],
    [
      "一路平安",
      "一路平安",
      "yílùpíng'ān",
      "have a safe journey; bon voyage"
    ],
    ["脑力", "腦力", "nǎolì", "mental ability; intelligence"],
    ["打招呼", "打招呼", "dǎ zhāohu", "notify; greet; inform"],
    [
      "一路顺风",
      "一路順風",
      "yílùshùnfēng",
      "safe travels; have a pleasant journey; bon voyage"
    ],
    ["欢呼", "歡呼", "huānhū", "cheer for; acclaim"],
    ["正义", "正義", "zhèngyì", "justice; righteous"],
    ["此刻", "此刻", "cǐkè", "this moment; now; at present"],
    ["新型", "新型", "xīnxíng", "new type; new kind; new pattern"],
    ["大脑", "大腦", "dànǎo", "brain; cerebrum"],
    [
      "风尚",
      "風尚",
      "fēngshàng",
      "current custom; order of the day; current way of doing things"
    ],
    [
      "预赛",
      "預賽",
      "yùsài",
      "preliminary competition; hold a preliminary competition"
    ],
    ["风度", "風度", "fēngdù", "elegant demeanor; grace; poise; style"],
    [
      "新人",
      "新人",
      "xīnrén",
      "new type of person; newlywed, in particular a new bride; bride and groom"
    ],
    ["收回", "收回", "shōuhuí", "regain; retake; take back"],
    ["国际主义", "國際主義", "guójì zhǔyì", "internationalism"],
    [
      "通风",
      "通風",
      "tōng fēng",
      "ventilate; airy; disclose information; tip off"
    ],
    ["暗杀", "暗殺", "ànshā", "to assassinate"],
    [
      "离休",
      "離休",
      "líxiū",
      "retire with honors; compulsory retirement of cadres"
    ],
    [
      "探头探脑",
      "探頭探腦",
      "tàn tóu tàn nǎo",
      "(saying) stick one's head out and look around"
    ],
    [
      "开天辟地",
      "開天辟地",
      "kāi tiān pì dì",
      "(saying) when heaven and earth were split apart in the creation"
    ],
    ["主义", "主義", "zhǔyì", "-ism; ideology"],
    ["评比", "評比", "píngbǐ", "compare and evaluate (or (by comparison)"],
    [
      "接收",
      "接收",
      "jiēshōu",
      "to receive; to accept; reception (of transmitted signal); to take over (property, etc.); expropriate; to admit"
    ],
    ["考核", "考核", "kǎohé", "evaluation; review; examine; check up on"],
    [
      "威风",
      "威風",
      "wēifēng",
      "awe-inspiring authority; power and prestige; impressive force"
    ],
    [
      "胸怀",
      "胸懷",
      "xiōnghuái",
      "think about; heart; one's bosom (the seat of emotions); breast; broad-minded and open"
    ],
    ["核心", "核心", "héxīn", "core; kernel; nucleus"],
    ["亲友", "親友", "qīnyǒu", "friends and relatives"],
    ["人道主义", "人道主義", "réndào zhǔyì", "humanitarian (aid); humanism"],
    ["收复", "收復", "shōufù", "recover (lost territory, etc.); recapture"],
    ["辩护", "辯護", "biànhù", "speak in defense of; argue for; defend"],
    [
      "分辩",
      "分辯",
      "fēnbiàn",
      "offer an explanation; defend oneself against a charge"
    ],
    ["山冈", "山岡", "shāngāng", "mound; mountain ridge; small hill"],
    ["收买", "收買", "shōumǎi", "to bribe; to purchase"],
    [
      "辩证法",
      "辯證法",
      "biànzhèngfǎ",
      "dialectics; dialectic or Socratic method of debate"
    ],
    ["收支", "收支", "shōuzhī", "income and expenses; cash flow"],
    [
      "复辟",
      "復辟",
      "fùbì",
      "to restore to power (to a dethroned monarch, etc.); to recover one's power or authority; restoration (of a past regime)"
    ],
    ["合乎", "合乎", "héhū", "be in accordance with; conform to; tally with"],
    [
      "评选",
      "評選",
      "píngxuǎn",
      "choose through evaluation and discussion; select on the basis of a vote or consensus"
    ],
    [
      "风浪",
      "風浪",
      "fēnglàng",
      "wind and waves; storm tossed sea; a stormy experience"
    ],
    ["恼火", "惱火", "nǎohuǒ", "get angry; irritated; annoy"],
    ["台风", "台風", "táifēng", "typhoon; stage presence"],
    ["新房", "新房", "xīnfáng", "brand new house; bridal chamber"],
    ["太平", "太平", "tàipíng", "peace and security"],
    ["回避", "回避", "huíbì", "avoid; shun; evade"],
    ["片刻", "片刻", "piànkè", "a short period of time"],
    [
      "不正之风",
      "不正之風",
      "bú zhèng zhī fēng",
      "unhealthy tendency; malpractice"
    ],
    ["议程", "議程", "yìchéng", "agenda"],
    ["苦恼", "苦惱", "kǔnǎo", "distressed; worried; to annoy"],
    ["招收", "招收", "zhāoshōu", "recruit; take in; to hire"],
    ["辩证", "辯證", "biànzhèng", "investigate; dialectical"],
    ["评定", "評定", "píngdìng", "evaluate; make a judgment"],
    ["商议", "商議", "shāngyì", "confer; negotiate; to deliberate"],
    ["首脑", "首腦", "shǒunǎo", "head (of state); summit (meeting); leader"],
    ["亲密", "親密", "qīnmì", "intimate; close; familiarity"],
    [
      "离别",
      "離別",
      "líbié",
      "leave or part from (when going on a long journey)"
    ],
    [
      "更新",
      "更新",
      "gēngxīn",
      "replace; renew; renovate; to upgrade; to update; to regenerate; to rejuvenate"
    ],
    ["核桃", "核桃", "hétao", "walnut"],
    ["收购", "收購", "shōugòu", "purchase; buy; acquire"],
    ["幸好", "幸好", "xìnghǎo", "fortunately; luckily"],
    ["定义", "定義", "dìngyì", "definition"],
    ["平日", "平日", "píngrì", "on ordinary days; ordinarily; usually"],
    ["学生", "學生", "xuésheng5", "student"],
    ["先生", "先生", "xiānsheng5", "Mr.; Sir; husband"],
    ["情况", "情況", "qíngkuàng", "circumstance; state of affairs; situation"],
    ["代表", "代表", "dàibiǎo", "represent; to delegate; on behalf of"],
    [
      "成绩",
      "成績",
      "chéngjì",
      "achievement; results (of work or study); grade (on schoolwork)"
    ],
    ["生活", "生活", "shēnghuó", "life; livelihood; to live"],
    ["事情", "事情", "shìqing5", "matter; affair; thing; business"],
    ["表示", "表示", "biǎoshì", "express; show; indicate"],
    ["负责", "負責", "fùzé", "responsible for; in charge of"],
    ["精神", "精神", "jīngshen5", "vigor; spirit; mind; essence"],
    ["丰富", "丰富", "fēngfù", "rich; enrich; abundant; plentiful"],
    ["清楚", "清楚", "qīngchu", "clear; distinct; be clear about"],
    [
      "表现",
      "表現",
      "biǎoxiàn",
      "to show; to display; show off; manifestation; performance"
    ],
    ["睡觉", "睡覺", "shuìjiào", "to sleep; to go to bed"],
    ["生日", "生日", "shēngrì", "birthday"],
    ["青年", "青年", "qīngnián", "young people; youth"],
    ["周围", "周圍", "zhōuwéi", "surroundings; vicinity; environment"],
    [
      "热情",
      "熱情",
      "rèqíng",
      "cordial; passionate; enthusiastic; warmth; warm-hearted"
    ],
    ["伟大", "偉大", "wěidà", "great; mighty; large"],
    ["胜利", "勝利", "shènglì", "victory; triumph"],
    ["眼睛", "眼睛", "yǎnjing5", "eye"],
    ["留学生", "留學生", "liúxuéshēng", "exchange student; foreign student"],
    ["春天", "春天", "chūntiān", "spring (season)"],
    ["安静", "安靜", "ānjìng", "quiet; peaceful; calm"],
    ["手表", "手表", "shǒubiǎo", "wristwatch"],
    ["专家", "專家", "zhuānjiā", "expert; specialist"],
    ["传统", "傳統", "chuántǒng", "tradition; traditional"],
    [
      "卫生",
      "衛生",
      "wèishēng",
      "health; hygiene; sanitation; sanitary; clean"
    ],
    ["责任", "責任", "zérèn", "responsibility; blame; duty"],
    ["厉害", "厲害", "lìhai", "terrible; formidable; fierce; cool; awesome"],
    ["大陆", "大陸", "dàlù", "continent; mainland (esp. China)"],
    ["生意", "生意", "shēngyi", "business; trade"],
    ["出生", "出生", "chūshēng", "be born"],
    ["表明", "表明", "biǎomíng", "make clear; make known"],
    [
      "名胜",
      "名勝",
      "míngshèng",
      "a place famous for its scenery or historical relics; well-known scenic spot"
    ],
    ["春节", "春節", "Chūn Jié", "Spring Festival (Chinese New Year)"],
    [
      "老百姓",
      "老百姓",
      "lǎobǎixìng",
      'ordinary people; the "person on the street"; civilians'
    ],
    ["性格", "性格", "xìnggé", "nature; disposition; temperament"],
    ["害怕", "害怕", "hàipà", "to be afraid of; to fear; to be scared"],
    ["宣传", "宣傳", "xuānchuán", "propagate; give publicity to; propaganda"],
    ["生命", "生命", "shēngmìng", "life"],
    ["心情", "心情", "xīnqíng", "mood; state of mind"],
    ["精力", "精力", "jīnglì", "energy; vigor"],
    ["请客", "請客", "qǐng kè", "to treat; invite to dinner; entertain guests"],
    ["生物", "生物", "shēngwù", "biology; organism; living creature"],
    ["危害", "危害", "wēihài", "endanger; jeopardize; to harm"],
    ["陆续", "陸續", "lùxù", "in turn; successively; one after another"],
    ["起义", "起義", "qǐyì", "revolt; insurrection; to rebel"],
    ["分离", "分離", "fēnlí", "separate; sever; to part with"],
    ["新式", "新式", "xīnshì", "new style; new-style; latest type"],
    ["图画", "圖畫", "túhuà", "drawing; picture"],
    ["平凡", "平凡", "píngfán", "commonplace; ordinary"],
    ["土壤", "土壤", "tǔrǎng", "soil; earth"],
    ["评介", "評介", "píngjiè", "discuss; introduce; evaluate; assessment"],
    [
      "提议",
      "提議",
      "tíyì",
      "to propose; to suggest; to move (to do sth.); proposal; suggestion"
    ],
    ["活该", "活該", "huógāi", "serve sb. right; deservedly; ought"],
    ["亲人", "親人", "qīnrén", "one's close relatives; family members"],
    [
      "战术",
      "戰術",
      "zhànshù",
      "(military) tactics; tactics to solve problems"
    ],
    ["狂风", "狂風", "kuángfēng", "fierce wind; gale"],
    ["亲热", "親熱", "qīnrè", "intimate; affectionate; warm"],
    ["平行", "平行", "píngxíng", "parallel; concurrent"],
    ["逃避", "逃避", "táobì", "to escape; evade; shirk"],
    ["不在乎", "不在乎", "bú zàihu", "not care; not mind"],
    ["呼呼", "呼呼", "hūhū", "(sound of wind blowing, snoring, etc.)"],
    ["亲眼", "親眼", "qīnyǎn", "with one's own eyes; personally"],
    ["荣幸", "榮幸", "róngxìng", "honored"],
    ["算术", "算術", "suànshù", "arithmetic"],
    ["议会", "議會", "yìhuì", "parliament; legislative assembly"],
    ["协议", "協議", "xiéyì", "agreement; pact; protocol"],
    ["公平", "公平", "gōngpíng", "fair; impartial; just"],
    ["风味", "風味", "fēngwèi", "local flavor; distinctive style"],
    ["风光", "風光", "fēngguāng", "a natural scenic view; sight"],
    ["探亲", "探親", "tànqīn", "go home to visit family; visit relatives"],
    [
      "议员",
      "議員",
      "yìyuán",
      "member (of a legislative body); representative; Congressman; Senator"
    ],
    ["核武器", "核武器", "héwǔqì", "nuclear weapon"],
    ["在乎", "在乎", "zàihu", "care about; be determined by; to mind"],
    [
      "名义",
      "名義",
      "míngyì",
      "name; (usu. followed by 上) nominal; titular; (do something) in (someone's) name; ostensible purpose"
    ],
    ["油画", "油畫", "yóuhuà", "oil painting"],
    ["烦恼", "煩惱", "fánnǎo", "worried; vexed"],
    ["回收", "回收", "huíshōu", "recycle; recover and put back to use"],
    ["自杀", "自殺", "zìshā", "kill oneself; commit suicide"],
    ["议案", "議案", "yì'àn", "proposal; motion; bill"],
    ["风沙", "風沙", "fēngshā", "sand blown by wind"],
    ["薪水", "薪水", "xīnshuǐ", "salary; wage; pay; stipend"],
    ["众议院", "眾議院", "zhòngyìyuàn", "House of Representatives (USA)"],
    ["幸运", "幸運", "xìngyùn", "luck; be lucky; good fortune"],
    ["亲身", "親身", "qīnshēn", "personal; oneself; intimate; firsthand"],
    ["收成", "收成", "shōucheng5", "harvest"],
    ["新娘", "新娘", "xīnniáng", "bride"],
    ["风趣", "風趣", "fēngqù", "humor; wit; humorous"],
    ["争议", "爭議", "zhēngyì", "controversy; dispute; contention"],
    ["新近", "新近", "xīnjìn", "recently; newly"],
    ["申述", "申述", "shēnshù", "to state in detail; allege"],
    ["秋收", "秋收", "qiūshōu", "autumn harvest; reap the fall harvest"],
    ["论述", "論述", "lùnshù", "treatise; discourse; exposition"],
    [
      "答辩",
      "答辯",
      "dábiàn",
      "reply (to a charge); make a statement of defence; defend a thesis"
    ],
    ["亲手", "親手", "qīnshǒu", "personally; with one's own hands"],
    ["表达", "表達", "biǎodá", "to express; to voice; convey"],
    ["感情", "感情", "gǎnqíng", "feeling; emotion; affection; love"],
    ["生动", "生動", "shēngdòng", "vivid; lively"],
    ["姓名", "姓名", "xìngmíng", "full name"],
    ["爱情", "愛情", "àiqíng", "(romantic) love"],
    ["性质", "性質", "xìngzhì", "nature; characteristic; quality"],
    ["专心", "專心", "zhuānxīn", "concentrate one's attention; be absorbed"],
    ["情景", "情景", "qíngjǐng", "scene; sight; circumstances"],
    ["同情", "同情", "tóngqíng", "sympathize (with)"],
    ["一生", "一生", "yìshēng", "all one's life; lifetime"],
    ["转告", "轉告", "zhuǎngào", "pass on; communicate; transmit"],
    ["年青", "年青", "niánqīng", "young; youthful (variant)"],
    ["害处", "害處", "hàichu", "damage; harm"],
    ["突击", "突擊", "tūjī", "make a sudden attack; assault; onrush"],
    ["雄伟", "雄偉", "xióngwěi", "grand; majestic"],
    ["战胜", "戰勝", "zhànshèng", "prevail; surmount; overcome"],
    ["卫星", "衛星", "wèixīng", "satellite"],
    ["平静", "平靜", "píngjìng", "calm; peaceful; tranquil; serene"],
    ["因素", "因素", "yīnsù", "element; factor"],
    ["请求", "請求", "qǐngqiú", "to request; ask"],
    ["灾害", "災害", "zāihài", "disaster; calamity"],
    ["星星", "星星", "xīngxing5", "star; (also -xīng: speck)"],
    ["积极性", "積极性", "jījíxìng", "zeal; initiative; enthusiasm"],
    ["小麦", "小麥", "xiǎomài", "wheat"],
    ["申请", "申請", "shēnqǐng", "apply for; application"],
    [
      "研究生",
      "研究生",
      "yánjiūshēng",
      "postgraduate (student); graduate student"
    ],
    [
      "打击",
      "打擊",
      "dǎjī",
      "strike; hit; attack; crack down on sth.; a setback; a blow; percussion (music)"
    ],
    ["新生", "新生", "xīnshēng", "newborn; new student"],
    ["丰收", "丰收", "fēngshōu", "bumper crop; have a good harvest"],
    ["诞生", "誕生", "dànshēng", "be born; come into being"],
    ["伤害", "傷害", "shānghài", "injure; harm; wound"],
    ["生存", "生存", "shēngcún", "exist; survive"],
    ["攻击", "攻擊", "gōngjī", "to attack; accuse; to charge"],
    ["性别", "性別", "xìngbié", "gender; sex; sexual distinction"],
    ["传染", "傳染", "chuánrǎn", "infect; contaminate; be contagious"],
    ["冷静", "冷靜", "lěngjìng", "calm; cool-headed; sober"],
    ["分割", "分割", "fēngē", "to separate; cut apart; break up"],
    ["流传", "流傳", "liúchuán", "to spread; circulate; hand down"],
    [
      "传说",
      "傳說",
      "chuánshuō",
      "it is said; legend; pass on (a story); word of mouth"
    ],
    ["任性", "任性", "rènxìng", "willful; headstrong"],
    ["勤劳", "勤勞", "qínláo", "hardworking; diligent; industrious"],
    ["包围", "包圍", "bāowéi", "surround; encircle; hem in"],
    ["个性", "個性", "gèxìng", "individuality; personality"],
    ["青春", "青春", "qīngchūn", "youth; youthfulness; fresh spring"],
    ["传达", "傳達", "chuándá", "convey; transmit; communicate"],
    ["青菜", "青菜", "qīngcài", "green vegetables; vegetable dishes"],
    ["花生", "花生", "huāshēng", "peanut"],
    ["表情", "表情", "biǎoqíng", "(facial) expression; express one's feelings"],
    ["请教", "請教", "qǐngjiào", "consult; seek advice"],
    ["围巾", "圍巾", "wéijīn", "scarf; shawl; wrap"],
    ["复印", "復印", "fùyìn", "to photocopy; to duplicate"],
    ["通信", "通信", "tōng xìn", "communicate by letter; convey information"],
    ["预报", "預報", "yùbào", "predict; forecast"],
    ["留学", "留學", "liúxué", "study abroad"],
    ["领土", "領土", "lǐngtǔ", "territory"],
    ["报社", "報社", "bàoshè", "newspaper office/press"],
    ["创立", "創立", "chuànglì", "to found; establish"],
    ["说服", "說服", "shuō fú", "persuade; convince"],
    ["圣诞节", "聖誕節", "Shèngdàn Jié", "Christmas season; Christmas Day"],
    ["仓库", "倉庫", "cāngkù", "depot; storehouse; warehouse"],
    ["法令", "法令", "fǎlìng", "laws and decrees; ordinance"],
    ["零件", "零件", "língjiàn", "spare parts; component"],
    ["复活节", "復活節", "Fùhuó Jié", "Easter"],
    ["带领", "帶領", "dàilǐng", "to guide; to lead"],
    ["柳树", "柳樹", "liǔshù", "willow"],
    ["通常", "通常", "tōngcháng", "regular; usual; normal; ordinary; usually"],
    ["调节", "調節", "tiáojié", "adjust; regulate; reconcile; mediate"],
    ["手枪", "手槍", "shǒuqiāng", "pistol; handgun"],
    ["脚步", "腳步", "jiǎobù", "footstep; step"],
    [
      "通顺",
      "通順",
      "tōngshùn",
      "(of writing) to read smoothly; clear and coherent"
    ],
    ["犯人", "犯人", "fànrén", "criminal; convict; prisoner"],
    ["印染", "印染", "yìnrǎn", "printing and dyeing"],
    ["时节", "時節", "shíjié", "season; time"],
    [
      "停留",
      "停留",
      "tíngliú",
      "stay somewhere temporarily; stop over; to remain"
    ],
    ["报复", "報復", "bàofu", "retaliate; revenge"],
    ["领会", "領會", "lǐnghuì", "understand; comprehend; grasp"],
    ["日报", "日報", "rìbào", "daily newspaper"],
    ["冷却", "冷卻", "lěngquè", "cooling; cool off"],
    ["农贸市场", "農貿市場", "nóngmào shìchǎng", "farmer's market"],
    ["危难", "危難", "wēinàn", "calamity"],
    [
      "占领",
      "占領",
      "zhànlǐng",
      "to occupy (a territory, position, status, etc.); to capture; to seize; to hold"
    ],
    ["服装", "服裝", "fúzhuāng", "(formal) clothing; costume; dress"],
    [
      "通用",
      "通用",
      "tōngyòng",
      "in common use; interchangeable; General Motors"
    ],
    ["领先", "領先", "lǐngxiān", "leadership; to lead; be in front"],
    [
      "通道",
      "通道",
      "tōngdào",
      "(communications) channel; passageway; alleyway"
    ],
    ["通行", "通行", "tōngxíng", "go through; a passage through; to open"],
    ["自卫", "自衛", "zìwèi", "self-defense"],
    ["无聊", "無聊", "wúliáo", "nonsense; bored; boring; silly"],
    ["通告", "通告", "tōnggào", "announce; give public notice"],
    ["脆弱", "脆弱", "cuìruò", "weak; fragile; flimsy; frail"],
    ["礼节", "禮節", "lǐjié", "etiquette; proprieties; ceremony"],
    [
      "通红",
      "通紅",
      "tōnghóng",
      "red through and through; very red; to blush (deep red)"
    ],
    ["勇士", "勇士", "yǒngshì", "warrior; a brave person"],
    [
      "指手划脚",
      "指手划腳",
      "zhǐ shǒu huà jiǎo",
      "gesticulate wildly; make indiscreet remarks/criticism"
    ],
    ["山脚", "山腳", "shānjiǎo", "the foot of a mountain"],
    ["首领", "首領", "shǒulǐng", "leader; head; boss; chief"],
    ["制服", "制服", "zhìfú", "a uniform; subdue; bring under control"],
    ["危急", "危急", "wēijí", "critical; desperate (situation)"],
    ["留心", "留心", "liú xīn", "to be careful; be mindful"],
    [
      "留意",
      "留意",
      "liúyì",
      "to be mindful; to pay attention to; keep one's eyes open"
    ],
    ["害虫", "害虫", "hàichóng", "pest; vermin"],
    ["辛勤", "辛勤", "xīnqín", "hardworking; diligent; industrious"],
    ["请示", "請示", "qǐngshì", "to ask for instructions"],
    ["维生素", "維生素", "wéishēngsù", "vitamin"],
    ["激素", "激素", "jīsù", "hormone"],
    ["责备", "責備", "zébèi", "to blame; criticize (sb.); accuse"],
    ["转移", "轉移", "zhuǎnyí", "to shift; divert; migrate"],
    ["收割", "收割", "shōugē", "to reap; to harvest"],
    ["元素", "元素", "yuánsù", "element"],
    ["射击", "射擊", "shèjī", "to shoot; to fire (a gun)"],
    ["智慧", "智慧", "zhìhuì", "wisdom; knowledge; intelligence"],
    ["镇静", "鎮靜", "zhènjìng", "calm; cool; tranquil"],
    ["转动", "轉動", "zhuǎndòng", "to turn; rotate; turn around; swivel"],
    ["陆军", "陸軍", "lùjūn", "army; ground force"],
    ["专政", "專政", "zhuānzhèng", "dictatorship"],
    ["陆地", "陸地", "lùdì", "land; dry land (as opposed to the sea)"],
    ["生理", "生理", "shēnglǐ", "physiology"],
    ["精细", "精細", "jīngxì", "fine; careful; precise"],
    ["神情", "神情", "shénqíng", "look; expression"],
    [
      "冲击",
      "沖擊",
      "chōngjī",
      "to attack; to batter; (of waves) to pound against; shock; impact"
    ],
    [
      "动静",
      "動靜",
      "dòngjing5",
      "sound of activity or people talking; news of activity"
    ],
    ["春季", "春季", "chūnjì", "springtime; the spring season"],
    ["情报", "情報", "qíngbào", "intelligence; information-gathering"],
    ["运转", "運轉", "yùnzhuǎn", "revolve; operate; to work"],
    ["垂直", "垂直", "chuízhí", "perpendicular; vertical"],
    ["转达", "轉達", "zhuǎndá", "pass on; convey; communicate"],
    ["优胜", "優勝", "yōushèng", "winning; superior; victorious"],
    ["无情", "無情", "wúqíng", "pitiless; unfeeling; ruthless"],
    ["消毒", "消毒", "xiāo dú", "disinfect; sterilize"],
    ["转入", "轉入", "zhuǎnrù", "change over to; shift to; switch to"],
    ["反击", "反擊", "fǎnjī", "to counterattack; strike back; beat back"],
    ["行星", "行星", "xíngxīng", "planet"],
    ["明星", "明星", "míngxīng", "(movie, etc.) star; celebrity"],
    [
      "素质",
      "素質",
      "sùzhì",
      "inner quality; basic essence; character quality"
    ],
    ["生态", "生態", "shēngtài", "way of life; ecology"],
    ["毒品", "毒品", "dúpǐn", "drugs; narcotics; poison"],
    ["女性", "女性", "nv3xìng", "female (sex)"],
    ["转向", "轉向", "zhuǎnxiàng", "change direction; turn towards"],
    ["生育", "生育", "shēngyù", "give birth; bring up (children)"],
    [
      "利害",
      "利害",
      "lìhai",
      "serious; formidable; devastating; (-hài: advantages and disadvantages)"
    ],
    ["招生", "招生", "zhāo shēng", "enroll new students"],
    ["歌星", "歌星", "gēxīng", "famous singer; pop star"],
    [
      "精美",
      "精美",
      "jīngměi",
      "delicate; exquisite; elegant; fine; refinement"
    ],
    ["奉行", "奉行", "fèngxíng", "pursue (a course, a policy)"],
    ["清早", "清早", "qīngzǎo", "first thing in the morning or at daybreak"],
    ["情节", "情節", "qíngjié", "plot; circumstances"],
    ["人生", "人生", "rénshēng", "human life"],
    ["男性", "男性", "nánxìng", "male; man"],
    ["有害", "有害", "yǒu hài", "destructive; harmful; damaging"],
    ["野生", "野生", "yěshēng", "wild; undomesticated; uncultivated"],
    ["概况", "概況", "gàikuàng", "general situation; summary"],
    ["温度计", "溫度計", "wēndùjì", "thermometer"],
    ["就餐", "就餐", "jiùcān", "eat a meal; dine"],
    [
      "尊称",
      "尊稱",
      "zūn chēng",
      "address sb. deferentially; title; honorific"
    ],
    [
      "遵照",
      "遵照",
      "zūnzhào",
      "comply; in accordance with; follow (the rules)"
    ],
    ["界限", "界限", "jièxiàn", "boundary; marginal; limit"],
    ["装配", "裝配", "zhuāngpèi", "assemble; to fit together"],
    ["酒会", "酒會", "jiǔhuì", "cocktail party"],
    ["倒退", "倒退", "dàotuì", "fall back; go in reverse"],
    [
      "眼力",
      "眼力",
      "yǎnlì",
      "eyesight; strength of vision; ability to make discerning judgments"
    ],
    [
      "按劳分配",
      "按勞分配",
      "àn láo fēnpèi",
      "distribution according to work"
    ],
    [
      "监察",
      "監察",
      "jiānchá",
      "to supervise; to monitor; to control; to inspect; inspection"
    ],
    ["希望", "希望", "xīwàng", "hope; wish for; desire"],
    ["技术", "技術", "jìshù", "technology; technique; skill"],
    ["水平", "水平", "shuǐpíng", "standard; proficiency; level; horizontal"],
    ["孩子", "孩子", "háizi", "child; children; son or daughter"],
    ["比赛", "比賽", "bǐsài", "(sports) match; competition"],
    ["艺术", "藝術", "yìshù", "art"],
    ["意义", "意義", "yìyì", "meaning; significance"],
    ["离开", "離開", "líkāi", "leave; depart"],
    ["刚才", "剛才", "gāngcái", "just now; a moment ago"],
    ["辛苦", "辛苦", "xīnkǔ", "hard; exhausting; toilsome; laborious"],
    ["母亲", "母親", "mǔqin5", "mother (formal)"],
    ["批评", "批評", "pīpíng", "criticism; to criticize"],
    ["父亲", "父親", "fùqin5", "father (formal)"],
    ["幸福", "幸福", "xìngfú", "happy; blessed; fortunate"],
    ["新年", "新年", "xīnnián", "New Year"],
    ["立刻", "立刻", "lìkè", "immediately; at once; right away"],
    ["小孩儿", "小孩兒", "xiǎoháir5", "child; kid"],
    ["画儿", "畫兒", "huàr5", "picture; drawing; painting"],
    ["建议", "建議", "jiànyì", "recommendation; propose; suggest; recommend"],
    ["收入", "收入", "shōurù", "take in; income; revenue"],
    ["平常", "平常", "píngcháng", "ordinary; common; usually"],
    ["平均", "平均", "píngjūn", "average; mean; share equally"],
    ["会议", "會議", "huìyì", "meeting; conference"],
    ["和平", "和平", "hépíng", "peace"],
    ["几乎", "几乎", "jīhū", "almost; nearly; practically"],
    ["风景", "風景", "fēngjǐng", "scenery; landscape"],
    ["平等", "平等", "píngděng", "equal; equality"],
    ["手术", "手術", "shǒushù", "surgery; operation"],
    ["新鲜", "新鮮", "xīnxiān", "fresh (experience, food, etc.); new; novel"],
    ["网球", "网球", "wǎngqiú", "tennis; tennis ball"],
    ["武术", "武術", "wǔshù", "martial arts"],
    ["深刻", "深刻", "shēnkè", "profound; deep"],
    ["平方", "平方", "píngfāng", "square (math or measurement)"],
    ["收音机", "收音機", "shōuyīnjī", "radio"],
    ["吸收", "吸收", "xīshōu", "absorb; ingest"],
    ["平时", "平時", "píngshí", "ordinarily; in normal times; in peacetime"],
    ["学术", "學術", "xuéshù", "learning; science; academics"],
    ["亲切", "親切", "qīnqiè", "kind; amiable; cordial"],
    [
      "分清",
      "分清",
      "fēn qīng",
      "distinguish between; make distinctions clear"
    ],
    [
      "转让",
      "轉讓",
      "zhuǎnràng",
      "transfer possession; assign rights/ownership"
    ],
    ["毒害", "毒害", "dúhài", "bane; poison (people's minds)"],
    ["外表", "外表", "wàibiǎo", "outward appearance; external; outside"],
    ["友情", "友情", "yǒuqíng", "the feeling of friendship; friendly feelings"],
    ["传真", "傳真", "chuánzhēn", "fax; facsimile"],
    ["本性", "本性", "běnxìng", "natural instincts; nature; inherent quality"],
    ["生怕", "生怕", "shēngpà", "extremely nervous; fear"],
    ["慢性", "慢性", "mànxìng", "chronic (disease); slow in taking effect"],
    ["自力更生", "自力更生", "zìlì gēngshēng", "self-reliance"],
    ["性命", "性命", "xìngmìng", "life"],
    ["吸毒", "吸毒", "xī dú", "take drugs"],
    ["转交", "轉交", "zhuǎnjiāo", "pass on to somebody else"],
    ["说情", "說情", "shuō qíng", "intercede; plead on another's behalf"],
    ["传单", "傳單", "chuándān", "leaflet; flier; pamphlet"],
    ["清理", "清理", "qīnglǐ", "cleanup; put in order; check up"],
    ["回击", "回擊", "huíjī", "fight back; return fire; counterattack"],
    ["图表", "圖表", "túbiǎo", "chart; diagram; graph"],
    ["记性", "記性", "jìxing5", "memory"],
    [
      "专程",
      "專程",
      "zhuānchéng",
      "lit. special-purpose trip; specifically; specially (for that purpose)"
    ],
    ["请愿", "請願", "qǐngyuàn", "petition (for action to be taken)"],
    [
      "转折",
      "轉折",
      "zhuǎnzhé",
      "turning point; shift in the trend of events; plot twist in a book"
    ],
    [
      "专题",
      "專題",
      "zhuāntí",
      "special topic; questions; special matter or subject"
    ],
    ["责怪", "責怪", "zéguài", "to blame; to rebuke"],
    ["泰然", "泰然", "tàirán", "calm; self-composed"],
    ["钟表", "鐘表", "zhōngbiǎo", "clock; watch"],
    ["专利", "專利", "zhuānlì", "patent; special privilege; monopoly"],
    ["激情", "激情", "jīqíng", "passion; strong emotion; fervor; enthusiasm"],
    ["游击", "游擊", "yóujī", "guerrilla warfare"],
    ["生效", "生效", "shēng xiào", "take effect; become effective"],
    ["宴请", "宴請", "yànqǐng", "invite sb. to supper"],
    ["生机", "生機", "shēngjī", "reprieve from death; life force; vitality"],
    ["今天", "今天", "jīntiān", "today; at the present; now"],
    ["今年", "今年", "jīnnián", "this year"],
    ["不要", "不要", "búyào", "don't ...; don't want..."],
    ["东西", "東西", "dōngxi", "thing; objects; stuff"],
    ["要求", "要求", "yāoqiú", "request; demand; requirement"],
    ["主要", "主要", "zhǔyào", "main; principal; major"],
    ["需要", "需要", "xūyào", "need; require"],
    ["要是", "要是", "yàoshi", "if; suppose; in case"],
    ["漂亮", "漂亮", "piàoliang5", "pretty; beautiful"],
    ["练习", "練習", "liànxí", "practice; exercise"],
    ["留念", "留念", "liúniàn", "to keep as a souvenir"],
    ["东边", "東邊", "dōngbian5", "east; eastern side; to the east of"],
    ["西边", "西邊", "xībian5", "west; west side; west of"],
    ["南边", "南邊", "nánbian5", "South; South side; location to the South"],
    ["只要", "只要", "zhǐyào", "so long as; if only; provided that"],
    ["南方", "南方", "nánfāng", "South; southern part of the country"],
    ["西方", "西方", "xīfāng", "the West; Western countries"],
    ["要紧", "要緊", "yàojǐn", "important; urgent; essential"],
    ["精通", "精通", "jīngtōng", "proficient; have a good command of"],
    ["杀害", "殺害", "shāhài", "murder; slay; kill"],
    ["精确", "精確", "jīngquè", "accurate; precise"],
    ["清真寺", "清真寺", "qīngzhēnsì", "mosque"],
    ["天生", "天生", "tiānshēng", "innate; inherent; natural"],
    ["清新", "清新", "qīngxīn", "fresh and clean"],
    ["小学生", "小學生", "xiǎoxuéshēng", "primary school student"],
    ["性情", "性情", "xìngqíng", "nature; temperament"],
    ["围攻", "圍攻", "wéigōng", "besiege; attack from all sides"],
    ["生人", "生人", "shēngrén", "stranger; to give birth; to be born"],
    ["亲生", "親生", "qīnshēng", "one's own (children, parents)"],
    ["人性", "人性", "rénxìng", "human nature; humanity"],
    ["国情", "國情", "guóqíng", "the state of a nation"],
    ["沉静", "沉靜", "chénjìng", "peaceful; quiet; calm; gentle"],
    ["清查", "清查", "qīngchá", "investigate thoroughly; carefully inspect"],
    [
      "生前",
      "生前",
      "shēngqián",
      "before one's death; during one's lifetime; while living"
    ],
    ["无可奉告", "無可奉告", "wú kě fèng gào", '(idiom) "no comment"'],
    ["合情合理", "合情合理", "hé qíng hé lǐ", "reasonable and fair"],
    ["执勤", "執勤", "zhí qín", "be on duty"],
    [
      "精华",
      "精華",
      "jīnghuá",
      "most important part of an object; essence; quintessence"
    ],
    ["功绩", "功績", "gōngjì", "feat; achievement; contribution; merits"],
    ["情理", "情理", "qínglǐ", "reason; sense"],
    ["恩情", "恩情", "ēnqíng", "deep affection"],
    ["抗击", "抗擊", "kàngjī", "resist; oppose; fight back"],
    [
      "专科",
      "專科",
      "zhuānkē",
      "specialized subject; specialized training school"
    ],
    ["酒精", "酒精", "jiǔjīng", "alcohol; ethanol"],
    ["棒球", "棒球", "bàngqiú", "baseball"],
    ["特性", "特性", "tèxìng", "property; characteristic"],
    ["传授", "傳授", "chuánshòu", "impart; pass on; teach"],
    ["寂静", "寂靜", "jìjìng", "quiet"],
    [
      "责任制",
      "責任制",
      "zérènzhì",
      "system of job responsibility; sense of duty"
    ],
    ["毒性", "毒性", "dúxìng", "toxicity"],
    ["深情", "深情", "shēnqíng", "deep emotion; deep love"],
    ["精密", "精密", "jīngmì", "accuracy; exact; precise; refined"],
    [
      "专用",
      "專用",
      "zhuānyòng",
      "special use; dedicated; for a special purpose"
    ],
    ["生命力", "生命力", "shēngmìnglì", "life-force; vitality"],
    [
      "周转",
      "周轉",
      "zhōuzhuǎn",
      "turnover (in cash or personnel); have enough resources to cover a need"
    ],
    [
      "精打细算",
      "精打細算",
      "jīng dǎ xì suàn",
      "budget carefully; pinch pennies"
    ],
    [
      "专人",
      "專人",
      "zhuānrén",
      "specialist; person specifically appointed for a task; expert"
    ],
    ["零星", "零星", "língxīng", "fragmentary; random; sporadic"],
    [
      "好转",
      "好轉",
      "hǎozhuǎn",
      "mend; straighten up; improve; take a turn for the better"
    ],
    ["党性", "黨性", "dǎngxìng", "political party spirit or character"],
    ["案情", "案情", "ànqíng", "details of a case; case"],
    ["传记", "傳記", "zhuànjì", "biography"],
    ["人情", "人情", "rénqíng", "human emotions; feelings; affection; favor"],
    ["精心", "精心", "jīngxīn", "with utmost care; meticulous; detailed"],
    ["情感", "情感", "qínggǎn", "feeling; emotion; mood"],
    ["后勤", "后勤", "hòuqín", "logistics"],
    ["专制", "專制", "zhuānzhì", "autocracy; dictatorship"],
    [
      "定性",
      "定性",
      "dìngxìng",
      "qualitative; to determine chemical composition; to determine the nature (normally of an error or crime)"
    ],
    ["纪念", "紀念", "jìniàn", "commemorate; remember"],
    ["训练", "訓練", "xùnliàn", "to train; to drill; to exercise; training"],
    ["东北", "東北", "dōngběi", "northeast; Northeast China; Manchuria"],
    ["必要", "必要", "bìyào", "necessary; essential; indispensable"],
    ["西北", "西北", "xīběi", "Northwest"],
    ["东方", "東方", "dōngfāng", "the East; Eastern countries"],
    [
      "不要紧",
      "不要緊",
      "bú yàojǐn",
      "it's not serious; never mind; doesn't matter"
    ],
    ["西南", "西南", "xīnán", "southwest"],
    ["东南", "東南", "dōngnán", "southeast"],
    ["今后", "今后", "jīnhòu", "from now on; in the future"],
    ["西餐", "西餐", "xīcān", "Western-style food"],
    ["熟练", "熟練", "shúliàn", "practiced; proficient; skilled"],
    [
      "想念",
      "想念",
      "xiǎngniàn",
      "to miss; remember with longing; long to see again"
    ],
    ["将要", "將要", "jiāngyào", "will; shall; be going to"],
    ["至今", "至今", "zhì jīn", "up to now; so far"],
    ["如今", "如今", "rújīn", "nowadays"],
    ["概念", "概念", "gàiniàn", "concept; idea"],
    ["教练", "教練", "jiàoliàn", "coach; instructor"],
    ["要不然", "要不然", "yàoburán", "otherwise; or else"],
    ["观念", "觀念", "guānniàn", "sense; notion; thought; concept; idea"],
    ["怀念", "懷念", "huáiniàn", "cherish the memory of; think fondly of"],
    ["西服", "西服", "xīfú", "a suit; Western-style clothes"],
    ["要不是", "要不是", "yàobushì", "if it were not for; but for"],
    [
      "要不",
      "要不",
      "yàobù",
      "otherwise; or else; either... (or); how about...?"
    ],
    ["陈列", "陳列", "chénliè", "to display; to exhibit"],
    [
      "要好",
      "要好",
      "yàohǎo",
      "be on good terms; be close friends; be eager to improve oneself"
    ],
    ["思念", "思念", "sīniàn", "think of; long for; to miss"],
    ["信念", "信念", "xìnniàn", "faith; belief; conviction"],
    ["要点", "要點", "yàodiǎn", "main point; essential"],
    ["今日", "今日", "jīnrì", "today; the present; now"],
    ["含量", "含量", "hánliàng", "content; quantity contained"],
    ["次要", "次要", "cìyào", "secondary; less important"],
    ["指南针", "指南針", "zhǐnánzhēn", "compass"],
    ["包含", "包含", "bāohán", "to contain; to embody; to include"],
    ["股票", "股票", "gǔpiào", "shares; stock (finance)"],
    ["支票", "支票", "zhīpiào", "(bank) cheque (UK) or check (US); M: 本"],
    ["投票", "投票", "tóupiào", "vote; poll"],
    ["房东", "房東", "fángdōng", "landlord"],
    ["纪念品", "紀念品", "jìniànpǐn", "keepsake; souvenir; memento"],
    ["要么", "要麼", "yàome", "either one or another"],
    ["山腰", "山腰", "shānyāo", "halfway up a mount; lit. waist of a mountain"],
    [
      "新陈代谢",
      "新陳代謝",
      "xīn chén dàixiè",
      "metabolism (bio); (saying) the new replaces the old"
    ],
    ["念头", "念頭", "niàntou", "thought; idea; intention"],
    ["纪要", "紀要", "jìyào", "written summary of a meeting; minutes"],
    ["要素", "要素", "yàosù", "essential factor; key constituent"],
    [
      "要命",
      "要命",
      "yàomìng",
      "cause somebody's death; extremely; frighteningly; annoyance"
    ],
    ["东道主", "東道主", "dōngdàozhǔ", "host for a party or conference"],
    ["提要", "提要", "tíyào", "summary; abstract"],
    ["首要", "首要", "shǒuyào", "most important; chief; principal"],
    ["含义", "含義", "hányì", "implied meaning; connotation"],
    ["股东", "股東", "gǔdōng", "stockholder; shareholder"],
    ["陈旧", "陳舊", "chénjiù", "old fashioned; outmoded; obsolete"],
    ["要领", "要領", "yàolǐng", "essentials; main points; gist"],
    ["含有", "含有", "hányǒu", "contain"],
    ["挂念", "掛念", "guàniàn", "concerned about"],
    ["练兵", "練兵", "liàn bīng", "drill troops; train an army"],
    [
      "冻结",
      "凍結",
      "dòngjié",
      "to freeze; to congeal; (of loans, wages, prices, etc.) freeze; frozen (assets etc.)"
    ],
    [
      "陈述",
      "陳述",
      "chénshù",
      "allegation; assertation; to declare; to state"
    ],
    ["我们", "我們", "wǒmen5", "we; us"],
    ["他们", "他們", "tāmen5", "they; them"],
    ["问题", "問題", "wèntí", "question; problem; issue"],
    ["你们", "你們", "nǐmen5", "you (plural)"],
    ["时候", "時候", "shíhou", "time; length of time; moment"],
    ["时间", "時間", "shíjiān", "time; period"],
    ["决定", "決定", "juédìng", "decide; decision"],
    ["她们", "她們", "tāmen5", "they; them (for females)"],
    ["非常", "非常", "fēicháng", "extremely; extraordinary; very"],
    ["新闻", "新聞", "xīnwén", "news"],
    ["安排", "安排", "ānpái", "arrange; to plan"],
    ["中间", "中間", "zhōngjiān", "center; middle; between; among"],
    ["凉快", "涼快", "liángkuai", "pleasantly cool (temperature)"],
    ["简单", "簡單", "jiǎndān", "simple; uncomplicated"],
    ["它们", "它們", "tāmen5", "they; them (for things)"],
    ["房间", "房間", "fángjiān", "room"],
    ["排球", "排球", "páiqiú", "volleyball"],
    ["请问", "請問", "qǐng wèn", "may I ask..."],
    ["门口", "門口", "ménkǒu", "doorway; entrance; gate"],
    ["之间", "之間", "zhījiān", "between; among"],
    [
      "一块儿",
      "一塊兒",
      "yíkuàir5",
      "at the same place; in company; together; one block, piece, unit of money (erhua variant)"
    ],
    ["人们", "人們", "rénmen5", "people"],
    ["问好", "問好", "wèn hǎo", "say hello to; send one's regards to"],
    ["有时候", "有時候", "yǒu shíhou", "sometimes"],
    ["专门", "專門", "zhuānmén", "specialist; specialized; customized"],
    ["依靠", "依靠", "yīkào", "rely on; depend on"],
    ["快乐", "快樂", "kuàilè", "happy"],
    [
      "坚决",
      "堅決",
      "jiānjué",
      "Persistent in doing something; resolute; determined; uncompromising"
    ],
    ["决心", "決心", "juéxīn", "determined; resolute"],
    ["可靠", "可靠", "kěkào", "reliable; trustworthy"],
    ["筷子", "筷子", "kuàizi", "chopsticks"],
    ["问候", "問候", "wènhòu", "extend greetings; send regards to"],
    ["空间", "空間", "kōngjiān", "space; open air"],
    ["学问", "學問", "xuéwen5", "learning; knowledge"],
    ["车间", "車間", "chējiān", "workshop"],
    ["非不可", "非不可", "fēi ... bùkě", "must...; have to..."],
    ["犯罪", "犯罪", "fànzuì", "crime; commit a crime"],
    ["简直", "簡直", "jiǎnzhí", "simply; at all"],
    ["闻名", "聞名", "wénmíng", "well-known; famous; renowned"],
    ["顾问", "顧問", "gùwèn", "adviser; consultant"],
    ["出门", "出門", "chū mén", "go out; leave home"],
    ["靠近", "靠近", "kàojìn", "near; come closer; approach"],
    ["人间", "人間", "rénjiān", "the human world; the world; earth"],
    ["快餐", "快餐", "kuàicān", "fast food; snack"],
    ["闲话", "閒話", "xiánhuà", "gossip; digression"],
    ["排列", "排列", "páiliè", "arrange; align; permutation"],
    ["决议", "決議", "juéyì", "a resolution; formal statement"],
    ["快活", "快活", "kuàihuo", "happy; cheerful"],
    ["飞快", "飛快", "fēikuài", "very fast; swiftly; rapid"],
    [
      "夜间",
      "夜間",
      "yèjiān",
      "nighttime; at night; evening or night (i.e. classes)"
    ],
    ["对门", "對門", "duìmén", "opposite building or room"],
    ["罪行", "罪行", "zuìxíng", "crime; guilt; offense"],
    ["提问", "提問", "tíwèn", "to question; to quiz"],
    [
      "走后门儿",
      "走后門兒",
      "zǒu hòuménr5",
      "gain advantages through connections; get in through the back door"
    ],
    ["排斥", "排斥", "páichì", "to reject; repulse; exclude"],
    ["等候", "等候", "děnghòu", "wait; queue"],
    ["决口", "決口", "jué kǒu", "be breached; burst"],
    [
      "反问",
      "反問",
      "fǎnwèn",
      "ask a rhetorical question; answer a question with a question"
    ],
    ["是非", "是非", "shìfēi", "right and wrong; truth and fiction; quarrel"],
    ["简便", "簡便", "jiǎnbiàn", "simple and convenient; handy"],
    ["决赛", "決賽", "juésài", "finals (of a competition); final match"],
    ["尽快", "儘快", "jǐnkuài", "as quickly as possible"],
    ["非法", "非法", "fēifǎ", "illegal"],
    ["排队", "排隊", "pái duì", "queue; stand in line"],
    ["罪犯", "罪犯", "zuìfàn", "criminal, offender, culprit"],
    ["判决", "判決", "pànjué", "judgment (by a court); adjudicate"],
    [
      "决不",
      "決不",
      "jué bù",
      "not at all; simply (can) not; under no circumstance"
    ],
    [
      "简称",
      "簡稱",
      "jiǎnchēng",
      "shortened form; abbreviation; to call for short"
    ],
    ["简短", "簡短", "jiǎnduǎn", "brief; short-duration"],
    [
      "门当户对",
      "門當戶對",
      "mén dāng hù duì",
      "be well matched in social and economic status"
    ],
    ["简明", "簡明", "jiǎnmíng", "simple and clear; concise"],
    ["问答", "問答", "wèndá", "question and answer; interlocution"],
    ["简体字", "簡體字", "jiǎntǐzì", "simplified Chinese characters"],
    ["过问", "過問", "guòwèn", "take an interest in; get involved with"],
    ["并非", "并非", "bìngfēi", "really not; really isn't; not at all"],
    ["简化", "簡化", "jiǎnhuà", "simplify; simplification"],
    ["轻快", "輕快", "qīngkuài", "light and quick; brisk; spry; lively"],
    ["追问", "追問", "zhuīwèn", "question closely; investigate in detail"],
    ["问世", "問世", "wènshì", "be published; to come out"],
    ["田间", "田間", "tiánjiān", "field; farm; farming"],
    ["决战", "決戰", "juézhàn", "decisive battle"],
    [
      "似是而非",
      "似是而非",
      "sì shì ér fēi",
      "(saying) appeared right but actually was wrong"
    ],
    ["精简", "精簡", "jīngjiǎn", "simplify; cut; reduce"],
    [
      "似笑非笑",
      "似笑非笑",
      "sì xiào fēi xiào",
      "(saying) resemble a smile yet not a smile"
    ],
    ["否决", "否決", "fǒujué", "to veto; vote down; overrule"],
    ["无非", "無非", "wúfēi", "nothing but; no more than; only"],
    ["罪名", "罪名", "zuìmíng", "criminal charge; accusation"],
    ["决策", "決策", "juécè", "determine policy; make strategic decision"],
    ["候选人", "候選人", "hòuxuǎnrén", "candidate"],
    [
      "候补",
      "候補",
      "hòubǔ",
      "a candidate for a vacancy; an alternate; wait to fill a vacancy"
    ],
    ["决算", "決算", "juésuàn", "final account; to calculate the final bill"],
    ["并排", "并排", "bìngpái", "side by side; abreast"],
    ["简易", "簡易", "jiǎnyì", "simple; easy"],
    ["处决", "處決", "chǔjué", "put to death; execute"],
    ["得罪", "得罪", "dézuì", "offend; violate; a faux pas"],
    ["简要", "簡要", "jiǎnyào", "concise; brief"],
    ["间接", "間接", "jiànjiē", "indirect"],
    ["罪状", "罪狀", "zuìzhuàng", "accusation"],
    ["裁决", "裁決", "cáijué", "ruling; adjudication"],
    ["重要", "重要", "zhòngyào", "important; significant; major"],
    ["结束", "結束", "jiéshù", "end; finish; conclude"],
    ["干净", "干淨", "gānjìng", "clean; neat and tidy"],
    [
      "除了以外",
      "除了以外",
      "chúle ... yǐwài",
      "except for ...; aside from ..."
    ],
    ["重视", "重視", "zhòngshì", "to value; take seriously"],
    ["速度", "速度", "sùdù", "speed; rate; velocity"],
    ["赶快", "趕快", "gǎnkuài", "at once; immediately; quickly"],
    [
      "整理",
      "整理",
      "zhěnglǐ",
      "put in order; arrange; straighten up; to tidy; to pack (luggage)"
    ],
    ["整个", "整個", "zhěnggè", "whole; entire; total"],
    ["重新", "重新", "chóngxīn", "again; anew; once more"],
    ["于是", "於是", "yúshì", "therefore; hence; as a result; consequently"],
    ["赶紧", "趕緊", "gǎnjǐn", "at once; hurriedly; lose no time"],
    ["重大", "重大", "zhòngdà", "great; important; major"],
    ["由于", "由於", "yóuyú", "due to; as a result of; thanks to"],
    ["等于", "等於", "děngyú", "(mathematics) equal to"],
    ["终于", "終於", "zhōngyú", "at last; in the end; finally"],
    [
      "调整",
      "調整",
      "tiáozhěng",
      "adjust; readjust; regulate; restructure; balance"
    ],
    ["完整", "完整", "wánzhěng", "complete; intact"],
    [
      "前途",
      "前途",
      "qiántú",
      "way forward; prospects; outlook for the future"
    ],
    ["重复", "重復", "chóngfù", "to repeat; to duplicate"],
    [
      "对于",
      "對於",
      "duìyú",
      "regarding; as far as sth. is concerned; with regards to; for"
    ],
    ["懂得", "懂得", "dǒngde", "understand; to grasp; know"],
    ["干杯", "干杯", "gān bēi", "drink a toast; cheers!; bottoms up!"],
    ["干脆", "干脆", "gāncuì", "simply; straightforward; clear-cut; blunt"],
    ["迅速", "迅速", "xùnsù", "fast; quick; rapid"],
    ["重点", "重點", "zhòngdiǎn", "emphasis; main point"],
    ["重量", "重量", "zhòngliàng", "weight"],
    ["善于", "善於", "shànyú", "be good at; excel at"],
    ["干活儿", "干活兒", "gànhuór5", "do manual labor; to work"],
    ["旅途", "旅途", "lv3tú", "journey; trip"],
    [
      "尊重",
      "尊重",
      "zūnzhòng",
      "to respect; to value; to esteem; to honor; eminent; serious; proper"
    ],
    ["高速", "高速", "gāosù", "high speed"],
    ["除非", "除非", "chúfēi", "only if; unless"],
    [
      "加速",
      "加速",
      "jiāsù",
      "to quicken; to speed up; to accelerate; to expedite; to hasten"
    ],
    ["至于", "至於", "zhìyú", "as for; as to; go so far as to"],
    ["干涉", "干涉", "gānshè", "interfere; intervene; meddle"],
    ["整体", "整體", "zhěngtǐ", "whole; entirety"],
    ["沉重", "沉重", "chénzhòng", "heavy; hard; serious; critical"],
    ["多余", "多余", "duōyú", "unnecessary; superfluous；surplus"],
    ["开除", "開除", "kāichú", "expel; to discharge; to kick out"],
    ["在于", "在於", "zàiyú", "lie in; be in; rest with; depend on"],
    ["位于", "位於", "wèiyú", "be located at"],
    ["处于", "處於", "chǔyú", "be in (some state, position, or condition)"],
    ["深重", "深重", "shēnzhòng", "grave; very serious"],
    ["除外", "除外", "chúwài", "exclude; exclusiveness; except for"],
    ["追赶", "追趕", "zhuīgǎn", "chase after; pursue; catch up with; overtake"],
    [
      "包干儿",
      "包干兒",
      "bāogānr5",
      "be responsible for a job until completion"
    ],
    ["除此之处", "除此之處", "chúcǐzhīchù", "in addition"],
    ["才干", "才干", "cáigàn", "ability; competence"],
    ["中途", "中途", "zhōngtú", "midway; halfway"],
    ["干线", "干線", "gànxiàn", "main road; primary route; trunk line"],
    ["发现", "發現", "fāxiàn", "discover; to find"],
    ["发生", "發生", "fāshēng", "happen; occur; take place"],
    ["欢迎", "歡迎", "huānyíng", "to welcome; greet"],
    ["医院", "醫院", "yīyuàn", "hospital"],
    ["医生", "醫生", "yīshēng", "doctor; physician"],
    ["出发", "出發", "chūfā", "start out; set off"],
    ["发烧", "發燒", "fāshāo", "have a fever"],
    ["痛快", "痛快", "tòngkuai", "joyful; delighted; very happy; jolly"],
    ["看病", "看病", "kàn bìng", "visit a doctor; see a patient"],
    ["地区", "地區", "dìqū", "an area; a region; a district"],
    [
      "发表",
      "發表",
      "fābiǎo",
      "publish; to issue (a statement); announce; express one's opinion"
    ],
    [
      "发挥",
      "發揮",
      "fāhuī",
      "to display; to bring (skill, talent, etc.) into play; to develop (an idea)"
    ],
    [
      "发达",
      "發達",
      "fādá",
      "developed (country, etc.); flourishing; prosperous"
    ],
    ["头发", "頭發", "tóufa", "hair (on the head)"],
    ["病人", "病人", "bìngrén", "a patient; sick person"],
    ["沙发", "沙發", "shāfā", "sofa"],
    [
      "医学",
      "醫學",
      "yīxué",
      "medicine; medical science; the study of medicine"
    ],
    ["痛苦", "痛苦", "tòngkǔ", "pain; suffering; agony"],
    ["迎接", "迎接", "yíngjiē", "meet; greet; to welcome"],
    ["登记", "登記", "dēngjì", "register (one's name); check in; enroll"],
    ["发出", "發出", "fāchū", "send out; to issue (an order, a sound, etc.)"],
    ["发明", "發明", "fāmíng", "invent; invention"],
    ["区别", "區別", "qūbié", "difference; distinguish"],
    ["病房", "病房", "bìngfáng", "hospital ward; sickroom"],
    ["医务室", "醫務室", "yīwùshì", "clinic; infirmary"],
    ["发动", "發動", "fādòng", "to start (e.g. a car); to launch; to mobilize"],
    ["山区", "山區", "shānqū", "mountainous area"],
    ["理发", "理發", "lǐfà", "hairdressing; haircut; barber"],
    ["发言", "發言", "fāyán", "make a speech; statement"],
    ["开发", "開發", "kāifā", "develop; to exploit (a resource)"],
    ["生病", "生病", "shēng bìng", "get sick; fall ill"],
    ["自治区", "自治區", "zìzhìqū", "autonomous region"],
    ["发射", "發射", "fāshè", "launch; shoot (a projectile); fire (a rocket)"],
    [
      "中医",
      "中醫",
      "zhōngyī",
      "traditional Chinese medicine; practitioner of traditional Chinese medicine"
    ],
    [
      "西医",
      "西醫",
      "xīyī",
      "Western medicine; a doctor trained in Western medicine"
    ],
    ["得病", "得病", "dé bìng", "fall ill; get sick; contract a disease"],
    ["废除", "廢除", "fèichú", "abolish; annul"],
    ["病床", "病床", "bìngchuáng", "hospital bed; sickbed"],
    [
      "疯狂",
      "瘋狂",
      "fēngkuáng",
      "crazy; madness; wild; extreme popularity; insane; frenzied; unbridled"
    ],
    ["病情", "病情", "bìngqíng", "state of an illness; patient's condition"],
    ["发育", "發育", "fāyù", "development; growth (of living things)"],
    ["发觉", "發覺", "fājué", "find; discover; detect"],
    ["蚊子", "蚊子", "wénzi", "mosquito"],
    ["这会儿", "這會兒", "zhèhuìr5", "now; at the moment"],
    ["产值", "產值", "chǎnzhí", "output value"],
    [
      "这样一来",
      "這樣一來",
      "zhèyàng yì lái",
      "thus; in so doing; in such a case"
    ],
    ["鲜艳", "鮮豔", "xiānyàn", "bright-colored"],
    ["色彩", "色彩", "sècǎi", "tint; color; hue"],
    ["增产", "增產", "zēng chǎn", "increase production"],
    ["杂文", "雜文", "záwén", "(satirical) essay"],
    ["光彩", "光彩", "guāngcǎi", "splendor; radiance; brilliance; honor"],
    ["产物", "產物", "chǎnwù", "result; product"],
    ["参考", "參考", "cānkǎo", "to reference; refer to; consult"],
    ["形态", "形態", "xíngtài", "shape; form; pattern; morphology"],
    ["语文", "語文", "yǔwén", "language and literature"],
    ["散文", "散文", "sǎnwén", "prose; essay"],
    ["必修", "必修", "bìxiū", "required course"],
    ["天文", "天文", "tiānwén", "astronomy"],
    ["丰产", "丰產", "fēngchǎn", "high yield; bumper crop"],
    ["修正", "修正", "xiūzhèng", "revise; revision; amend"],
    ["地形", "地形", "dìxíng", "terrain; topography; landscape; landform"],
    ["兑换", "兌換", "duìhuàn", "to exchange; to convert (currencies)"],
    ["转换", "轉換", "zhuǎnhuàn", "to transform; to change; to convert"],
    ["英明", "英明", "yīngmíng", "wise; brilliant"],
    ["无产阶级", "無產階級", "wúchǎn jiējí", "proletariat"],
    [
      "资产阶级",
      "資產階級",
      "zīchǎnjiējí",
      "the capitalist class; the bourgeoisie"
    ],
    ["特色", "特色", "tèsè", "characteristic; distinguishing feature"],
    ["国产", "國產", "guóchǎn", "made in one's own country"],
    ["维修", "維修", "wéixiū", "maintain (of equipment); to mend; repair"],
    ["特产", "特產", "tèchǎn", "special or unique product"],
    ["修养", "修養", "xiūyǎng", "accomplishment; self-cultivation"],
    ["绝望", "絕望", "juéwàng", "to despair; hopelessness"],
    ["把手", "把手", "bǎshou", "knob; handle; grip"],
    ["文人", "文人", "wénrén", "scholar; literati; man of letters"],
    ["图形", "圖形", "túxíng", "picture; figure; graph"],
    [
      "须知",
      "須知",
      "xūzhī",
      "prerequisites; knowledge requirement; key information"
    ],
    [
      "党中央",
      "黨中央",
      "dǎngzhōngyāng",
      "(Chinese Communist) Party Central Committee"
    ],
    ["救济", "救濟", "jiùjì", "emergency relief; aid; help out in a disaster"],
    ["产地", "產地", "chǎndì", "place (of production); manufacturing location"],
    ["草率", "草率", "cǎoshuài", "careless; negligent; sloppy"],
    ["调换", "調換", "diàohuàn", "exchange; change places; change"],
    ["参议院", "參議院", "cānyìyuàn", "Senate"],
    ["出色", "出色", "chūsè", "remarkable; outstanding; excellent"],
    [
      "形而上学",
      "形而上學",
      "xíng'érshàngxué",
      "(saying) outside actual experience; metaphysics"
    ],
    ["外形", "外形", "wàixíng", "figure; shape; external form; contour"],
    ["产区", "產區", "chǎnqū", "place of production; manufacturing location"],
    ["修复", "修復", "xiūfù", "restoration; repair"],
    ["超产", "超產", "chāo chǎn", "exceed a production goal"],
    ["生产率", "生產率", "shēngchǎnlv4", "labor productivity; efficiency"],
    ["天色", "天色", "tiānsè", "time of the day; weather conditions"],
    ["参与", "參與", "cānyù", "participate in"],
    [
      "投产",
      "投產",
      "tóuchǎn",
      "(of a factory) to go into operation; to put into production"
    ],
    [
      "参观",
      "參觀",
      "cānguān",
      "to visit (a place, such as a tourist spot); to tour; inspect"
    ],
    ["文章", "文章", "wénzhāng", "article; essay"],
    ["这儿", "這兒", "zhèr5", "here"],
    ["文学", "文學", "wénxué", "literature"],
    ["文艺", "文藝", "wényì", "literature and art"],
    ["英文", "英文", "Yīngwén", "English (language)"],
    ["颜色", "顏色", "yánsè", "color; countenance; facial expression"],
    ["精彩", "精彩", "jīngcǎi", "brilliant; spectacular; wonderful"],
    ["整齐", "整齊", "zhěngqí", "tidy; neat; in good order"],
    ["文学家", "文學家", "wénxuéjiā", "writer; man/woman of letters"],
    ["课文", "課文", "kèwén", "text (of a lesson)"],
    ["日文", "日文", "Rìwén", "Japanese language"],
    ["法文", "法文", "Fǎwén", "French (language)"],
    ["外文", "外文", "wàiwén", "(written) foreign language"],
    ["产品", "產品", "chǎnpǐn", "product; goods; merchandise"],
    ["形式", "形式", "xíngshì", "form; shape; mode"],
    ["产生", "產生", "chǎnshēng", "to produce; emerge; give rise to"],
    ["绝对", "絕對", "juéduì", "absolute; definite, absolutely"],
    ["产量", "產量", "chǎnliàng", "output; yield"],
    ["文明", "文明", "wénmíng", "civilization; civilized; culture"],
    ["中央", "中央", "zhōngyāng", "central; middle; center"],
    ["文物", "文物", "wénwù", "cultural relic; historical relic"],
    ["形成", "形成", "xíngchéng", "to take shape; to form"],
    ["彩色", "彩色", "cǎisè", "color; colorful"],
    ["情形", "情形", "qíngxing5", "circumstances; situation"],
    ["修理", "修理", "xiūlǐ", "to repair; perform maintenance; to overhaul"],
    ["英雄", "英雄", "yīngxióng", "hero"],
    ["德文", "德文", "Déwén", "German (language)"],
    ["文字", "文字", "wénzì", "characters; script; writing"],
    ["形容", "形容", "xíngróng", "describe; appearance; look"],
    ["影子", "影子", "yǐngzi", "shadow; reflection"],
    ["作文", "作文", "zuò wén", "write an essay; essay"],
    ["率领", "率領", "shuàilǐng", "to lead; to command; to head"],
    ["这边", "這邊", "zhèbiān", "this side; here"],
    ["效率", "效率", "xiàolv4", "efficiency"],
    ["文件", "文件", "wénjiàn", "document; file"],
    ["英勇", "英勇", "yīngyǒng", "bravery; heroic; valiant; gallant"],
    ["形状", "形狀", "xíngzhuàng", "form; figure; shape"],
    ["形势", "形勢", "xíngshì", "circumstances; situation; terrain"],
    ["一齐", "一齊", "yìqí", "at the same time; in unison; simultaneously"],
    ["交换", "交換", "jiāohuàn", "to exchange; to swap; to switch"],
    ["论文", "論文", "lùnwén", "thesis; paper; treatise"],
    ["修改", "修改", "xiūgǎi", "to amend; to modify; to revise; to alter"],
    ["财产", "財產", "cáichǎn", "property; fortune; assets"],
    ["修建", "修建", "xiūjiàn", "to build; to construct; renovate"],
    ["把握", "把握", "bǎwò", "grasp; hold; certainty; assurance"],
    ["景色", "景色", "jǐngsè", "scenery; landscape; scene; view"],
    ["影片", "影片", "yǐngpiàn", "film; movie"],
    ["破产", "破產", "pòchǎn", "go bankrupt; go broke; bankruptcy"],
    [
      "选修",
      "選修",
      "xuǎnxiū",
      "to take an optional course; optional course (in school)"
    ],
    ["赶忙", "趕忙", "gǎnmáng", "hurry; hastily"],
    [
      "速成",
      "速成",
      "sùchéng",
      "achieve rapidly; gain quick mastery (of a course or subject)"
    ],
    ["着重", "着重", "zhuózhòng", "put emphasis on; to stress"],
    ["干旱", "干旱", "gānhàn", "arid; dry"],
    ["用途", "用途", "yòngtú", "use; application; purpose"],
    ["载重", "載重", "zàizhòng", "carrying capacity"],
    ["便于", "便於", "biànyú", "easy; convenient for"],
    [
      "赶上",
      "趕上",
      "gǎnshàng",
      "to catch up with; to be in time for; to meet with or chance upon"
    ],
    ["敢于", "敢於", "gǎnyú", "have the courage to; dare to; be bold in"],
    ["清除", "清除", "qīngchú", "to eliminate; to get rid of"],
    ["懂事", "懂事", "dǒngshì", "be intelligent; be sensible; thoughtful"],
    ["骨干", "骨干", "gǔgàn", "backbone; mainstay"],
    [
      "若干",
      "若干",
      "ruògān",
      "a certain number or amount; how many; how much"
    ],
    ["整风", "整風", "zhěng fēng", "rectify incorrect work styles"],
    [
      "消除",
      "消除",
      "xiāochú",
      "eliminate; remove; clear up (abstract things）"
    ],
    ["整天", "整天", "zhěngtiān", "all day long; day and night"],
    ["快速", "快速", "kuàisù", "high-speed; rapid; fast"],
    ["重申", "重申", "chóngshēn", "reiterate; reaffirm"],
    ["保重", "保重", "bǎozhòng", "take care (of oneself)"],
    ["注重", "注重", "zhùzhòng", "to pay attention to; to emphasize"],
    ["整整", "整整", "zhěngzhěng", "whole; full; exactly; make sb. suffer"],
    ["加重", "加重", "jiāzhòng", "make more serious; increase the weight of"],
    ["体重", "體重", "tǐzhòng", "body weight"],
    [
      "急于",
      "急於",
      "jíyú",
      "anxious; impatient; want to do something right away"
    ],
    ["除夕", "除夕", "chúxī", "Lunar New Year's Eve"],
    [
      "不至于",
      "不至於",
      "búzhìyú",
      "cannot go so far; not to such an extent as to"
    ],
    [
      "大于",
      "大於",
      "dàyú",
      "greater than; used between nouns to indicate relative magnitude; A is bigger than B"
    ],
    ["过于", "過於", "guòyú", "too much; excessively"],
    ["重型", "重型", "zhòngxíng", "heavy duty"],
    ["排除", "排除", "páichú", "eliminate; get rid of; remove"],
    ["树干", "樹干", "shùgàn", "tree trunk"],
    ["勇于", "勇於", "yǒngyú", "have the courage to; be brave enough to"],
    ["对岸", "對岸", "duì'àn", "opposite bank (of a body of water)"],
    [
      "口岸",
      "口岸",
      "kǒu'àn",
      "a trading port (on sea or river); customs; a trading or transit post on a border between countries"
    ],
    [
      "斩草除根",
      "斬草除根",
      "zhǎn cǎo chú gēn",
      "cut weeds and eliminate the roots; completely eliminate"
    ],
    ["约束", "約束", "yuēshù", "restrict; limit to; constrain; restriction"],
    ["富余", "富余", "fùyu", "surplus; more than needed"],
    ["破除", "破除", "pòchú", "eliminate; do away with; eradicate"],
    ["重心", "重心", "zhòngxīn", "center of gravity; central core; main part"],
    ["限于", "限於", "xiànyú", "restrict at; limit to"],
    ["整数", "整數", "zhěngshù", "integer; whole number; round figure"],
    ["比重", "比重", "bǐzhòng", "proportion; specific gravity"],
    [
      "扫除",
      "掃除",
      "sǎochú",
      "sweep away (often figurative); clean with a brush"
    ],
    ["抗旱", "抗旱", "kàng hàn", "drought-resistant"],
    ["庄重", "莊重", "zhuāngzhòng", "grave; solemn; dignified"],
    ["旱灾", "旱災", "hànzāi", "drought"],
    ["海岸", "海岸", "hǎi'àn", "coastal; seacoast"],
    ["干预", "干預", "gānyù", "meddle; intervene; intervention"],
    [
      "一干二净",
      "一干二淨",
      "yìgān'èrjìng",
      "(saying) thoroughly; completely"
    ],
    ["平整", "平整", "píngzhěng", "smooth; level off; remove any bumps"],
    ["发行", "發行", "fāxíng", "publish; issue; distribute; release"],
    ["废话", "廢話", "fèihuà", "nonsense; rubbish"],
    ["发布", "發布", "fābù", "issue; announce; release"],
    [
      "发票",
      "發票",
      "fāpiào",
      "receipt or bill for purchase; (government certified) invoice"
    ],
    [
      "发起",
      "發起",
      "fāqǐ",
      "to originate; to initiate; to launch (an attack, an initiative, etc.); to sponsor; to start; to propose sth. (for the first time)"
    ],
    ["发炎", "發炎", "fāyán", "become inflamed from infection or injury"],
    ["发财", "發財", "fā cái", "to get rich; to make a fortune"],
    ["信仰", "信仰", "xìnyǎng", "firm belief; faith; believe in (a religion)"],
    ["发愁", "發愁", "fā chóu", "worry about sth."],
    ["发病", "發病", "fā bìng", "onset (of a disease); outbreak"],
    [
      "病号",
      "病號",
      "bìnghào",
      "sick personnel; person on the sick list; patient"
    ],
    ["作废", "作廢", "zuòfèi", "expire; lose validity"],
    ["沉痛", "沉痛", "chéntòng", "deep grief; bitter; resentful"],
    [
      "废品",
      "廢品",
      "fèipǐn",
      "production rejects; useless product; discarded material"
    ],
    ["废物", "廢物", "fèiwù", "rubbish; waste material; useless person"],
    [
      "医药",
      "醫藥",
      "yīyào",
      "medical care and medicines; medicine (drug); medical; pharmaceutical"
    ],
    [
      "打发",
      "打發",
      "dǎfa",
      "dispatch somebody to do something; to send sb. away; to pass the time"
    ],
    ["发火", "發火", "fā huǒ", "become angry; ignite; catch fire; detonate"],
    ["病虫害", "病虫害", "bìngchónghài", "plant diseases and insect pests"],
    ["发热", "發熱", "fā rè", "have a fever; feverish; emit heat"],
    ["散发", "散發", "sànfā", "distribute; emit"],
    ["医治", "醫治", "yīzhì", "treat (an illness); cure; heal"],
    ["批发", "批發", "pīfā", "wholesale"],
    ["激发", "激發", "jīfā", "arouse; excite"],
    [
      "半途而废",
      "半途而廢",
      "bàn tú ér fèi",
      "give up halfway; leave sth. unfinished"
    ],
    ["林区", "林區", "línqū", "forested area; woods"],
    ["登陆", "登陸", "dēnglù", "to land; come ashore; sign/log in"],
    ["疯子", "瘋子", "fēngzi", "madman; lunatic"],
    ["自发", "自發", "zìfā", "spontaneous; unprompted"],
    ["禁区", "禁區", "jìnqū", "forbidden area; forbidden zone"],
    ["病毒", "病毒", "bìngdú", "virus"],
    [
      "特区",
      "特區",
      "tèqū",
      "(abbr. for ～别行政～) Special administrative region; special zone"
    ],
    ["军医", "軍醫", "jūnyī", "military doctor"],
    ["出发点", "出發點", "chūfādiǎn", "starting point; the outset"],
    [
      "区分",
      "區分",
      "qūfēn",
      "differentiate; find differing aspects; find the difference between"
    ],
    ["医务", "醫務", "yīwù", "medical affairs"],
    ["这个", "這個", "zhège", "this"],
    ["这样", "這樣", "zhèyàng", "this way; this (kind of, sort of); like this"],
    ["经济", "經濟", "jīngjì", "economy; economic"],
    ["中文", "中文", "Zhōngwén", "Chinese (language)"],
    ["文化", "文化", "wénhuà", "culture, civilization; education; literacy"],
    ["这些", "這些", "zhèxiē", "these"],
    ["这里", "這里", "zhèlǐ", "here"],
    [
      "参加",
      "參加",
      "cānjiā",
      "participate; join (a group); take part in (an activity); give (advice)"
    ],
    ["爸爸", "爸爸", "bàba", "father; dad"],
    ["这么", "這麼", "zhème", "so (much); such; this way; like this"],
    ["生产", "生產", "shēngchǎn", "to produce; manufacture; give birth"],
    ["影响", "影響", "yǐngxiǎng", "influence; affect; effect"],
    ["英语", "英語", "Yīngyǔ", "English (language)"],
    ["必须", "必須", "bìxū", "must; have to"],
    ["减产", "減產", "jiǎn chǎn", "reduction of output; a drop in crop yield"],
    ["断绝", "斷絕", "duànjué", "to sever; to break off"],
    [
      "百花齐放",
      "百花齊放",
      "bǎi huā qí fàng",
      "(saying) a hundred flowers bloom; let the arts have free expression"
    ],
    ["出产", "出產", "chūchǎn", "output; produce; manufacture"],
    ["剪彩", "剪彩", "jiǎn cǎi", "cut the ribbon at an opening ceremony"],
    ["文盲", "文盲", "wénmáng", "illiterate"],
    ["水产", "水產", "shuǐchǎn", "aquatic product"],
    [
      "投机倒把",
      "投機倒把",
      "tóujī dǎobǎ",
      "engage in speculation and profiteering"
    ],
    ["高产", "高產", "gāochǎn", "high yielding"],
    ["更换", "更換", "gēnghuàn", "to change; to exchange; replace"],
    ["眼色", "眼色", "yǎnsè", "a wink; signal with one's eyes"],
    ["花色", "花色", "huāsè", "(variety of) designs and colors"],
    ["参照", "參照", "cānzhào", "refer to; cross-reference"],
    ["资产", "資產", "zīchǎn", "property; assets"],
    ["神色", "神色", "shénsè", "expression; look"],
    ["云彩", "雲彩", "yúncai", "(informal) cloud"],
    ["巴结", "巴結", "bājie", "fawn on; curry favor with"],
    ["农产品", "農產品", "nóngchǎnpǐn", "agricultural product; farm produce"],
    ["这么着", "這麼着", "zhèmezhe", "this way; in this manner"],
    ["文言", "文言", "wényán", "classical Chinese"],
    ["古文", "古文", "gǔwén", "ancient prose; classical Chinese writing"],
    ["谢绝", "謝絕", "xièjué", "politely refuse"],
    ["参军", "參軍", "cān jūn", "join the army; enlist"],
    ["生产力", "生產力", "shēngchǎnlì", "production capability; productivity"],
    ["齐全", "齊全", "qíquán", "complete; all ready"],
    ["把柄", "把柄", "bǎbǐng", "a handle; a handhold"],
    ["替换", "替換", "tìhuàn", "exchange; replace; switch"],
    ["频率", "頻率", "pínlv4", "frequency"],
    ["条文", "條文", "tiáowén", "clause; an explanatory section in a document"],
    ["人参", "人參", "rénshēn", "ginseng"],
    ["把戏", "把戲", "bǎxì", "acrobatics; jugglery; cheap trick; game"],
    ["叫唤", "叫喚", "jiàohuan5", "cry out; bark out a sound"],
    ["换取", "換取", "huànqǔ", "to exchange sth for sth else"],
    ["文艺界", "文藝界", "wényìjiè", "art and literature circles"],
    ["星期", "星期", "xīngqī", "week"],
    ["基本", "基本", "jīběn", "basic; fundamental"],
    ["基础", "基礎", "jīchǔ", "base; foundation"],
    ["尤其", "尤其", "yóuqí", "especially; particularly"],
    ["跳舞", "跳舞", "tiào wǔ", "to dance"],
    ["星期日", "星期日", "xīngqīrì", "Sunday"],
    ["贵姓", "貴姓", "guì xìng", "(honorable) surname"],
    ["星期天", "星期天", "xīngqītiān", "Sunday"],
    ["其他", "其他", "qítā", "other; else"],
    ["学期", "學期", "xuéqī", "semester; school term"],
    ["期间", "期間", "qījiān", "period of time; time; during"],
    ["时期", "時期", "shíqī", "period in time or history; period; time"],
    ["其中", "其中", "qízhōng", "among; in; included among these"],
    ["其次", "其次", "qícì", "next; secondly"],
    ["日期", "日期", "rìqī", "date"],
    ["宝贵", "寶貴", "bǎoguì", "valuable; precious; value"],
    ["其余", "其余", "qíyú", "the others; the rest; remaining"],
    ["极其", "极其", "jíqí", "extremely; exceedingly"],
    ["其它", "其它", "qítā", "other; else (objects, animals, events)"],
    ["短期", "短期", "duǎnqī", "short-term"],
    ["鼓舞", "鼓舞", "gǔwǔ", "heartening (news); to boost (morale)"],
    ["其实", "其實", "qíshí", "actually; in fact"],
    ["甚至", "甚至", "shènzhì", "even (to the point of); so much so that"],
    ["珍贵", "珍貴", "zhēnguì", "precious; valuable"],
    ["遗憾", "遺憾", "yíhàn", "regret; pity; feel sorry"],
    ["舞台", "舞台", "wǔtái", "stage; arena"],
    ["某些", "某些", "mǒuxiē", "some; certain"],
    ["与其", "與其", "yǔqí", "rather than; better than"],
    ["初期", "初期", "chūqī", "initial stage; beginning period; early days"],
    ["早期", "早期", "zǎoqī", "early period; early stage"],
    ["遗产", "遺產", "yíchǎn", "inheritance; heritage; legacy"],
    ["舞会", "舞會", "wǔhuì", "dance; ball; party"],
    [
      "甚至于",
      "甚至於",
      "shènzhìyú",
      "even (to the extent that); so much so that"
    ],
    ["基地", "基地", "jīdì", "base (of operations)"],
    ["遗留", "遺留", "yíliú", "legacy; leave over; hand down"],
    ["基层", "基層", "jīcéng", "basic level; grassroots level"],
    [
      "伊斯兰教",
      "伊斯蘭教",
      "Yīsīlánjiào",
      "Islam religion; Muslim religion"
    ],
    ["定期", "定期", "dìngqī", "regularly; at regular intervals; set a date"],
    ["按期", "按期", "ànqī", "on schedule; on time"],
    ["期望", "期望", "qīwàng", "earnestly hope or expect; expectation"],
    ["基督教", "基督教", "jīdūjiào", "Christianity"],
    ["舞厅", "舞廳", "wǔtīng", "dance hall; ballroom"],
    ["周期", "周期", "zhōuqī", "period; cycle; rhythm"],
    [
      "为期",
      "為期",
      "wéiqī",
      "be scheduled for; last for (a certain duration)"
    ],
    ["遗体", "遺體", "yítǐ", "remains (of a dead person)"],
    ["前期", "前期", "qiánqī", "preceding period; early stage"],
    ["预期", "預期", "yùqī", "expect; expected; anticipate"],
    ["基金", "基金", "jījīn", "fund; endowment"],
    ["法西斯", "法西斯", "fǎxīsī", "fascist"],
    ["遗失", "遺失", "yíshī", "lose; lose due to carelessness"],
    [
      "同期",
      "同期",
      "tóngqī",
      "corresponding time period (e.g. to compare inflation now with the rate during the same month last year)"
    ],
    ["后期", "后期", "hòuqī", "late stage; later period"],
    ["贵重", "貴重", "guìzhòng", "precious; expensive"],
    ["遗传", "遺傳", "yíchuán", "inherit (genetically); hereditary"],
    ["期限", "期限", "qīxiàn", "time limit; deadline; allotted time"],
    ["甘心", "甘心", "gānxīn", "content; willing; resign oneself"],
    ["斯文", "斯文", "sīwen5", "refined; educated; cultured; gentle"],
    ["飞舞", "飛舞", "fēiwǔ", "flutter in the air; dance in the breeze"],
    ["可贵", "可貴", "kěguì", "be treasured; praiseworthy; commendable"],
    ["分期", "分期", "fēn qī", "by stages; staggered; step by step"],
    ["限期", "限期", "xiànqī", "time limit; deadline"],
    ["贵族", "貴族", "guìzú", "lord; nobility; nobleman; noblewoman"],
    [
      "名副其实",
      "名副其實",
      "míng fù qí shí",
      "name matches reality; be worthy of the name"
    ],
    ["期待", "期待", "qīdài", "look forward to; await; expectation"],
    [
      "到期",
      "到期",
      "dàoqī",
      "become due; expire (visa, etc.); mature (investment bond, etc.)"
    ],
    ["近期", "近期", "jìnqī", "in the near future; soon; recent"],
    ["高贵", "高貴", "gāoguì", "grandeur; noble"],
    ["延期", "延期", "yán qī", "delay; extend; postpone"],
    ["名贵", "名貴", "míngguì", "famous and valuable; rare; precious"],
    ["其间", "其間", "qíjiān", "meantime; during this time"],
    [
      "莫名其妙",
      "莫名其妙",
      "mòmíngqímiào",
      "odd; baffling; unaccountable; unfathomable mystery"
    ],
    ["组织", "組織", "zǔzhī", "organize; organization"],
    ["而且", "而且", "érqiě", "moreover; in addition; as well as"],
    ["工业", "工業", "gōngyè", "industry"],
    ["农业", "農業", "nóngyè", "agriculture; farming"],
    ["姐姐", "姐姐", "jiějie", "older sister"],
    ["小姐", "小姐", "xiǎojiě", "young lady; miss"],
    ["祖国", "祖國", "zǔguó", "homeland; motherland; fatherland"],
    ["作业", "作業", "zuòyè", "school assignment; homework; task"],
    ["一共", "一共", "yígòng", "altogether; in total"],
    [
      "专业",
      "專業",
      "zhuānyè",
      "profession; speciality; specialized field of study; major"
    ],
    ["严重", "嚴重", "yánzhòng", "grave; serious; critical"],
    ["提供", "提供", "tígōng", "to supply; provide; furnish"],
    ["企业", "企業", "qǐyè", "company; business; firm"],
    [
      "事业",
      "事業",
      "shìyè",
      "undertaking; project; cause; enterprise; career; publicly funded institution"
    ],
    ["普通", "普通", "pǔtōng", "common; ordinary; average"],
    ["共同", "共同", "gòngtóng", "together; to have in common; jointly"],
    ["商业", "商業", "shāngyè", "business; commerce; trade"],
    ["职业", "職業", "zhíyè", "profession; occupation"],
    ["明显", "明顯", "míngxiǎn", "clear; obvious"],
    ["公共", "公共", "gōnggòng", "public; common (use)"],
    ["失业", "失業", "shī yè", "lose one's job; unemployment"],
    ["显得", "顯得", "xiǎnde", "appear; seem; to look"],
    ["业务", "業務", "yèwù", "business; professional work"],
    ["显然", "顯然", "xiǎnrán", "clear; evidently; obviously"],
    ["严格", "嚴格", "yángé", "strict; stringent"],
    ["显著", "顯著", "xiǎnzhù", "notable; marked; outstanding; remarkable"],
    ["并且", "并且", "bìngqiě", "Furthermore; and; besides; moreover"],
    ["共产党", "共產黨", "gòngchǎndǎng", "the Communist Party"],
    ["营业", "營業", "yíngyè", "do business; to trade"],
    ["业余", "業余", "yèyú", "spare time; after-hours;"],
    ["amateur", "", "", ""],
    ["供给", "供給", "gōngjǐ", "furnish; provide; supply"],
    ["庄严", "莊嚴", "zhuāngyán", "solemn; stately; dignified"],
    ["行业", "行業", "hángyè", "industry; trade; profession"],
    ["小组", "小組", "xiǎozǔ", "team; group; small group"],
    ["共和国", "共和國", "gònghéguó", "republic"],
    ["普通话", "普通話", "pǔtōnghuà", "Mandarin (common language)"],
    ["显示", "顯示", "xiǎnshì", "display; illustrate; to show"],
    ["亚军", "亞軍", "yàjūn", "second place; runner-up"],
    ["港口", "港口", "gǎngkǒu", "port; harbor"],
    ["普及", "普及", "pǔjí", "widespread; popular; disseminate; to spread"],
    ["严厉", "嚴厲", "yánlì", "strict; severe"],
    ["严密", "嚴密", "yánmì", "strict; closely-knit; tight"],
    ["恶心", "惡心", "ěxin5", "feel sick; nausea; nauseating"],
    ["外祖母", "外祖母", "wàizǔmǔ", "maternal grandmother"],
    ["重工业", "重工業", "zhònggōngyè", "heavy industry; manufacturing"],
    ["人民", "人民", "rénmín", "the people"],
    ["部分", "部分", "bùfen5", "part; share; section"],
    ["农民", "農民", "nóngmín", "farmer; peasant"],
    ["帮助", "幫助", "bāngzhù", "help; assist; aid"],
    ["全部", "全部", "quánbù", "whole; entire; complete"],
    ["民族", "民族", "mínzú", "nationality; ethnic group"],
    ["首都", "首都", "shǒudū", "capital (city)"],
    [
      "干部",
      "干部",
      "gànbù",
      "cadre / official / officer / manager; cadre (i.e. manager, staff, officer, etc.)"
    ],
    ["辅导", "輔導", "fǔdǎo", "to coach; to tutor; give advice (in study)"],
    ["结婚", "結婚", "jiéhūn", "get married"],
    ["帮忙", "幫忙", "bāngmáng", "to help (with a favour)"],
    [
      "到底",
      "到底",
      "dàodǐ",
      "indeed; after all; until the end (also used in a question for emphasis)"
    ],
    ["部门", "部門", "bùmén", "department; branch; section"],
    ["报纸", "報紙", "bàozhǐ", "newspaper"],
    ["民主", "民主", "mínzhǔ", "democracy"],
    ["南部", "南部", "nánbù", "southern part"],
    ["底下", "底下", "dǐxia", "below; under; bottom"],
    ["离婚", "離婚", "lí hūn", "to divorce; divorced from (one's spouse)"],
    ["故乡", "故鄉", "gùxiāng", "hometown; homeland; birthplace"],
    ["降低", "降低", "jiàngdī", "reduce; lower; drop"],
    ["家乡", "家鄉", "jiāxiāng", "hometown"],
    ["西部", "西部", "xībù", "west; western part"],
    ["东部", "東部", "dōngbù", "the east; the eastern part"],
    [
      "国民党",
      "國民黨",
      "Guómíndǎng",
      "Kuomintang (KMT); Chinese Nationalist Party"
    ],
    ["乡下", "鄉下", "xiāngxia", "countryside; rural; village"],
    ["昏迷", "昏迷", "hūnmí", "lose consciousness; be in a coma"],
    ["部队", "部隊", "bùduì", "armed forces; troops"],
    ["法郎", "法郎", "fǎláng", "(Currency) franc"],
    ["内部", "內部", "nèibù", "internal; interior; inside (part, section)"],
    ["北部", "北部", "běibù", "northern part; Tonkin (region in Vietnam)"],
    ["居民", "居民", "jūmín", "resident; inhabitant"],
    ["民间", "民間", "mínjiān", "among the people; popular; folk"],
    ["博物馆", "博物館", "bówùguǎn", "museum"],
    ["博士", "博士", "bóshì", "doctor; PhD"],
    ["公民", "公民", "gōngmín", "citizen"],
    [
      "大都",
      "大都",
      "dàdū",
      "almost all; for the most part; mostly (also -dōu); metropolitan; Dadu (capital of China during the Yuan Dynasty,  1280-1368, modern day Beijing"
    ],
    ["底片", "底片", "dǐpiàn", "negative; photographic plate"],
    ["渔民", "漁民", "yúmín", "fisherman; fisher folk"],
    ["老乡", "老鄉", "lǎoxiāng", "fellow townspeople; fellow villager"],
    ["定婚", "定婚", "dìng hūn", "get engaged; be betrothed"],
    ["民用", "民用", "mínyòng", "civil; for civilian use"],
    ["局部", "局部", "júbù", "part; local"],
    ["外部", "外部", "wàibù", "external part; outside; exterior; surface"],
    ["失眠", "失眠", "shīmián", "insomnia; suffer from insomnia"],
    ["民兵", "民兵", "mínbīng", "militia; militia-person"],
    ["乡村", "鄉村", "xiāngcūn", "rural; village; countryside"],
    ["睡眠", "睡眠", "shuìmián", "sleep"],
    ["中部", "中部", "zhōngbù", "center; middle part"],
    ["移民", "移民", "yímín", "migrate; immigrant"],
    [
      "少数民族",
      "少數民族",
      "shǎoshù mínzú",
      "minority nationality; ethnic group"
    ],
    ["市民", "市民", "shìmín", "city resident; townsfolk; urban dweller"],
    ["都市", "都市", "dūshì", "city; metropolis"],
    ["平民", "平民", "píngmín", "the common people; commoner; civilian"],
    ["民事", "民事", "mínshì", "civil matters; agricultural affairs"],
    ["搏斗", "搏斗", "bódòu", "fight; struggle; wrestle"],
    ["新郎", "新郎", "xīnláng", "bridegroom; groom"],
    ["低级", "低級", "dījí", "low level"],
    ["图纸", "圖紙", "túzhǐ", "blueprint; drawing; design plans"],
    ["全都", "全都", "quándōu", "all; without exception"],
    ["拼搏", "拼搏", "pīnbó", "struggle; wrestle"],
    [
      "支部",
      "支部",
      "zhībù",
      "branch, esp. grass root branches of a political party"
    ],
    ["选民", "選民", "xuǎnmín", "voter; electorate; constituency"],
    ["贫民", "貧民", "pínmín", "poor people"],
    ["民意", "民意", "mínyì", "the will of the people; public opinion"],
    ["减低", "減低", "jiǎndī", "lower; reduce"],
    ["民众", "民眾", "mínzhòng", "populace; masses; the people"],
    ["国民", "國民", "guómín", "national; citizen"],
    [
      "高低",
      "高低",
      "gāodī",
      "height; high or low; ups and downs; no matter what"
    ],
    ["低温", "低溫", "dīwēn", "low temperature; relatively low temperature"],
    [
      "低下",
      "低下",
      "dīxià",
      "(of status or living standards) low; lowly; to lower (one's head)"
    ],
    ["祖母", "祖母", "zǔmǔ", "paternal grandmother (formal)"],
    ["助手", "助手", "zhùshǒu", "assistant; helper"],
    ["组成", "組成", "zǔchéng", "compose; constitute; make up"],
    ["凶恶", "凶惡", "xiōng'è", "fierce; ferocious; menacing"],
    ["恶化", "惡化", "èhuà", "worsen; deteriorate"],
    ["罪恶", "罪惡", "zuì'è", "sin; vice"],
    ["科普", "科普", "kēpǔ", "popular science; popularization of science"],
    ["协助", "協助", "xiézhù", "assist; to help"],
    ["祖父", "祖父", "zǔfù", "paternal grandfather (formal)"],
    ["严禁", "嚴禁", "yánjìn", "strictly prohibit; forbid"],
    ["互助", "互助", "hùzhù", "help each other"],
    ["祖先", "祖先", "zǔxiān", "ancestors; forefathers"],
    ["共青团", "共青團", "gòngqīngtuán", "Communist Youth League"],
    ["外祖父", "外祖父", "wàizǔfù", "maternal grandfather"],
    ["总共", "總共", "zǒnggòng", "altogether; in sum; in all; in total"],
    ["况且", "況且", "kuàngqiě", "moreover; besides; in addition"],
    [
      "厌恶",
      "厭惡",
      "yànwù",
      "to detest; to loathe; to hate; to be disgusted with"
    ],
    ["就业", "就業", "jiùyè", "employment; obtain a job"],
    ["助理", "助理", "zhùlǐ", "assistant"],
    [
      "组合",
      "組合",
      "zǔhé",
      "to assemble; to make up; combination; combinatorial"
    ],
    ["尊严", "尊嚴", "zūnyán", "dignity; sanctity; honor"],
    [
      "各行各业",
      "各行各業",
      "gè háng gè yè",
      "all trades and professions; all walks of life"
    ],
    ["可恶", "可惡", "kěwù", "hateful; abominable; repulsive"],
    ["结业", "結業", "jiéyè", "finish a course of study; conclude"],
    [
      "副业",
      "副業",
      "fùyè",
      "sideline; side occupation (opp. 主业); part-time business; hobby"
    ],
    ["显微镜", "顯微鏡", "xiǎnwēijìng", "microscope"],
    [
      "创业",
      "創業",
      "chuàngyè",
      "begin an undertaking; start a major task; start a company"
    ],
    ["共计", "共計", "gòngjì", "sum up; total"],
    [
      "吉普车",
      "吉普車",
      "jípǔchē",
      "jeep; military vehicle originally made in USA"
    ],
    ["恶毒", "惡毒", "èdú", "malicious; venomous"],
    ["海港", "海港", "hǎigǎng", "seaport; ocean port; harbor"],
    ["普查", "普查", "pǔchá", "census; general survey; general investigation"],
    ["严寒", "嚴寒", "yánhán", "bitter cold; severe winter"],
    [
      "专业户",
      "專業戶",
      "zhuānyèhù",
      "family firm that produces a special product; cottage industry"
    ],
    ["资助", "資助", "zīzhù", "subsidy; provide financial aid"],
    ["共性", "共性", "gòngxìng", "overall character"],
    ["改组", "改組", "gǎizǔ", "reorganize; reshuffle"],
    ["林业", "林業", "línyè", "forestry; forest industry"],
    ["轻工业", "輕工業", "qīnggōngyè", "light industry; light manufacturing"],
    ["补助", "補助", "bǔzhù", "subsidy; allowance"],
    ["渔业", "漁業", "yúyè", "fishing industry; fishery"],
    [
      "借助",
      "借助",
      "jièzhù",
      "borrow from; have the aid of; draw support from"
    ],
    [
      "和平共处",
      "和平共處",
      "hépíng gòng chǔ",
      "peaceful coexistence of nations; societies etc."
    ],
    ["共产主义", "共產主義", "gòngchǎn zhǔyì", "communism"],
    ["旅游业", "旅游業", "lv3yóu yè", "tourist industry; tourism"],
    [
      "显而易见",
      "顯而易見",
      "xiǎn ér yì jiàn",
      "clear and easy to see; obviously"
    ],
    ["产业", "產業", "chǎnyè", "industry; estate; property"],
    [
      "暂且",
      "暫且",
      "zànqiě",
      "for the moment; for the time being; temporarily"
    ],
    [
      "待业",
      "待業",
      "dài yè",
      "await job assignment (term used only in mainland China); unemployed"
    ],
    ["恶性", "惡性", "èxìng", "malignant; wicked; vicious"],
    ["辅助", "輔助", "fǔzhù", "assist; aide; auxiliary"],
    [
      "乡亲",
      "鄉親",
      "xiāngqīn",
      "fellow countrymen (from the same village); local people"
    ],
    ["难民", "難民", "nànmín", "refugee"],
    ["下乡", "下鄉", "xià xiāng", "go to the countryside"],
    ["门市部", "門市部", "ménshìbù", "saleroom; section in a retail store"],
    ["脉搏", "脈搏", "màibó", "pulse; throbbing"],
    [
      "全民",
      "全民",
      "quánmín",
      "the entire population (of a country); all the people"
    ],
    ["部件", "部件", "bùjiàn", "parts (of a character); components"],
    ["部位", "部位", "bùwèi", "position; place; part (of a whole)"],
    ["一般", "一般", "yìbān", "general; ordinary; common; same"],
    ["图书馆", "圖書館", "túshūguǎn", "library"],
    ["词典", "詞典", "cídiǎn", "dictionary"],
    ["生词", "生詞", "shēngcí", "new vocabulary word"],
    ["公司", "公司", "gōngsī", "company; corporation"],
    ["读书", "讀書", "dú shū", "to study; read; attend school"],
    ["手段", "手段", "shǒuduàn", "method; means (of doing sth.)"],
    ["阶段", "階段", "jiēduàn", "stage; phase"],
    ["司机", "司機", "sījī", "driver; chauffeur"],
    ["书店", "書店", "shūdiàn", "bookstore"],
    ["西瓜", "西瓜", "xīguā", "watermelon"],
    ["书架", "書架", "shūjià", "bookshelf"],
    ["书包", "書包", "shūbāo", "schoolbag; satchel"],
    ["盘子", "盤子", "pánzi", "plate; dish; tray"],
    [
      "书记",
      "書記",
      "shūji",
      "chief official of a branch of a socialist or communist party; secretary; clerk"
    ],
    ["单词", "單詞", "dāncí", "(individual) word"],
    ["轮船", "輪船", "lúnchuán", "steamship"],
    ["念书", "念書", "niànshū", "read; to study"],
    ["证书", "證書", "zhèngshū", "certificate; credentials"],
    ["幻想", "幻想", "huànxiǎng", "delusion; fantasy; illusion"],
    ["司令", "司令", "sīlìng", "commanding officer"],
    ["书本", "書本", "shūběn", "book"],
    ["瓜子", "瓜子", "guāzǐ", "melon seed"],
    ["孤立", "孤立", "gūlì", "isolate; isolated"],
    ["幻灯", "幻燈", "huàndēng", "slide; slide show; projector"],
    ["书法", "書法", "shūfǎ", "calligraphy; penmanship"],
    ["司法", "司法", "sīfǎ", "judicial; (administration of) justice"],
    ["书写", "書寫", "shūxiě", "write; writing"],
    ["飞船", "飛船", "fēichuán", "airship; spaceship"],
    ["孤独", "孤獨", "gūdú", "lonely; solitary"],
    ["孤单", "孤單", "gūdān", "lonely; loneliness"],
    ["词句", "詞句", "cíjù", "words and sentences; wording"],
    ["工具书", "工具書", "gōngjùshū", "reference book (such as dictionary)"],
    ["总司令", "總司令", "zǒngsīlìng", "commander-in-chief; general"],
    [
      "冬瓜",
      "冬瓜",
      "dōngguā",
      'wax gourd; "winter melon"; white fuzzy vegetable'
    ],
    ["渡船", "渡船", "dùchuán", "ferry"],
    ["司令部", "司令部", "sīlìngbù", "headquarters; command center"],
    ["算盘", "算盤", "suànpán", "abacus"],
    ["议定书", "議定書", "yìdìngshū", "protocol; treaty"],
    ["船只", "船只", "chuánzhī", "ships; boats; vessels; shipping"],
    ["瓜分", "瓜分", "guāfēn", "to partition; divide up"],
    ["假期", "假期", "jiàqī", "vacation; holiday; period of leave"],
    ["面对", "面對", "miànduì", "to face; confront"],
    ["声明", "聲明", "shēngmíng", "statement; declare; proclaim"],
    ["日益", "日益", "rìyì", "day by day; more and more; increasingly"],
    ["局面", "局面", "júmiàn", "aspect; situation"],
    ["运气", "運气", "yùnqi", "luck; fortune"],
    ["继承", "繼承", "jìchéng", "inherit; carry on; succeed"],
    ["假如", "假如", "jiǎrú", "if; supposing; in case"],
    ["露面", "露面", "lòu miàn", "show one's face; appear (in public)"],
    ["风气", "風气", "fēngqì", "general mood; atmosphere; common practice"],
    ["当面", "當面", "dāngmiàn", "to sb.'s face; in sb.'s presence"],
    ["四面八方", "四面八方", "sìmiànbāfāng", "all directions; all around"],
    ["体面", "體面", "tǐmiàn", "dignity; honorable; face; good-looking"],
    [
      "相声",
      "相聲",
      "xiàngsheng5",
      "sketch; crosstalk; comic dialogue; traditional Chinese comical dialogue"
    ],
    ["一口气", "一口气", "yìkǒuqì", "in one breath; in one go"],
    ["天然气", "天然气", "tiānránqì", "natural gas"],
    ["汽船", "汽船", "qìchuán", "steamship; steamboat"],
    ["蒸发", "蒸發", "zhēngfā", "evaporate; evaporation"],
    ["有益", "有益", "yǒuyì", "beneficial; useful; profitable"],
    ["承担", "承擔", "chéngdān", "undertake; assume (responsibility)"],
    ["承包", "承包", "chéngbāo", "to contract for; undertake a job"],
    ["革新", "革新", "géxīn", "innovation; improve"],
    ["蒸汽", "蒸汽", "zhēngqì", "steam"],
    ["气概", "气概", "qìgài", "lofty quality; mettle; spirit"],
    ["气体", "气體", "qìtǐ", "gas (i.e. gaseous substance)"],
    ["气压", "气壓", "qìyā", "atmospheric pressure; barometric pressure"],
    ["面孔", "面孔", "miànkǒng", "face; look; facial expression"],
    ["假若", "假若", "jiǎruò", "if; supposing; in case"],
    ["场面", "場面", "chǎngmiàn", "scene; occasion; spectacle"],
    [
      "正面",
      "正面",
      "zhèngmiàn",
      "front; obverse side; right side; positive; direct; open"
    ],
    ["气味", "气味", "qìwèi", "odor; scent"],
    ["口气", "口气", "kǒuqì", "tone of voice; manner of speaking"],
    [
      "神气",
      "神气",
      "shénqì",
      "expression; manner; spirited; putting on airs; cocky"
    ],
    ["海面", "海面", "hǎimiàn", "sea level; ocean surface"],
    ["面粉", "面粉", "miànfěn", "flour"],
    ["假使", "假使", "jiǎshǐ", "if; supposing; in case"],
    ["气功", "气功", "qìgōng", "Qi Gong, a system of deep breathing exercises"],
    ["书面", "書面", "shūmiàn", "in writing; written (guarantee, etc.)"],
    ["承受", "承受", "chéngshòu", "to bear; to support; absorb; sustain"],
    ["废气", "廢气", "fèiqì", "waste (exhaust) gas; steam"],
    ["福气", "福气", "fúqì", "good fortune; happy lot"],
    ["假装", "假裝", "jiǎzhuāng", "pretend to be; feign; make believe"],
    ["面子", "面子", "miànzi", 'honor; reputation; prestige; "face"'],
    ["面包车", "面包車", "miànbāochē", "van for carrying people; microbus"],
    ["收益", "收益", "shōuyì", "earnings; profit"],
    [
      "半真半假",
      "半真半假",
      "bàn zhēn bàn jiǎ",
      "(adj) half true and half false"
    ],
    ["假冒", "假冒", "jiǎmào", "impersonate; fake; counterfeit"],
    ["朝气", "朝气", "zhāoqì", "vitality; youthful spirit; dynamism"],
    ["和气", "和气", "héqi", "friendly; polite; amiable"],
    ["气息", "气息", "qìxī", "breath; smell"],
    ["局长", "局長", "júzhǎng", "director of a bureau"],
    ["生长", "生長", "shēngzhǎng", "grow; grow up"],
    ["传播", "傳播", "chuánbō", "propagate; transmit; to spread"],
    [
      "院长",
      "院長",
      "yuànzhǎng",
      "president (of a university, etc.); department head; dean"
    ],
    [
      "校长",
      "校長",
      "xiàozhǎng",
      "(academic) president; school principal; headmaster"
    ],
    ["毛巾", "毛巾", "máojīn", "towel; washcloth"],
    ["尾巴", "尾巴", "wěiba", "tail"],
    ["开展", "開展", "kāizhǎn", "begin to develop; to launch"],
    ["科长", "科長", "kēzhǎng", "section chief; branch director"],
    ["粉笔", "粉筆", "fěnbǐ", "chalk"],
    ["延长", "延長", "yáncháng", "extend; prolong; lengthen"],
    ["班长", "班長", "bānzhǎng", "class monitor; team leader"],
    ["笔记", "筆記", "bǐjì", "take down in writing; notes"],
    ["市长", "市長", "shìzhǎng", "mayor"],
    [
      "委托",
      "委托",
      "wěituō",
      "to entrust; to trust; to ensign; to commission"
    ],
    ["摩托车", "摩托車", "mótuōchē", "motorcycle; motorbike"],
    ["转播", "轉播", "zhuǎnbō", "relay; broadcast (on radio or TV)"],
    ["组长", "組長", "zǔzhǎng", "group leader; director; team captain"],
    ["毛笔", "毛筆", "máobǐ", "writing brush"],
    ["张望", "張望", "zhāngwàng", "to peep (through a crack); look around"],
    ["厂长", "厂長", "chǎngzhǎng", "director of a factory"],
    ["翻身", "翻身", "fān shēn", "turn over; free oneself"],
    [
      "推翻",
      "推翻",
      "tuīfān",
      "to overthrow; to overturn; topple; repudiate; cancel; to reverse"
    ],
    [
      "万古长青",
      "萬古長青",
      "wàn gǔ cháng qīng",
      "remain fresh; last forever; eternal"
    ],
    ["毛线", "毛線", "máoxiàn", "yarn"],
    ["丧失", "喪失", "sàngshī", "to lose; to forfeit"],
    ["长远", "長遠", "chángyuǎn", "long-term; long-range"],
    ["长久", "長久", "chángjiǔ", "long-lasting; for a long time; permanently"],
    ["省长", "省長", "shěngzhǎng", "governor of a province"],
    ["托儿所", "托兒所", "tuō'érsuǒ", "nursery; child care center"],
    ["笔试", "筆試", "bǐshì", "written exam"],
    ["漫长", "漫長", "màncháng", "lengthy; very long; endless"],
    ["团长", "團長", "tuánzhǎng", "regimental commander; head of delegation"],
    ["住宅", "住宅", "zhùzhái", "residence; dwelling; tenement"],
    ["长度", "長度", "chángdù", "length"],
    [
      "家长",
      "家長",
      "jiāzhǎng",
      "parent or guardian of a child; head of a family"
    ],
    ["涨价", "漲價", "zhǎng jià", "appreciate (in value); increase in price"],
    ["长短", "長短", "chángduǎn", "length; duration; accident"],
    ["长处", "長處", "chángchù", "strongpoint; good aspects"],
    [
      "师长",
      "師長",
      "shīzhǎng",
      "military division level commander; teachers and elders"
    ],
    ["伸展", "伸展", "shēnzhǎn", "extension"],
    [
      "一技之长",
      "一技之長",
      "yíjìzhīcháng",
      "proficiency in a particular field; professional skill; speciality"
    ],
    ["纸张", "紙張", "zhǐzhāng", "paper"],
    ["播种", "播種", "bōzhòng", "sow seeds; sowing; seed"],
    [
      "没吃没穿",
      "沒吃沒穿",
      "méi chī méi chuān",
      "(idiom) be without food and clothing; be very poor"
    ],
    ["释放", "釋放", "shìfàng", "release; set free; discharge"],
    [
      "笔直",
      "筆直",
      "bǐzhí",
      "perfectly straight; straight as a ramrod; bolt upright"
    ],
    ["排长", "排長", "páizhǎng", "platoon leader"],
    [
      "直播",
      "直播",
      "zhíbō",
      "to go live, live broadcast (not recorded); (agriculture) direct seeding"
    ],
    ["助长", "助長", "zhùzhǎng", "encourage; foster; foment"],
    [
      "书信",
      "書信",
      "shūxìn",
      "letter; written message; an epistle (in the Bible)"
    ],
    ["搬运", "搬運", "bānyùn", "carry; transport; convey; portage"],
    ["贺词", "賀詞", "hècí", "message of congratulation"],
    ["方面", "方面", "fāngmiàn", "aspect; field; side; respect"],
    ["汽车", "汽車", "qìchē", "car; automobile; bus; vehicle"],
    ["天气", "天气", "tiānqì", "weather"],
    ["声音", "聲音", "shēngyīn", "sound; voice"],
    ["放假", "放假", "fàng jià", "have a holiday or vacation"],
    ["客气", "客气", "kèqi", "polite; courteous; formal; modest"],
    ["见面", "見面", "jiànmiàn", "meet/see somebody (face to face); meeting"],
    ["空气", "空气", "kōngqì", "air"],
    ["寒假", "寒假", "hánjià", "winter vacation"],
    ["公共汽车", "公共汽車", "gōnggòng qìchē", "(public) bus"],
    ["面包", "面包", "miànbāo", "bread"],
    ["请假", "請假", "qǐng jià", "ask for time off"],
    ["声调", "聲調", "shēngdiào", "tone; note"],
    ["汽水", "汽水", "qìshuǐ", "soda; pop; soft drinks"],
    ["面条儿", "面條兒", "miàntiáor5", "noodles"],
    ["大声", "大聲", "dà shēng", "loud"],
    ["改革", "改革", "gǎigé", "reform"],
    ["气候", "气候", "qìhòu", "climate; atmosphere; weather"],
    ["面积", "面積", "miànjī", "(surface) area"],
    ["生气", "生气", "shēngqì", "angry; mad"],
    ["全面", "全面", "quánmiàn", "all-around; comprehensive; fully"],
    ["气温", "气溫", "qìwēn", "air temperature"],
    ["面前", "面前", "miànqián", "in front of; facing"],
    ["对面", "對面", "duìmiàn", "opposite; across from; the other side"],
    ["承认", "承認", "chéngrèn", "admit; concede; acknowledge"],
    ["外面", "外面", "wàimian5", "outside"],
    ["利益", "利益", "lìyì", "benefit; (in sb.'s) interest"],
    ["前面", "前面", "qiánmian5", "in front; fore; ahead; preceding"],
    ["里面", "里面", "lǐmiàn", "inside; interior"],
    ["表面", "表面", "biǎomiàn", "surface; outside; face"],
    [
      "革命",
      "革命",
      "gémìng",
      "revolution; revolutionary (politics); cause great social change; rise in revolt; take part in revolution"
    ],
    ["上面", "上面", "shàngmian5", "top; on top of; above-mentioned"],
    ["一方面", "一方面", "yìfāngmiàn", "on the one hand; one side"],
    ["力气", "力气", "lìqi", "physical strength; effort"],
    ["后面", "后面", "hòumian5", "rear; back; behind"],
    ["下面", "下面", "xiàmian5", "below; following; next; under"],
    ["片面", "片面", "piànmiàn", "one-sided; unilateral"],
    ["勇气", "勇气", "yǒngqì", "courage; valor"],
    ["语气", "語气", "yǔqì", "tone; manner of speaking; mood"],
    ["南面", "南面", "nánmiàn", "south side; south"],
    ["汽油", "汽油", "qìyóu", "gasoline; gas; petrol"],
    ["西面", "西面", "xīmiàn", "west side; west"],
    ["假条", "假條", "jiàtiáo", "application for leave; leave permit"],
    ["东面", "東面", "dōngmiàn", "East side"],
    ["地面", "地面", "dìmiàn", "floor; ground; surface"],
    ["北面", "北面", "běimiàn", "northern side; north"],
    ["面临", "面臨", "miànlín", "be faced with; be up against"],
    ["播音", "播音", "bō yīn", "transmit; broadcast"],
    ["注释", "注釋", "zhùshì", "annotate; note; make notes in the margin"],
    [
      "展望",
      "展望",
      "zhǎnwàng",
      "outlook; prospect; to look ahead; look forward to"
    ],
    ["首长", "首長", "shǒuzhǎng", "senior official; director; principal"],
    ["高涨", "高漲", "gāozhǎng", "upsurge; (tensions, etc.) run high"],
    ["寄托", "寄托", "jìtuō", "entrust to the care of; place one's hope on"],
    [
      "天长地久",
      "天長地久",
      "tiān cháng dì jiǔ",
      "enduring as the universe; everlasting and unchanging"
    ],
    [
      "三番五次",
      "三番五次",
      "sān fān wǔ cì",
      "do over and over again (idiom)"
    ],
    ["展示", "展示", "zhǎnshì", "open up; reveal; to display"],
    [
      "上涨",
      "上漲",
      "shàngzhǎng",
      "to rise; go up (of water level, prices, etc.)"
    ],
    ["羽毛", "羽毛", "yǔmáo", "feather; plumage; plume"],
    ["专长", "專長", "zhuāncháng", "specialty; special knowledge or ability"],
    ["展现", "展現", "zhǎnxiàn", "emerge; develop; unfold before one's eyes"],
    ["亲笔", "親筆", "qīnbǐ", "personal handwriting; in one's own handwriting"],
    ["进展", "進展", "jìnzhǎn", "make progress; development; make headway"],
    ["施展", "施展", "shīzhǎn", "to use fully; to put to good use"],
    ["播放", "播放", "bōfàng", "broadcast; transmit"],
    ["高兴", "高興", "gāoxìng", "happy; glad; willing (to do something)"],
    ["晚上", "晚上", "wǎnshang5", "evening; night"],
    ["应该", "應該", "yīnggāi", "should; ought to; must"],
    ["检查", "檢查", "jiǎnchá", "to check; examine; inspect"],
    ["危险", "危險", "wēixiǎn", "danger; dangerous; perilous"],
    ["遇到", "遇到", "yùdào", "meet; run into; come across"],
    ["晚会", "晚會", "wǎnhuì", "evening party; social evening"],
    ["晚饭", "晚飯", "wǎnfàn", "dinner; supper"],
    ["好像", "好像", "hǎoxiàng", "seem like"],
    ["鸡蛋", "雞蛋", "jīdàn", "chicken egg"],
    ["举行", "舉行", "jǔxíng", "convene; to hold (a meeting, ceremony, etc.)"],
    ["兴趣", "興趣", "xìngqù", "interest (in something or somebody)"],
    ["印象", "印象", "yìnxiàng", "impression"],
    ["适应", "適應", "shìyìng", "to suit; to fit; adapt; get used to"],
    ["现象", "現象", "xiànxiàng", "appearance; phenomenon"],
    [
      "对象",
      "對象",
      "duìxiàng",
      "target; object; partner; boyfriend or girlfriend"
    ],
    ["答应", "答應", "dāying5", "to respond; to promise; to answer; agree"],
    ["缺乏", "缺乏", "quēfá", "shortage; lack"],
    ["选举", "選舉", "xuǎnjǔ", "to elect; election"],
    ["避免", "避免", "bìmiǎn", "avoid; avert; prevent"],
    ["想象", "想象", "xiǎngxiàng", "imagine; visualize; imagination"],
    ["气象", "气象", "qìxiàng", "meteorology; atmosphere; phenomenon"],
    ["缺点", "缺點", "quēdiǎn", "weak point; defect; fault; shortcoming"],
    [
      "反应",
      "反應",
      "fǎnyìng",
      "to react; to respond; reaction; response; repercussion"
    ],
    ["应当", "應當", "yīngdāng", "should; ought to; must"],
    ["形象", "形象", "xíngxiàng", "image; imagery; vivid; visualization"],
    ["缺少", "缺少", "quēshǎo", "to lack; be short of; be deficient in"],
    ["感兴趣", "感興趣", "gǎn xìngqù", "interested in"],
    ["兔子", "兔子", "tùzi", "rabbit; hare"],
    ["录像", "錄像", "lùxiàng", "to videotape; video recording"],
    ["应用", "應用", "yìngyòng", "to apply; to use; application"],
    ["夜晚", "夜晚", "yèwǎn", "night"],
    ["抽象", "抽象", "chōuxiàng", "abstract; abstraction"],
    ["遇见", "遇見", "yù jiàn", "meet; run into"],
    ["响应", "響應", "xiǎngyìng", "respond to; answer"],
    ["保险", "保險", "bǎoxiǎn", "insurance; insure; safe"],
    [
      "举办",
      "舉辦",
      "jǔbàn",
      "to conduct; to hold (an event); to sponsor; to stage; organize"
    ],
    ["待遇", "待遇", "dàiyù", "benefits; treatment; pay; wage; salary"],
    ["脸色", "臉色", "liǎnsè", "complexion; look; facial expression"],
    ["晚报", "晚報", "wǎnbào", "evening paper"],
    [
      "不象话",
      "不象話",
      "búxiànghuà",
      "ridiculous; outrageous (variant of ~像~)"
    ],
    ["早晚", "早晚", "zǎowǎn", "sooner or later; morning and evening"],
    [
      "应付",
      "應付",
      "yìngfu",
      "to cope with; to deal with; to handle; to do sth. after a fashion; to make do"
    ],
    ["动摇", "動搖", "dòngyáo", "shake; vacillate; waver"],
    ["检讨", "檢討", "jiǎntǎo", "self-criticism; review"],
    ["不免", "不免", "bùmiǎn", "unavoidable"],
    ["鸭子", "鴨子", "yāzi", "duck"],
    ["兴高采烈", "興高采烈", "xìng gāo cǎi liè", "in high spirits; cheerful"],
    ["半岛", "半島", "bàndǎo", "peninsula"],
    ["供应", "供應", "gōngyìng", "to supply; provide; offer"],
    ["景象", "景象", "jǐngxiàng", "scene; sight (to behold)"],
    ["群岛", "群島", "qúndǎo", "archipelago; group of islands"],
    ["免得", "免得", "miǎnde", "so as not to; so as to avoid"],
    ["遥远", "遙遠", "yáoyuǎn", "distant; remote"],
    ["免费", "免費", "miǎnfèi", "free (of charge); no cost"],
    [
      "相应",
      "相應",
      "xiāngyìng",
      "corresponding; relevant; fitting; appropriate"
    ],
    ["兴起", "興起", "xīngqǐ", "to rise; spring up; come into vogue; burgeon"],
    ["难免", "難免", "nánmiǎn", "hard to avoid; difficult to escape from"],
    ["冒险", "冒險", "màoxiǎn", "adventure; take a risk; take chances"],
    ["晚年", "晚年", "wǎnnián", "one's later years; old age"],
    [
      "未免",
      "未免",
      "wèimiǎn",
      "(of something that one finds has gone too far); rather; a bit too ..."
    ],
    ["新兴", "新興", "xīnxīng", "rising; up and coming; newly developing"],
    [
      "机遇",
      "機遇",
      "jīyù",
      "opportunity; stroke of good luck; favorable circumstance"
    ],
    ["免除", "免除", "miǎnchú", "prevent; avoid; remit"],
    [
      "检举",
      "檢舉",
      "jiǎnjǔ",
      "inform against; reveal to higher authorities; impeach"
    ],
    ["对应", "對應", "duìyìng", "corresponding; counterpart"],
    [
      "检修",
      "檢修",
      "jiǎnxiū",
      "examine and fix a mechanical device; to overhaul"
    ],
    ["举世闻名", "舉世聞名", "jǔshì wénmíng", "(saying) world famous"],
    ["肖像", "肖像", "xiàoxiàng", "portrait"],
    ["检测", "檢測", "jiǎncè", "inspect; examine; investigation"],
    ["缺口", "缺口", "quēkǒu", "gap; breach; shortfall"],
    ["列举", "列舉", "lièjǔ", "make a list; enumerate"],
    ["复兴", "復興", "fùxīng", "revive; rejuvenate; restore"],
    ["风险", "風險", "fēngxiǎn", "risk; hazard"],
    ["兴办", "興辦", "xīngbàn", "begin; set in motion"],
    ["图象", "圖象", "túxiàng", "image; picture"],
    ["大雁", "大雁", "dàyàn", "wild goose"],
    [
      "供不应求",
      "供不應求",
      "gōngbúyìngqiú",
      "(saying) demand outstrips supply"
    ],
    ["照应", "照應", "zhàoying5", "look after; take care of; to coordinate"],
    ["兴建", "興建", "xīngjiàn", "to build; to construct"],
    ["举动", "舉動", "jǔdòng", "action; movement; behavior; conduct"],
    ["晚餐", "晚餐", "wǎncān", "evening meal; dinner"],
    ["遥控", "遙控", "yáokòng", "remote control"],
    ["大气压", "大气壓", "dàqìyā", "atmospheric pressure"],
    ["承办", "承辦", "chéngbàn", "undertake; accept an assignment"],
    [
      "迎面",
      "迎面",
      "yíng miàn",
      "face to face; headlong; head-on; in one's face"
    ],
    ["效益", "效益", "xiàoyì", "benefit; effectiveness"],
    ["名声", "名聲", "míngshēng", "reputation of a person or thing"],
    ["路面", "路面", "lùmiàn", "pavement"],
    ["爱面子", "愛面子", "ài miànzi", "be sensitive about one's reputation"],
    ["假定", "假定", "jiǎdìng", "assume; suppose"],
    [
      "精益求精",
      "精益求精",
      "jīng yì qiú jīng",
      "keep improving; striving for perfection"
    ],
    ["水蒸气", "水蒸气", "shuǐzhēngqì", "water vapor; steam"],
    ["反革命", "反革命", "fǎngémìng", "counter-revolutionary"],
    ["娇气", "嬌气", "jiāoqì", "delicate; effeminate; squeamish; finicky"],
    ["出面", "出面", "chū miàn", "To appear in person"],
    ["气势", "气勢", "qìshì", "imposing manner; look of great force"],
    ["气力", "气力", "qìlì", "strength; energy; vigor; talent"],
    ["面容", "面容", "miànróng", "appearance; facial structure or features"],
    [
      "正气",
      "正气",
      "zhèngqì",
      "healthy environment; healthy atmosphere; righteousness"
    ],
    ["背面", "背面", "bèimiàn", "the back; the reverse side; the wrong side"],
    ["汽球", "汽球", "qìqiú", "balloon"],
    ["皮革", "皮革", "pígé", "leather"],
    [
      "有声有色",
      "有聲有色",
      "yǒu shēng yǒu sè",
      "(saying) have sound and color; vivid; dazzling"
    ],
    ["服气", "服气", "fúqì", "be convinced; accept things as fair"],
    ["气流", "气流", "qìliú", "airstream; airflow; breath"],
    ["志气", "志气", "zhìqì", "ambition; resolve; backbone; drive; spirit"],
    [
      "反面",
      "反面",
      "fǎnmiàn",
      "the reverse side of sth.; opposite side of a topic"
    ],
    [
      "呼声",
      "呼聲",
      "hūshēng",
      "a cry; a voice; a shout; fig. opinion/demand (esp. expressed by a group)"
    ],
    [
      "画面",
      "畫面",
      "huàmiàn",
      "general appearance of a picture; (picture) frame; TV/monitor screen"
    ],
    [
      "争气",
      "爭气",
      "zhēng qì",
      "work hard for sth.; determined not to fall short"
    ],
    ["平面", "平面", "píngmiàn", "a plane (i.e. flat surface); type; category"],
    ["假设", "假設", "jiǎshè", "suppose that; hypothesis; conjecture"],
    ["响声", "響聲", "xiǎngshēng", "noise; sound"],
    ["声势", "聲勢", "shēngshì", "momentum; fame and power; prestige"],
    ["面目", "面目", "miànmù", "appearance; facial features; look"],
    [
      "理直气壮",
      "理直气壯",
      "lǐzhíqìzhuàng",
      "with justice on one's side, one is bold and assured; have the courage of one's convictions; just and forceful"
    ],
    ["发展", "發展", "fāzhǎn", "develop; development; growth"],
    ["紧张", "緊張", "jǐnzhāng", "nervous; strained; stressed out"],
    ["广播", "广播", "guǎngbō", "broadcast; on the air"],
    ["增长", "增長", "zēngzhǎng", "grow; to increase; enrich"],
    ["长途", "長途", "chángtú", "long-distance"],
    ["解释", "解釋", "jiěshì", "explain; interpret; expound"],
    ["部长", "部長", "bùzhǎng", "minister; head of a department"],
    ["毛病", "毛病", "máobìng", "(of a machine) trouble; mishap; breakdown;"],
    ["defect; fault; mistake;", "", "", ""],
    ["bad habit; shortcoming;", "", "", ""],
    ["(dialect) illness", "", "", ""],
    ["长期", "長期", "chángqī", "long term; long time"],
    ["展开", "展開", "zhǎn kāi", "spread out; unfold; expand; develop"],
    ["毛衣", "毛衣", "máoyī", "woolen sweater"],
    ["主张", "主張", "zhǔzhāng", "to advocate; viewpoint; position"],
    ["羽毛球", "羽毛球", "yǔmáoqiú", "badminton"],
    ["队长", "隊長", "duìzhǎng", "captain; team leader"],
    ["成长", "成長", "chéngzhǎng", "to mature; grow up; growth"],
    ["展出", "展出", "zhǎnchū", "to put on display; be on show; to exhibit"],
    ["一举", "一舉", "yìjǔ", "in one fell swoop; an action; with one move"],
    ["象样", "象樣", "xiàng yàng", "presentable (variant of 像~)"],
    ["缺席", "缺席", "quē xí", "absence; absent; default"],
    ["以免", "以免", "yǐmiǎn", "so as not to; in order to avoid; lest"],
    ["可能", "可能", "kěnéng", "possible; maybe"],
    ["妈妈", "媽媽", "māma", "Mom; mother"],
    ["经验", "經驗", "jīngyàn", "experience"],
    ["能够", "能夠", "nénggòu", "capable of; able to"],
    ["马上", "馬上", "mǎshàng", "at once; immediately; right away"],
    ["能力", "能力", "nénglì", "capability; capable; ability"],
    ["考虑", "考慮", "kǎolv4", "think over; consider"],
    ["实验", "實驗", "shíyàn", "experiment; test"],
    [
      "干吗",
      "干嗎",
      "gànmá",
      "what's going on?; what are you doing?; whatever for?"
    ],
    ["能干", "能干", "nénggàn", "capable; competent"],
    ["马路", "馬路", "mǎlù", "street; road"],
    ["能源", "能源", "néngyuán", "energy resources; power source"],
    ["老虎", "老虎", "lǎohǔ", "tiger"],
    ["马虎", "馬虎", "mǎhu", "careless; sloppy; casual; negligent"],
    ["大妈", "大媽", "dàmā", "aunt; wife of father's elder brother"],
    ["试验", "試驗", "shìyàn", "experiment; test"],
    ["不是吗", "不是嗎", "bú shì ma", "isn't it?; isn't that so?"],
    [
      "马克",
      "馬克",
      "mǎkè",
      "Mark (name); mark (German or Finnish monetary unit)"
    ],
    ["虚心", "虛心", "xūxīn", "modest; open-minded"],
    [
      "力所能及",
      "力所能及",
      "lìsuǒnéngjí",
      "within one's power; to the best of one's ability"
    ],
    ["测验", "測驗", "cèyàn", "test; exam; to test"],
    [
      "老大妈",
      "老大媽",
      "lǎodàmā",
      "aunt (respectful address for elderly woman)"
    ],
    ["才能", "才能", "cáinéng", "talent; ability"],
    ["考验", "考驗", "kǎoyàn", "put to the test; trial"],
    ["化验", "化驗", "huàyàn", "laboratory test; chemical examination"],
    [
      "性能",
      "性能",
      "xìngnéng",
      "performance (e.g. of a machine); natural capacity; how well sth. functions"
    ],
    ["技能", "技能", "jìnéng", "skill; technical ability"],
    ["检验", "檢驗", "jiǎnyàn", "inspect; examine; to test"],
    ["马克思主义", "馬克思主義", "Mǎkèsīzhǔyì", "Marxism"],
    ["能量", "能量", "néngliàng", "energy (physics); capabilities"],
    ["功能", "功能", "gōngnéng", "function; feature"],
    [
      "能歌善舞",
      "能歌善舞",
      "néng gē shàn wǔ",
      "good at singing and dancing"
    ],
    [
      "体验",
      "體驗",
      "tǐyàn",
      "to experience for oneself; to personally experience"
    ],
    ["忧虑", "憂慮", "yōulv4", "worry; anxiety (about); concerned"],
    ["原子能", "原子能", "yuánzǐnéng", "atomic energy"],
    ["职能", "職能", "zhínéng", "function; role"],
    ["太阳能", "太陽能", "tàiyángnéng", "solar energy"],
    ["虚伪", "虛偽", "xūwěi", "false; fictitious; hypocritical"],
    [
      "千军万马",
      "千軍萬馬",
      "qiān jūn wàn mǎ",
      "(saying) a strong army with thousands of horses; a lot of people"
    ],
    [
      "弄虚作假",
      "弄虛作假",
      "nòng xū zuò jiǎ",
      "practice fraud; (saying) trick someone"
    ],
    ["顾虑", "顧慮", "gùlv4", "misgiving; apprehension; concern"],
    [
      "智能",
      "智能",
      "zhìnéng",
      "intelligent; capability; smart (phone, system, bomb, etc.)"
    ],
    ["马力", "馬力", "mǎlì", "horsepower"],
    ["验收", "驗收", "yànshōu", "inspect and then accept (i.e. received goods"],
    ["虚弱", "虛弱", "xūruò", "weak; in poor health; feeble"],
    ["本能", "本能", "běnnéng", "innate ability; instinct"],
    ["丑恶", "丑惡", "chǒu'è", "ugly; repulsive; odiousness"],
    ["配套", "配套", "pèi tào", "form a complete set"],
    [
      "外电",
      "外電",
      "wàidiàn",
      "reports from foreign (non-Chinese) news agencies"
    ],
    ["变换", "變換", "biànhuàn", "transform; alternate; convert"],
    [
      "丰满",
      "丰滿",
      "fēngmǎn",
      "plump; well developed; plentiful; Fengman district of Jilin City, Jilin Province"
    ],
    ["美满", "美滿", "měimǎn", "happy; blissful"],
    ["满怀", "滿懷", "mǎnhuái", "full of; contain; imbued with"],
    ["黄金", "黃金", "huángjīn", "gold"],
    ["变形", "變形", "biàn xíng", "become deformed; change shape"],
    ["政变", "政變", "zhèngbiàn", "coup d'état"],
    [
      "悬念",
      "懸念",
      "xuánniàn",
      "reader's involvement; suspense in a movie, place etc"
    ],
    ["附属", "附屬", "fùshǔ", "subsidiary; auxiliary; affiliate; attached"],
    ["横行", "橫行", "héngxíng", "to rampage; run amok; to riot"],
    ["演变", "演變", "yǎnbiàn", "develop; evolve"],
    ["冒牌", "冒牌", "màopái", "imposter; fake; quack (doctor)"],
    ["两手", "兩手", "liǎngshǒu", "two tactics; twin strategies"],
    ["两口子", "兩口子", "liǎngkǒuzi", "husband and wife"],
    ["悬挂", "懸掛", "xuánguà", "suspend; hang; suspension (cable car)"],
    ["那时", "那時", "nàshí", "then; at that time; in those days"],
    [
      "两极",
      "兩极",
      "liǎngjí",
      "the North and the South pole; two opposing extremes"
    ],
    [
      "满月",
      "滿月",
      "mǎn yuè",
      "complete month; a baby's first month of life; full moon"
    ],
    [
      "所属",
      "所屬",
      "suǒshǔ",
      "one's affiliation (i.e. the organization one is affiliated with); those under one's leadership; subordinate; belonging to; affiliated; under one's command"
    ],
    ["关切", "關切", "guānqiè", "be deeply concerned; troubled (by)"],
    ["鬼子", "鬼子", "guǐzi", "devil (foreign invaders)"],
    ["演唱", "演唱", "yǎnchàng", "sing (in front of an audience)"],
    ["传送", "傳送", "chuánsòng", "convey; transmit; deliver"],
    ["演习", "演習", "yǎnxí", "manoeuvre; exercise; drill; dry run"],
    ["魔鬼", "魔鬼", "móguǐ", "devil; demon; monster"],
    ["输送", "輸送", "shūsòng", "transport; carry"],
    ["演算", "演算", "yǎnsuàn", "calculate; perform calculations"],
    ["公关", "公關", "gōngguān", "public relations"],
    ["讲演", "講演", "jiǎngyǎn", "lecture to a crowd; give a speech"],
    [
      "小鬼",
      "小鬼",
      "xiǎoguǐ",
      "(idiom) an endearing term of address to a child; little demon"
    ],
    ["龙头", "龍頭", "lóngtóu", "water tap; faucet"],
    ["(informal) head of any group", "", "", ""],
    ["难关", "難關", "nánguān", "difficulty; crisis"],
    ["那个", "那個", "nàge", "that one"],
    ["电话", "電話", "diànhuà", "telephone; phone call"],
    [
      "那么",
      "那麼",
      "nàme",
      "well... ; in that case; like that; in that way; so very much"
    ],
    ["电视", "電視", "diànshì", "television; TV"],
    ["那样", "那樣", "nàyàng", "that kind; that sort"],
    ["变化", "變化", "biànhuà", "change; variation; to change; to vary"],
    ["那些", "那些", "nàxiē", "those"],
    ["电影", "電影", "diànyǐng", "movie; film"],
    ["满意", "滿意", "mǎnyì", "satisfied; pleased"],
    ["那里", "那里", "nàlǐ", "there"],
    ["改变", "改變", "gǎibiàn", "to change; alter; transform"],
    ["那儿", "那兒", "nàr5", "there; that place (Beijing accent)"],
    [
      "哪里",
      "哪里",
      "nǎlǐ",
      "where;  wherever; how could it be (humble denial of compliment)"
    ],
    ["变成", "變成", "biàn chéng", "change into; become"],
    ["哪儿", "哪兒", "nǎr5", "where; wherever (northern China)"],
    ["电灯", "電燈", "diàndēng", "electric light"],
    ["电车", "電車", "diànchē", "trolleybus; tram"],
    ["窗户", "窗戶", "chuānghu", "window"],
    [
      "满足",
      "滿足",
      "mǎnzú",
      "satisfied; contented; satisfy; meet the needs of"
    ],
    ["电报", "電報", "diànbào", "telegram; cable; telegraph"],
    ["充满", "充滿", "chōngmǎn", "filled with; brimming with; very full"],
    ["电影院", "電影院", "diànyǐngyuàn", "cinema; movie theater"],
    ["属于", "屬於", "shǔyú", "belong to; be part of"],
    ["电视台", "電視台", "diànshìtái", "TV station"],
    ["恋爱", "戀愛", "liàn'ài", "romantic love; be in love; love affair"],
    ["电台", "電台", "diàntái", "transceiver; broadcasting station"],
    ["转变", "轉變", "zhuǎnbiàn", "to change; to shift; transform"],
    ["黄瓜", "黃瓜", "huángguā", "cucumber"],
    ["电冰箱", "電冰箱", "diànbīngxiāng", "(electric) refrigerator"],
    ["哪怕", "哪怕", "nǎpà", "even if; even though; no matter how"],
    ["哪个", "哪個", "nǎge", "which (also nǎ-)"],
    ["黄油", "黃油", "huángyóu", "butter"],
    ["公用电话", "公用電話", "gōngyòng diànhuà", "public phone"],
    ["金属", "金屬", "jīnshǔ", "metal"],
    ["那边", "那邊", "nàbian5", "that side; that place; over there"],
    ["手套", "手套", "shǒutào", "glove; mitten"],
    ["哪些", "哪些", "nǎxiē", "which; who; what (plural)"],
    ["电脑", "電腦", "diànnǎo", "computer"],
    ["电子", "電子", "diànzǐ", "electronic; electron"],
    ["牌子", "牌子", "páizi", "billboard; sign; brand; trademark; plate"],
    ["不满", "不滿", "bùmǎn", "resentful; dissatisfied; not full"],
    ["家属", "家屬", "jiāshǔ", "family member; a dependent"],
    ["窗口", "窗口", "chuāngkǒu", "window; (service) counter"],
    ["电器", "電器", "diànqì", "electrical appliance; device"],
    ["电流", "電流", "diànliú", "electric current"],
    ["拐弯", "拐彎", "guǎi wān", "turn a corner; make a turn"],
    ["窗台", "窗台", "chuāngtái", "window sill"],
    ["发电", "發電", "fā diàn", "generate electricity"],
    ["掩盖", "掩蓋", "yǎngài", "cover; overspread; conceal; hide behind"],
    [
      "黄色",
      "黃色",
      "huángsè",
      "yellow (color); decadent; obscene; pornographic; dirty"
    ],
    ["赤道", "赤道", "chìdào", "the equator"],
    ["转弯", "轉彎", "zhuǎn wān", "turn a corner; turn around; make a u-turn"],
    ["黄昏", "黃昏", "huánghūn", "dusk; evening; nightfall"],
    ["圆满", "圓滿", "yuánmǎn", "satisfactory"],
    ["电池", "電池", "diànchí", "battery"],
    ["县城", "縣城", "xiànchéng", "county seat; county town"],
    ["弯曲", "彎曲", "wānqū", "to bend; curve around; winding"],
    ["掩护", "掩護", "yǎnhù", "to shield; to screen; cover; protection"],
    [
      "扭转",
      "扭轉",
      "niǔzhuǎn",
      "to reverse; to remedy (a situation); to twist"
    ],
    ["电压", "電壓", "diànyā", "voltage"],
    ["无线电", "無線電", "wúxiàndiàn", "radio; wireless"],
    ["电力", "電力", "diànlì", "electrical power; electricity"],
    ["走弯路", "走彎路", "zǒu wānlù", "take an indirect route"],
    ["电线", "電線", "diànxiàn", "(electric) wire; power cord; cable"],
    ["变革", "變革", "biàngé", "to transform; to change; transformation"],
    ["自满", "自滿", "zìmǎn", "complacent; self-satisfied"],
    ["两旁", "兩旁", "liǎngpáng", "both sides; either sides"],
    [
      "有两下子",
      "有兩下子",
      "yǒu liǎng xiàzi",
      "have real skill; know one's stuff"
    ],
    ["变动", "變動", "biàndòng", "alteration; to change"],
    ["金牌", "金牌", "jīnpái", "gold medal"],
    ["名牌", "名牌", "míngpái", "famous brand; name brand"],
    ["水电", "水電", "shuǐdiàn", "hydroelectric power"],
    [
      "留恋",
      "留戀",
      "liúliàn",
      "reluctant to leave; cannot bear to part; recall with nostalgia"
    ],
    [
      "别扭",
      "別扭",
      "bièniu",
      "awkward; unnatural; hard to deal with; uncomfortable"
    ],
    ["金黄", "金黃", "jīnhuáng", "golden yellow; golden"],
    ["县长", "縣長", "xiànzhǎng", "county mayor; county head commissioner"],
    ["变质", "變質", "biàn zhì", "go bad; deteriorate; (geology) metamorphism"],
    [
      "纵横",
      "縱橫",
      "zònghéng",
      "vertically and horizontally; in length and breadth; freely; with great ease"
    ],
    ["事变", "事變", "shìbiàn", "incident; unforeseen event; emergency"],
    ["质变", "質變", "zhìbiàn", "qualitative change; fundamental change"],
    ["变更", "變更", "biàngēng", "to change; to alter; to modify"],
    ["赤字", "赤字", "chìzì", "(financial) deficit; red ink"],
    ["电源", "電源", "diànyuán", "electric power supply; power source"],
    ["电动机", "電動機", "diàndòngjī", "electric motor"],
    ["电路", "電路", "diànlù", "circuit; electric circuit"],
    ["电气", "電气", "diànqì", "electric"],
    ["成套", "成套", "chéng tào", "be complete; whole"],
    ["马车", "馬車", "mǎchē", "carriage; cart; buggy"],
    ["马戏", "馬戲", "mǎxì", "circus"],
    [
      "只能",
      "只能",
      "zhǐnéng",
      "can only; not having any other choice; obliged to do sth."
    ],
    ["马达", "馬達", "mǎdá", "motor"],
    ["节能", "節能", "jié néng", "save energy; fuel-efficient; energy-saving"],
    ["能手", "能手", "néngshǒu", "dab hand; expert; ace; crackerjack"],
    ["验证", "驗證", "yànzhèng", "validate; verify"],
    ["空虚", "空虛", "kōngxū", "hollow; emptiness; meaningless"],
    [
      "无能为力",
      "無能為力",
      "wú néng wéi lì",
      "incapable of action; powerless; impotent"
    ],
    ["虚假", "虛假", "xūjiǎ", "false; phony; pretense; deceit"],
    ["关系", "關系", "guānxi", "relation; connection; relationship"],
    ["联系", "聯系", "liánxì", "connection; contact; get in touch"],
    [
      "关心",
      "關心",
      "guānxīn",
      "be concerned about; care for; be interested in"
    ],
    [
      "演出",
      "演出",
      "yǎnchū",
      "to act (in a play); perform; put on a show; performance"
    ],
    ["表演", "表演", "biǎoyǎn", "perform; performance"],
    ["早晨", "早晨", "zǎochen5", "(early) morning"],
    [
      "没关系",
      "沒關系",
      "méi guānxi",
      "it doesn't matter; never mind; \"that's okay\""
    ],
    ["有关", "有關", "yǒuguān", "having to do with; concerning; related to"],
    ["关于", "關於", "guānyú", "about; regarding; concerning"],
    ["演员", "演員", "yǎnyuán", "actor or actress; performer"],
    ["海关", "海關", "hǎiguān", "customs (i.e. border inspection)"],
    [
      "联合",
      "聯合",
      "liánhé",
      "unite; ally; joint; combined; alliance; union; coalition"
    ],
    ["关照", "關照", "guānzhào", "concern; look after; keep an eye on"],
    ["机关", "機關", "jīguān", "organ; mechanism; office; machine-operated"],
    ["送行", "送行", "sòngxíng", "see sb. off; give a send off"],
    ["开演", "開演", "kāiyǎn", "(of a play, movie, etc.) begin"],
    ["欢送", "歡送", "huānsòng", "to send off"],
    [
      "联欢",
      "聯歡",
      "liánhuān",
      "to have a social gathering; to have a get-together"
    ],
    ["导演", "導演", "dǎoyǎn", "to direct; director"],
    ["关怀", "關懷", "guānhuái", "show loving care for; show solicitude for"],
    ["赠送", "贈送", "zèngsòng", "give as a present"],
    ["清晨", "清晨", "qīngchén", "early morning"],
    ["关头", "關頭", "guāntóu", "juncture; moment; critical point"],
    ["播送", "播送", "bōsòng", "to broadcast; transmit"],
    ["演说", "演說", "yǎnshuō", "a speech; make a speech"],
    ["送礼", "送禮", "sòng lǐ", "give a present"],
    ["袭击", "襲擊", "xíjī", "surprise attack; to raid"],
    [
      "联想",
      "聯想",
      "liánxiǎng",
      "to associate (cognitively); to make an associative connection; mental association; word prediction and auto-complete functions of input method editing programs; abbr. for Lenovo Group (PRC computer firm)"
    ],
    [
      "对联",
      "對聯",
      "duìlián",
      "rhyming couplet; vertical written couplet usually placed along either side of a doorway"
    ],
    ["联队", "聯隊", "liánduì", "wing (of an air force)"],
    ["尼龙", "尼龍", "nílóng", "nylon"],
    ["关节炎", "關節炎", "guānjiéyán", "arthritis"],
    ["诞辰", "誕辰", "dànchén", "birthday"],
    ["运送", "運送", "yùnsòng", "transport; carry"],
    ["演讲", "演講", "yǎnjiǎng", "give a lecture; make a speech"],
    ["魔术", "魔術", "móshù", "magic"],
    ["开关", "開關", "kāiguān", "power switch; open a gate"],
    ["攻关", "攻關", "gōngguān", "lit. storm the gate; tackle a key problem"],
    ["相关", "相關", "xiāngguān", "related; pertinent; correlation"],
    ["把关", "把關", "bǎ guān", "guard a pass; check on"]
  ];
